import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, Output, ViewChild, ContentChild, Input, Directive, HostListener, NgModule, Injectable, ContentChildren, Optional, Self } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/forms';
import { FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, NgControl, ReactiveFormsModule, FormControlDirective, FormsModule } from '@angular/forms';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as i1$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i1$3 from '@angular/router';
import { RouterModule } from '@angular/router';
import { switchMap, catchError, filter, take } from 'rxjs/operators';
import { BehaviorSubject, throwError, ReplaySubject, Subject, distinctUntilChanged } from 'rxjs';
import * as i1$4 from '@angular/material/table';
import * as i3 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as i1$5 from '@angular/material/paginator';
import { __rest } from 'tslib';
import 'reflect-metadata';

/**
 * classe responsável por realizar a gestão do html gerado dinâmicamente
 * para o autocomplete
 */
class HtmlManageAutocomplete {
    constructor(root) {
        this.root = root;
        /*
         * o atributo "uniqId" é (como o próprio nome diz) o identificador unico para cadas instancia
         * do autocomlete, sendo a partir dele que toda a orientação é feita;
         *
         * Esse id não é o exato valor utilizado no elemento, mas sim um valor chave que é combionado a
         * uma string para gerar varios id's em uma mesma chave. Isso serve para identificar varios
         * elementos de uma mesma indtancias;
         *
         * veja mais no HTML ou no metodo getElementHtml()
         */
        this.uniqId = '';
        // verificador se o metodo está ou não aberto
        this.showList = false;
        this.positionY = "bottom";
        /**
         * Atributos de CSS a serem importados nos elementos HTML
         * @private
         */
        this.attrCssElements = {
            input: {
                position: 'absolute'
            },
            rootDivList: {},
            divList: {}
        };
    }
    /*
     * metodo de abertura da lista
     */
    openList() {
        if (this.showList)
            return;
        this.setHtmlParamsOpen();
        this.root.onTouched();
        this.showList = true;
    }
    /*
     * metodo de fechamento da lista
     */
    closeList() {
        const element = this.getElementHtml('input');
        element.style.position = '';
        this.attrCssElements.input['zIndex'] = '';
        this.showList = false;
    }
    /**
     * Busca elemento HTML pelo id
     * @param elementString
     */
    getElementHtml(elementString) {
        const transIdElement = {
            input: 'input-autocomplete-',
            root_div_list: 'root-div-list-autocomplete-',
            divList: 'content-div-list-autocomplete-'
        };
        const element = window.document.getElementById(transIdElement[elementString] + this.uniqId);
        if (!element)
            throw "Não foi possível encontrar o elemento '" + transIdElement[elementString] + this.uniqId + "'";
        return element;
    }
    setHtmlParamsOpen() {
        const elementInput = this.getElementHtml('input');
        const elementInputCoordinates = elementInput.getBoundingClientRect();
        this.attrCssElements.input['width'] = elementInputCoordinates.width + 'px';
        this.attrCssElements.input['zIndex'] = String(Number(this.root.zIndex) + 1);
        this.attrCssElements.divList['scrollX'] = '0';
        this.attrCssElements.divList['zIndex'] = String(Number(this.root.zIndex) + 2);
        this.positionY = this.verifyPositionY(elementInputCoordinates);
        if (this.positionY == 'top') {
            this.setParamsTop(elementInputCoordinates);
        }
        else {
            this.setParamsBottom(elementInputCoordinates);
        }
        if (this.root.widthDivList == 'justify') {
            this.attrCssElements.divList['width'] = elementInputCoordinates.width + 'px';
        }
        else if (this.root.widthDivList == 'min-justify') {
            this.attrCssElements.divList['minWidth'] = elementInputCoordinates.width + 'px';
        }
        else {
            this.attrCssElements.divList['width'] = 'auto';
        }
        if (this.root.positionX == 'start') {
            this.attrCssElements.rootDivList['margin-left'] = elementInputCoordinates.left + 'px';
            this.attrCssElements.rootDivList['maxWidth'] = window.innerWidth - elementInputCoordinates.left - 30 + 'px';
        }
        else {
            this.attrCssElements.rootDivList['maxWidth'] =
                elementInputCoordinates.left + elementInputCoordinates.width - 10 + 'px';
        }
        this.insertAttrInHtmlElement();
    }
    /**
     * Metoro de controle vertica da abertura da lista.
     * caso nenhum valor seja informado para o INPUT positionY, esse metodo irá verificar
     * se o espaço abaixo é menor que 300px, caso seja, ele irá verificar o espaço acima.
     * Caso o espaço acima seja >= 300px ele abrirá acima, do contrário abrirá abaixo.
     *
     * A div list sempre utilizará um espaço de 10px para o fim da tela, isso para melhorar a
     * experiência do usuário.
     *
     * @param elementInputCoordinates
     * @private
     */
    verifyPositionY(elementInputCoordinates) {
        if (!!this.root.positionY)
            return this.root.positionY;
        // verifica se o BOTTOM é menor que o mínimo '300px'
        if ((window.innerHeight - elementInputCoordinates.top + elementInputCoordinates.height) < 300) {
            // verifica se o TOP é menor do que o BOTTOM
            if ((window.innerHeight - elementInputCoordinates.top + (elementInputCoordinates.height / 2)) > elementInputCoordinates.top + (elementInputCoordinates.height / 2)) {
                return 'bottom';
            }
            else {
                return 'top';
            }
        }
        return "bottom";
    }
    // seta parametros de apresentação TOP
    setParamsTop(elementInputCoordinates) {
        this.attrCssElements.rootDivList['marginBottom'] = window.innerHeight - elementInputCoordinates.top + 'px';
        this.attrCssElements.rootDivList['maxHeight'] = elementInputCoordinates.top - 10 + 'px';
    }
    // seta parametros de apresentação BOTTOM
    setParamsBottom(elementInputCoordinates) {
        this.attrCssElements.rootDivList['marginTop'] = elementInputCoordinates.top + elementInputCoordinates.height + 'px';
        this.attrCssElements.rootDivList['maxHeight'] = window.innerHeight - (elementInputCoordinates.top + elementInputCoordinates.height) - 10 + 'px';
    }
    // seta atributos css nos elemebtos
    insertAttrInHtmlElement() {
        const elementInput = this.getElementHtml('input');
        const elementContent = this.getElementHtml('root_div_list');
        const elementDivList = this.getElementHtml('divList');
        // set INPUT
        Object.keys(this.attrCssElements.input).map((attr) => {
            // @ts-ignore
            elementInput.style[attr] = this.attrCssElements.input[attr];
        });
        // set CONTENT DIVLIST
        Object.keys(this.attrCssElements.rootDivList).map((attr) => {
            // @ts-ignore
            elementContent.style[attr] = this.attrCssElements.rootDivList[attr];
        });
        // set DIVLIST
        Object.keys(this.attrCssElements.divList).map((attr) => {
            // @ts-ignore
            elementDivList.style[attr] = this.attrCssElements.divList[attr];
        });
    }
}

/**
 * classe de gestão dos eventos do autocomplete
 */
class EventsManageAutocomplete {
    constructor(root) {
        this.root = root;
        /**
         * Atributo responsável por guardar uma instância de setTimeOut(), essa por sua vez é cancelada
         * sempre que uma nova é feita em tempo menor que o informado no INPUT "timeOutDelay" que por padrão
         * é 300ms
         */
        this.timeout = null;
    }
    createEventsAutocomplete() {
        addEventListener("keyup", (e) => {
            if (e.key === "Escape" && this.root.htmlManage.showList) {
                this.close();
            }
        });
        addEventListener("scroll", () => {
            if (this.root.htmlManage.showList) {
                this.close();
            }
        });
        addEventListener("resize", () => {
            if (this.root.htmlManage.showList) {
                this.close();
            }
        });
    }
    // metodo que realiza ações ao do "onfocus" no input
    // TODO trazer o openList() para cá e verificar melhor os casos de focus
    focusIn() {
        this.root.markAsTouched();
        this.root.formValue.patchValue('');
    }
    /*
     * metodo responsável por fechar o autocomplete, ele quem irá chamar todos os outros
     */
    close() {
        this.root.htmlManage.closeList();
        this.root.dataManage.setFakeValue();
        this.emiOutput('colse');
    }
    /**
     * Metodo verivica onde o click foi feito para definir se deve ou não fechar após o click.
     * sempre será fechado quando o input não for multiplo.
     * @param ev
     */
    closeClickOut(ev) {
        if (this.root.divPelicula.nativeElement.contains(ev.target) &&
            !this.root.divList.nativeElement.contains(ev.target)) {
            this.close();
        }
        return;
    }
    /**
     * verifica as alterações do input de busca e envia para o modelo de filtragem correto
     * @param val
     */
    onChangeSearch(val) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            if (Array.isArray(this.root.list)) {
                this.root.dataManage.filterList(val || '');
                return;
            }
            this.root.dataManage.getByEndpoint(val || '');
        }, this.root.timeOutDelay);
    }
    // CLICK: seleciona item
    selectOption(index) {
        if (this.root.dataManage.verifySelectedIten(index)) {
            const indexItemSelected = this.root.selectedList.findIndex(item => this.root.dataManage.getKey(item) == this.root.dataManage.getKey(this.root.visibleList[index]));
            if (indexItemSelected != -1) {
                this.unSelectOption(indexItemSelected);
            }
            return;
        }
        const singleSelection = !this.root.multiple;
        if (singleSelection) {
            this.root.selectedList = [];
        }
        this.root.selectedList.push(this.root.visibleList[index]);
        const value = this.root.selectedList.map(item => this.root.dataManage.getKey(item));
        this.root.dataManage.setValue(singleSelection ? value[0] : value);
        if (singleSelection)
            this.close();
    }
    // CLICK: desselecionar item
    unSelectOption(index) {
        if (!this.root.multiple)
            return;
        this.root.selectedList.splice(index, 1);
        const value = this.root.selectedList.map(item => this.root.dataManage.getKey(item));
        this.root.dataManage.setValue(value);
    }
    // emite eventos para o elemento pai
    emiOutput(emit, val) {
        switch (emit) {
            case 'colse':
                this.root.close.emit({ selectedList: this.root.selectedList, value: this.root.value });
                break;
            case 'change':
                this.root.inputChange.emit(val);
                break;
        }
    }
}

function uniqIdHtml(actionGetId, length = 5) {
    if (!actionGetId) {
        actionGetId = (unidId) => String(unidId);
    }
    let result = '';
    do {
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        result = '';
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
    } while (!!window.document.getElementById(actionGetId(String(result))));
    return String(result);
}

function clearString(str) {
    if (!str)
        str = '';
    str = str.replace(/a|A|á|Á|â|Â|à|À|ä|Ä|ã|Ã/g, 'a');
    str = str.replace(/e|E|é|É|ê|Ê|è|È|ë|Ë/g, 'e');
    str = str.replace(/i|I|í|Í|î|Î|ì|Ì|ï|Ï/g, 'i');
    str = str.replace(/u|U|ú|Ú|û|Û|ù|Ù|ü|Ü/g, 'u');
    str = str.replace(/o|O|ó|Ó|ô|Ô|ò|Ò|ö|Ö|õ|Õ/g, 'o');
    str = str.replace(/c|C|ç|Ç/g, 'c');
    //TODO remover toUpperCase - verificar impacto
    return str.toUpperCase();
}

/**
 * Classe responsável por todos os metodos de gestão de dados do autocomplete
 */
class DataManageAutocomplete {
    constructor(root) {
        this.root = root;
    }
    // verifica se um item foi selecionado
    verifySelectedIten(i) {
        const index = (this.root.selectedList || []).findIndex((item) => this.getKey(item) == this.getKey(this.root.visibleList[i]));
        return index !== -1;
    }
    // filtra lista do prfil
    filterList(value) {
        if (!value) {
            this.root.visibleList = this.root.list || [];
        }
        this.root.visibleList = (this.root.list || []).filter(item => {
            return clearString(this.getLabel(item)).includes(clearString(value));
        });
    }
    //TODO ajustar função de busca no back-end
    getByEndpoint(val) {
        const nome = !!val ? val : '';
        this.root.http.get(this.root.urlServer, { params: Object.assign({ nome }, (this.root.params || {})) }).subscribe((resp) => {
            this.root.visibleList = (resp === null || resp === void 0 ? void 0 : resp.data) || [];
            this.root.eventManage.emiOutput('change', val);
        });
    }
    // setar valor e informar a mudança ao form "pai" caso exista
    setValue(value) {
        this.root.value = value;
        this.root.onChange(this.root.value);
    }
    // setar iten independente da lista existir ou não
    setPreSelectedList(preList) {
        this.root.selectedList = preList;
        const value = preList === null || preList === void 0 ? void 0 : preList.filter(item => this.getKey(item));
        this.setValue(value);
        this.setFakeValue();
    }
    // setar nomes dos itens selecionados no input
    setFakeValue() {
        const fakeValue = this.root.selectedList.map(item => this.getLabel(item)).join(', ');
        this.root.formValue.patchValue(fakeValue);
    }
    /**
     * ajustar os dados da lista de acordo com insersão do writeValue
     * aqui verificamos se os itens imformados pelo pai existem na lista de seleção
     * ou na lista selecionada, fazendo o máximo para apresentar o nome e não rodar elementos
     * já completos e renderizados
     * @param oldValue
     */
    ajustSelectedlistByValue(oldValue) {
        if (Array.isArray(this.root.value)) {
            if (this.root.value.length == 0) {
                this.root.selectedList = [];
                this.setFakeValue();
            }
            if (Array.isArray(oldValue)) {
                if (oldValue.length > 0) {
                    // buscando apenas items não renderizados
                    const list = this.root.value.filter(item => {
                        const index = oldValue.findIndex(key => item == key);
                        return index == -1;
                    });
                    if (list.length > 0) {
                        list.map(key => {
                            var _a;
                            const index = (_a = this.root.list) === null || _a === void 0 ? void 0 : _a.findIndex(item => this.getKey(item) == key);
                            if (index != -1) {
                                // @ts-ignore
                                this.root.selectedList.push(this.root.list[index]);
                                this.setFakeValue();
                            }
                        });
                    }
                }
            }
        }
        if (typeof this.root.value == 'string' || typeof this.root.value == 'number') {
            this.root.value = [this.root.value];
            this.root.selectedList = [];
            if (this.root.value.length > 0) {
                this.root.value.map(key => {
                    var _a;
                    const index = (_a = this.root.list) === null || _a === void 0 ? void 0 : _a.findIndex(item => this.getKey(item) == key);
                    if (index != -1) {
                        // @ts-ignore
                        this.root.selectedList.push(this.root.list[index]);
                        this.setFakeValue();
                    }
                });
            }
        }
    }
    // buscando label
    getLabel(item) {
        if (typeof item == 'string')
            return item;
        if (typeof this.root.label == 'string') {
            if (this.root.label in item) {
                return item[this.root.label];
            }
            else {
                return '--';
            }
        }
        if (Array.isArray(this.root.label)) {
            const label = Array.isArray(this.root.label) ? this.root.label : [];
            let result = item;
            label.map((nivelArray) => {
                if (nivelArray in result) {
                    result = result[nivelArray];
                }
            });
            return result;
        }
        return '--';
    }
    // buscando key
    getKey(item) {
        if (typeof item == 'string')
            return item;
        if (typeof this.root.key == 'string') {
            if (this.root.key in item) {
                return item[this.root.key];
            }
            else {
                return '--';
            }
        }
        if (Array.isArray(this.root.key)) {
            const keys = Array.isArray(this.root.key) ? this.root.key : [];
            let result = item;
            keys.map((nivelArray) => {
                if (nivelArray in result) {
                    result = result[nivelArray];
                }
            });
            return result;
        }
        return '--';
    }
    /**
     *  OS METODOS ABAIXO RETORNAM DADOS AOS CONTENT'S PARA ESTILIZAÇÃO NO HTML
     */
    // LABEL SELECIONADOS: retorna total de itens selecionados
    getNgContentLabelSelectedList() {
        return {
            totalSelected: this.root.selectedList.length
        };
    }
    // LABEL LISTA DISPONÍVEL: retorna total de itens disponíveis
    getNgContentLabelList() {
        return {
            total: this.root.visibleList.length
        };
    }
    // ITEN SELECIONADO: retodna interface com dados necessários para estilização
    getNgContentItemSelected(option) {
        return {
            row: option,
            label: this.getLabel(option),
            key: this.getKey(option),
            selected: true
        };
    }
    // ITEM DISPONÍVEL: retodna interface com dados necessários para estilização
    getNgContentItem(option, index) {
        return {
            row: option,
            label: this.getLabel(option),
            key: this.getKey(option),
            selected: this.root.dataManage.verifySelectedIten(index)
        };
    }
}

class InputAutocompleteComponent {
    constructor(http) {
        this.http = http;
        /**======================================================
         *  METODOS DE RELAÇÃO COM NG_VALUE_ACCESSOR
         *
         *  Os metodos abaixo servem para relação entre o componente e o form (caso exista)
         =======================================================*/
        // valor de dados sincronizado com os FORMs
        this.value = '';
        // metodo repositório do "onChange()" fornecido pelo NG_VALUE_ACCESSOR
        this.onChange = (val) => {
        };
        // metodo repositório do "onTouched()" fornecido pelo NG_VALUE_ACCESSOR
        this.onTouched = () => {
        };
        this.onValidationChange = () => { };
        /**======================================================
         *  ATRIBUTOS DE GERENCIAMENTO DO FORM INTERNO DO COMPONENTE
         =======================================================*/
        // form interno do componente, serve para controlar o input
        this.formValue = new FormControl('');
        // controle de toque do component
        this.touched = false;
        // controle de disable do component
        this.disabled = false;
        // lista de itens selecionados
        this.selectedList = [];
        // lista de itens visíveis no momento
        this.visibleList = [];
        /**======================================================
         *  DISPARO DE EVENTOS AO COMPONENTE PAI
         =======================================================*/
        // TODO verificar a necessidade deste output 'outValue'
        this.outValu = new EventEmitter();
        this.inputChange = new EventEmitter();
        this.close = new EventEmitter();
        /**======================================================
         *  CLASSES DE GESTÃO DOS DADOS
         *
         *  Essas são as classes que realizam o trabalho duro.
         =======================================================*/
        // gereniamento dos comportamentos do HTML
        this.htmlManage = new HtmlManageAutocomplete(this);
        // gerenciamento dos eventos
        this.eventManage = new EventsManageAutocomplete(this);
        // gerenciamento dos dados da lista
        this.dataManage = new DataManageAutocomplete(this);
        // indicador de caminho para apresentação de label
        this.label = '';
        // indicador de caminho de busca do id
        this.key = '';
        /*---------------------------------------
           Inputs de gestão do autocomplete
         ---------------------------------------*/
        /*
         * permitir valores escritos diretamente pelo cliente
         * habilitando a alimentação direta aos FORMs como um input normal
         */
        this.acceptWrittenValue = false;
        /*
         * input que seta lista de itens antes do plot do autocomplete
         */
        this.preSelectedList = [];
        // indicador de caminho de busca do id
        this.showSelectedList = false;
        // tempo de deley de escrita para minimizar a quantidade de endpoints
        this.timeOutDelay = 300;
        // controle de posicionamento
        this.positionX = 'start';
        // ajusta o tamanho da div de apresentação da lista
        this.widthDivList = 'min-justify';
        // z-index do input
        this.zIndex = '1001';
        // classes a serem transferidas ao input
        this.classes = '';
        // placeholder do input
        this.placeholder = '';
        /*---------------------------------------
           Inputs de gestão da busca de dados pelo servidor http
         ---------------------------------------*/
        // url de busca dos cados quando forem buscados por endpoint
        this.urlServer = '';
        this.formValue.valueChanges.subscribe(val => {
            if (this.acceptWrittenValue) {
                this.dataManage.setValue(val);
            }
        });
        this.htmlManage.uniqId = uniqIdHtml(val => 'content-input-autocomplete-' + val);
        this.eventManage.createEventsAutocomplete();
    }
    // metodo de registro do "onChange()"
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    // metodo de registro do "onTouched()"
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    /*
     * metodo de acesso exclusívo do form.
     * esse metodo entrará em ação quando um valor for fornecido pelo form pai
     * e não por ações do próprio autocomplete
     *
     * @param value
     */
    writeValue(value) {
        const oldValue = this.value;
        this.value = value;
        this.dataManage.ajustSelectedlistByValue(oldValue);
    }
    // metodo para avisar ao form pai sobre o touche do autocomplete
    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }
    // ação de alteração de estado do disabled
    setDisabledState(disabled) {
        this.disabled = disabled;
        this.formValue[disabled ? 'disable' : 'enable']();
    }
    validate(c) {
        this.validationResult = { 'sync': true };
        return null;
    }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
    /**======================================================
     *  METODOS DE CICLO DE VIDA DO ANGULAR
     =======================================================*/
    ngAfterViewChecked() {
        // TODO mudar para observable
        window.dispatchEvent(new CustomEvent('dispacher-tramspile-style-dg-autocomplete', { detail: this.htmlManage.uniqId }));
    }
    // verifica mudanças de @Input()
    ngOnChanges(changes) {
        if ('list' in changes) {
            if (!!changes['list'].currentValue) {
                this.visibleList = changes['list'].currentValue;
            }
        }
        if ('preSelectedList' in changes) {
            if (!!changes['preSelectedList'].currentValue) {
                this.dataManage.setPreSelectedList(changes['preSelectedList'].currentValue);
            }
        }
    }
    /**======================================================
     *  METODOS DE FUNÇÕES UTEIS PARA GERENCIAMENTO DE DADOS
     *
     *  Os metodos abaixo serão de utilidade diversa, com o seu foco em funções uteis
     *  para manejo dinâmico do elemeto pai para com o elemento filho (input-autocomplete)
     =======================================================*/
    // metodo de limpeza de dados
    clear() {
        this.selectedList = [];
        this.dataManage.setFakeValue();
        this.dataManage.setValue(this.multiple ? [] : '');
    }
}
InputAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InputAutocompleteComponent, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
InputAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: InputAutocompleteComponent, selector: "input-autocomplete", inputs: { list: "list", label: "label", key: "key", acceptWrittenValue: "acceptWrittenValue", preSelectedList: "preSelectedList", multiple: "multiple", showSelectedList: "showSelectedList", timeOutDelay: "timeOutDelay", positionY: "positionY", positionX: "positionX", widthDivList: "widthDivList", zIndex: "zIndex", classes: "classes", placeholder: "placeholder", urlServer: "urlServer", params: "params" }, outputs: { outValu: "outValue", inputChange: "change", close: "close" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => InputAutocompleteComponent),
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: forwardRef(() => InputAutocompleteComponent)
        }
    ], queries: [{ propertyName: "headerSelectList", first: true, predicate: ["header_select_list"], descendants: true }, { propertyName: "headerSelectedList", first: true, predicate: ["header_selected_list"], descendants: true }, { propertyName: "rowOption", first: true, predicate: ["row_option"], descendants: true }, { propertyName: "rowOptionSelected", first: true, predicate: ["row_option_selected"], descendants: true }, { propertyName: "inputButtonEnd", first: true, predicate: ["button_end"], descendants: true }], viewQueries: [{ propertyName: "divList", first: true, predicate: ["divList"], descendants: true }, { propertyName: "divPelicula", first: true, predicate: ["divPelicula"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"autocomplete-component\" [class.input-group]=\"!!inputButtonEnd\">\r\n<!-- input visivel para o usu\u00E1rio, serve como um filtro para o valor real -->\r\n  <input\r\n    [formControl]=\"formValue\"\r\n    id=\"input-autocomplete-{{htmlManage.uniqId}}\"\r\n    (focus)=\"eventManage.focusIn()\"\r\n    (click)=\"htmlManage.openList()\"\r\n    class=\"{{classes}}\"\r\n    (ngModelChange)=\"eventManage.onChangeSearch($event)\"\r\n    type=\"text\"\r\n    autocomplete=\"off\"\r\n    placeholder=\"{{placeholder}}\"\r\n  >\r\n  <span *ngIf=\"!!inputButtonEnd\" class=\"input-group-text\">\r\n    <ng-container\r\n      [ngTemplateOutlet]=\"inputButtonEnd\"\r\n    >\r\n  </ng-container>\r\n  </span>\r\n\r\n\r\n  <div style=\"position: relative\" *ngIf=\"htmlManage.showList\">\r\n    <input tabindex=\"-1\" class=\"{{classes}}\">\r\n  </div>\r\n\r\n  <div\r\n    class=\"cdk-dg-autocomplete-pelicula\"\r\n    [class.show]=\"htmlManage.showList\"\r\n    [style.z-index]=\"zIndex\"\r\n    (click)=\"eventManage.closeClickOut($event)\"\r\n  >\r\n    <div\r\n      #divPelicula\r\n      class=\"cdk-dg-autocomplete-pelicula-content\"\r\n      [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.positionY == 'bottom'\"\r\n      [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.positionY == 'top'\"\r\n    >\r\n      <div\r\n        class=\"cdk-dg-root-div-list-autocomplete\"\r\n        id=\"root-div-list-autocomplete-{{htmlManage.uniqId}}\"\r\n        [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.positionY == 'bottom'\"\r\n        [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.positionY == 'top'\"\r\n        [class.cdk-dg-autocomplete-position-x-start]=\"positionX == 'start'\"\r\n        [class.cdk-dg-autocomplete-position-x-end]=\"positionX == 'end'\"\r\n        [class.cdk-dg-cutocomplete-ajuste-width-auto]=\"widthDivList == 'auto' || widthDivList == 'min-justify'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-justify]=\"widthDivList == 'justify'\"\r\n      >\r\n        <div\r\n          #divList\r\n          id=\"content-div-list-autocomplete-{{htmlManage.uniqId}}\"\r\n          class=\"cdk-dg-content-list-autocomplete theme-dg-content-list-autocomplete\"\r\n        >\r\n          <div class=\"cdk-body-list-autocomplete theme-dg-body-list-autocomplete\">\r\n\r\n            <!-- LISTA DE ITEM SELECIONADOS -->\r\n            <ul\r\n              *ngIf=\"!!multiple && showSelectedList\"\r\n              class=\"theme-ul-items-selected-autocomplete\"\r\n            >\r\n              <li *ngIf=\"!headerSelectedList\" class=\"disabled\">Selecionados</li>\r\n\r\n              <!-- CONTENT DE HEADER DA LISTA DE ITENS SELECIONADOS -->\r\n              <ng-container\r\n                *ngIf=\"headerSelectedList\"\r\n                [ngTemplateOutlet]=\"headerSelectedList\"\r\n                [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentLabelSelectedList()}\"\r\n              >\r\n              </ng-container>\r\n\r\n              <li\r\n                *ngFor=\"let option of selectedList; let i = index\"\r\n                (click)=\"eventManage.unSelectOption(i)\"\r\n                [value]=\"option.value\"\r\n                [class.default-row-list-autocomplete]=\"!rowOption && !rowOptionSelected\"\r\n              >\r\n\r\n                <!-- CONTENT DE LISTA SELECIONADA (priorit\u00E1ria absoluta) -->\r\n                <ng-container\r\n                  *ngIf=\"rowOptionSelected\"\r\n                  [ngTemplateOutlet]=\"rowOptionSelected\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItemSelected(option)}\"\r\n                >\r\n                </ng-container>\r\n\r\n                <!-- CONTENT DA LISTA\r\n                    nesse caso quando houver um template para os itens a selecionar e n\u00E3o houver uma de itens selecionados\r\n                    essa template valer\u00E1 para todas (selecionadas e a selecionar)\r\n                 -->\r\n                <ng-container\r\n                  *ngIf=\"rowOption && !rowOptionSelected\"\r\n                  [ngTemplateOutlet]=\"rowOption\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItemSelected(option)}\"\r\n                >\r\n                </ng-container>\r\n                <span *ngIf=\"!rowOption\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                  {{dataManage.getLabel(option)}}\r\n              </span>\r\n              </li>\r\n            </ul>\r\n\r\n            <ul\r\n              class=\"theme-ul-items-autocomplete\"\r\n            >\r\n              <li *ngIf=\"!headerSelectList\" class=\"disabled\">selecione</li>\r\n              <ng-container\r\n                *ngIf=\"headerSelectList\"\r\n                [ngTemplateOutlet]=\"headerSelectList\"\r\n                [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentLabelList()}\"\r\n              >\r\n              </ng-container>\r\n              <li\r\n                *ngFor=\"let option of visibleList; let i = index\"\r\n                (click)=\"eventManage.selectOption(i)\"\r\n                [value]=\"option.value\"\r\n                [class.default-row-list-autocomplete]=\"!rowOption && !rowOptionSelected\"\r\n              >\r\n                <ng-container\r\n                  *ngIf=\"rowOption\"\r\n                  [ngTemplateOutlet]=\"rowOption\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItem(option, i)}\"\r\n                >\r\n                </ng-container>\r\n                <span *ngIf=\"!rowOption\">\r\n                  <input type=\"checkbox\" *ngIf=\"!!multiple\" [checked]=\"dataManage.verifySelectedIten(i)\">\r\n                  {{dataManage.getLabel(option)}}\r\n                </span>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".autocomplete-component input.inputAutocomplete-component.ng-invalid{border-color:red!important}\n"], directives: [{ type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InputAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'input-autocomplete', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: forwardRef(() => InputAutocompleteComponent),
                        },
                        {
                            provide: NG_VALIDATORS,
                            multi: true,
                            useExisting: forwardRef(() => InputAutocompleteComponent)
                        }
                    ], template: "<div class=\"autocomplete-component\" [class.input-group]=\"!!inputButtonEnd\">\r\n<!-- input visivel para o usu\u00E1rio, serve como um filtro para o valor real -->\r\n  <input\r\n    [formControl]=\"formValue\"\r\n    id=\"input-autocomplete-{{htmlManage.uniqId}}\"\r\n    (focus)=\"eventManage.focusIn()\"\r\n    (click)=\"htmlManage.openList()\"\r\n    class=\"{{classes}}\"\r\n    (ngModelChange)=\"eventManage.onChangeSearch($event)\"\r\n    type=\"text\"\r\n    autocomplete=\"off\"\r\n    placeholder=\"{{placeholder}}\"\r\n  >\r\n  <span *ngIf=\"!!inputButtonEnd\" class=\"input-group-text\">\r\n    <ng-container\r\n      [ngTemplateOutlet]=\"inputButtonEnd\"\r\n    >\r\n  </ng-container>\r\n  </span>\r\n\r\n\r\n  <div style=\"position: relative\" *ngIf=\"htmlManage.showList\">\r\n    <input tabindex=\"-1\" class=\"{{classes}}\">\r\n  </div>\r\n\r\n  <div\r\n    class=\"cdk-dg-autocomplete-pelicula\"\r\n    [class.show]=\"htmlManage.showList\"\r\n    [style.z-index]=\"zIndex\"\r\n    (click)=\"eventManage.closeClickOut($event)\"\r\n  >\r\n    <div\r\n      #divPelicula\r\n      class=\"cdk-dg-autocomplete-pelicula-content\"\r\n      [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.positionY == 'bottom'\"\r\n      [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.positionY == 'top'\"\r\n    >\r\n      <div\r\n        class=\"cdk-dg-root-div-list-autocomplete\"\r\n        id=\"root-div-list-autocomplete-{{htmlManage.uniqId}}\"\r\n        [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.positionY == 'bottom'\"\r\n        [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.positionY == 'top'\"\r\n        [class.cdk-dg-autocomplete-position-x-start]=\"positionX == 'start'\"\r\n        [class.cdk-dg-autocomplete-position-x-end]=\"positionX == 'end'\"\r\n        [class.cdk-dg-cutocomplete-ajuste-width-auto]=\"widthDivList == 'auto' || widthDivList == 'min-justify'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-justify]=\"widthDivList == 'justify'\"\r\n      >\r\n        <div\r\n          #divList\r\n          id=\"content-div-list-autocomplete-{{htmlManage.uniqId}}\"\r\n          class=\"cdk-dg-content-list-autocomplete theme-dg-content-list-autocomplete\"\r\n        >\r\n          <div class=\"cdk-body-list-autocomplete theme-dg-body-list-autocomplete\">\r\n\r\n            <!-- LISTA DE ITEM SELECIONADOS -->\r\n            <ul\r\n              *ngIf=\"!!multiple && showSelectedList\"\r\n              class=\"theme-ul-items-selected-autocomplete\"\r\n            >\r\n              <li *ngIf=\"!headerSelectedList\" class=\"disabled\">Selecionados</li>\r\n\r\n              <!-- CONTENT DE HEADER DA LISTA DE ITENS SELECIONADOS -->\r\n              <ng-container\r\n                *ngIf=\"headerSelectedList\"\r\n                [ngTemplateOutlet]=\"headerSelectedList\"\r\n                [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentLabelSelectedList()}\"\r\n              >\r\n              </ng-container>\r\n\r\n              <li\r\n                *ngFor=\"let option of selectedList; let i = index\"\r\n                (click)=\"eventManage.unSelectOption(i)\"\r\n                [value]=\"option.value\"\r\n                [class.default-row-list-autocomplete]=\"!rowOption && !rowOptionSelected\"\r\n              >\r\n\r\n                <!-- CONTENT DE LISTA SELECIONADA (priorit\u00E1ria absoluta) -->\r\n                <ng-container\r\n                  *ngIf=\"rowOptionSelected\"\r\n                  [ngTemplateOutlet]=\"rowOptionSelected\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItemSelected(option)}\"\r\n                >\r\n                </ng-container>\r\n\r\n                <!-- CONTENT DA LISTA\r\n                    nesse caso quando houver um template para os itens a selecionar e n\u00E3o houver uma de itens selecionados\r\n                    essa template valer\u00E1 para todas (selecionadas e a selecionar)\r\n                 -->\r\n                <ng-container\r\n                  *ngIf=\"rowOption && !rowOptionSelected\"\r\n                  [ngTemplateOutlet]=\"rowOption\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItemSelected(option)}\"\r\n                >\r\n                </ng-container>\r\n                <span *ngIf=\"!rowOption\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                  {{dataManage.getLabel(option)}}\r\n              </span>\r\n              </li>\r\n            </ul>\r\n\r\n            <ul\r\n              class=\"theme-ul-items-autocomplete\"\r\n            >\r\n              <li *ngIf=\"!headerSelectList\" class=\"disabled\">selecione</li>\r\n              <ng-container\r\n                *ngIf=\"headerSelectList\"\r\n                [ngTemplateOutlet]=\"headerSelectList\"\r\n                [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentLabelList()}\"\r\n              >\r\n              </ng-container>\r\n              <li\r\n                *ngFor=\"let option of visibleList; let i = index\"\r\n                (click)=\"eventManage.selectOption(i)\"\r\n                [value]=\"option.value\"\r\n                [class.default-row-list-autocomplete]=\"!rowOption && !rowOptionSelected\"\r\n              >\r\n                <ng-container\r\n                  *ngIf=\"rowOption\"\r\n                  [ngTemplateOutlet]=\"rowOption\"\r\n                  [ngTemplateOutletContext]=\"{$implicit:dataManage.getNgContentItem(option, i)}\"\r\n                >\r\n                </ng-container>\r\n                <span *ngIf=\"!rowOption\">\r\n                  <input type=\"checkbox\" *ngIf=\"!!multiple\" [checked]=\"dataManage.verifySelectedIten(i)\">\r\n                  {{dataManage.getLabel(option)}}\r\n                </span>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".autocomplete-component input.inputAutocomplete-component.ng-invalid{border-color:red!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; }, propDecorators: { outValu: [{
                type: Output,
                args: ['outValue']
            }], inputChange: [{
                type: Output,
                args: ['change']
            }], close: [{
                type: Output,
                args: ['close']
            }], divList: [{
                type: ViewChild,
                args: ['divList']
            }], divPelicula: [{
                type: ViewChild,
                args: ['divPelicula']
            }], headerSelectList: [{
                type: ContentChild,
                args: ['header_select_list', { static: false }]
            }], headerSelectedList: [{
                type: ContentChild,
                args: ['header_selected_list', { static: false }]
            }], rowOption: [{
                type: ContentChild,
                args: ['row_option', { static: false }]
            }], rowOptionSelected: [{
                type: ContentChild,
                args: ['row_option_selected', { static: false }]
            }], inputButtonEnd: [{
                type: ContentChild,
                args: ['button_end', { static: false }]
            }], list: [{
                type: Input
            }], label: [{
                type: Input
            }], key: [{
                type: Input
            }], acceptWrittenValue: [{
                type: Input,
                args: ['acceptWrittenValue']
            }], preSelectedList: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showSelectedList: [{
                type: Input
            }], timeOutDelay: [{
                type: Input
            }], positionY: [{
                type: Input
            }], positionX: [{
                type: Input
            }], widthDivList: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], classes: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], urlServer: [{
                type: Input
            }], params: [{
                type: Input
            }] } });

class CdkContentListAutocompleteDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    tramspileStyleAttrByElement(value) {
        var _a, _b;
        if (((_a = this.reference) === null || _a === void 0 ? void 0 : _a.htmlManage.uniqId) != (value === null || value === void 0 ? void 0 : value.detail))
            return;
        const element = (_b = this.reference) === null || _b === void 0 ? void 0 : _b.htmlManage.getElementHtml('divList');
        if (!element)
            return;
        this.getStyleList().map((item) => {
            if (typeof element.style == 'object') {
                // @ts-ignore
                element.style[item.attr] = item.value;
            }
        });
        const listStyle = [...(this.elementRef.nativeElement.classList || [])];
        listStyle.map((item) => {
            element.classList.add(item);
        });
    }
    getStyleList() {
        const list = this.elementRef.nativeElement.style;
        const result = [];
        Object.keys(list).map((item) => {
            if (isNaN(Number(item))) {
                if (list[item]) {
                    result.push({ attr: item, value: list[item] });
                }
            }
        });
        return result;
    }
}
CdkContentListAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkContentListAutocompleteDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
CdkContentListAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: CdkContentListAutocompleteDirective, selector: "[cdk-dg-autocomplete-content-list]", inputs: { reference: "reference" }, host: { listeners: { "window:dispacher-tramspile-style-dg-autocomplete": "tramspileStyleAttrByElement($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkContentListAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cdk-dg-autocomplete-content-list]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { reference: [{
                type: Input
            }], tramspileStyleAttrByElement: [{
                type: HostListener,
                args: ['window:dispacher-tramspile-style-dg-autocomplete', ['$event']]
            }] } });

class DgAutocompleteDirective {
    constructor(elementRef, host, _injector) {
        this.elementRef = elementRef;
        this.host = host;
        this._injector = _injector;
        this.formControl = this._injector.get(NgControl);
    }
    ngOnInit() {
        // console.log(this.formControl.control?.errors)
        // console.log(this.formControl.control)
        // console.log('ngOnInit', this._injector.get(NG_VALIDATORS))
    }
    execut() {
        // // const classList = [...this.elementRef.nativeElement.classList];
        //
        // // if (!!this.formControl.control?.errors) {
        // //   if (this.formControl.control?.errors['required']) {
        // //     this.host.formValue.addValidators([Validators.required]);
        // //     this.host.formValue.updateValueAndValidity()
        // //   }
        // // }
        //
        // // this.host.onValidationChange()
        //
        // // if (this.formControl.touched) {
        // //   this.host.onTouched();
        // //   // console.log('invalid', this.formControl.invalid)
        // //   if (this.formControl.invalid) {
        // //     // this.host.invalid = true;
        // //     this.host.setInvalid(true);
        // //   }
        // // }
        // // this.host.formValue.setErrors(this.formControl.errors)
        //
        // // this.host.classController = 'test' //classList.join(' ')
        //
        // // this.host.setClassController(classList.join(' '))
        //
        // // console.log('a', this.host.classController)
        // // console.log('classList', classList)
        // const classList = [...this.elementRef.nativeElement.classList];
        //
        // // if (
        // //   classList.findIndex((classe: string) => classe == 'ng-invalid') != -1 &&
        // //   classList.findIndex((classe: string) => classe == 'ng-touched') != -1
        // // ) {
        // //   this.host.verifyInvalidClass(true)
        // // } else {
        // //   this.host.verifyInvalidClass(false)
        // // }
    }
}
DgAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteDirective, deps: [{ token: i0.ElementRef }, { token: InputAutocompleteComponent }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive });
DgAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgAutocompleteDirective, selector: "input-autocomplete-aaa[formControlName]", host: { listeners: { "window:dispacher-tramspile-style-dg-autocomplete": "execut($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input-autocomplete-aaa[formControlName]'
                    // providers: [{
                    //   provide: NG_ASYNC_VALIDATORS,
                    //   useExisting: forwardRef(() => DgAutocompleteDirective),
                    //   multi: true
                    // }]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: InputAutocompleteComponent }, { type: i0.Injector }]; }, propDecorators: { execut: [{
                type: HostListener,
                args: ['window:dispacher-tramspile-style-dg-autocomplete', ['$event']]
            }] } });

class DgAutocompleteModule {
}
DgAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteModule, declarations: [InputAutocompleteComponent,
        CdkContentListAutocompleteDirective,
        DgAutocompleteDirective], imports: [CommonModule,
        ReactiveFormsModule], exports: [InputAutocompleteComponent,
        CdkContentListAutocompleteDirective,
        DgAutocompleteDirective] });
DgAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteModule, imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        InputAutocompleteComponent,
                        CdkContentListAutocompleteDirective,
                        DgAutocompleteDirective
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule
                    ],
                    exports: [
                        InputAutocompleteComponent,
                        CdkContentListAutocompleteDirective,
                        DgAutocompleteDirective
                    ]
                }]
        }] });

class DgSidebarMenuComponent {
    constructor() {
        this.listMenuAdm = [
            { url: '/admin', nome: 'Admin', icon: 'settings', subMenu: [
                    { url: '/admin', nome: 'config', icon: 'admin_panel_settings' }
                ] }
        ];
        this._open = true;
        this.showBackground = true;
        this.closeClickBackground = true;
        this.halfCollapse = 'md';
        this.collapse = 'sm';
        if (!!window.localStorage.getItem('dg-sidebar-state')) {
            DgSidebarMenuComponent.open = Boolean(Number(window.localStorage.getItem('dg-sidebar-state')));
            this._open = DgSidebarMenuComponent.open;
        }
    }
    ngOnInit() { }
    changeState() {
        if (window.innerWidth > 991) {
            window.localStorage.setItem('dg-sidebar-state', !DgSidebarMenuComponent.open ? '1' : '0');
        }
        DgSidebarMenuComponent.open = !DgSidebarMenuComponent.open;
        this._open = DgSidebarMenuComponent.open;
    }
    bgChangeState() {
        if (this.closeClickBackground) {
            this.changeState();
        }
    }
}
DgSidebarMenuComponent.open = true;
DgSidebarMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DgSidebarMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgSidebarMenuComponent, selector: "dg-sidebar-menu", ngImport: i0, template: "\r\n<!--\r\n    USADO PAERA DEMARCAR POSI\u00C7\u00D5ES NA TELA\r\n-->\r\n<div\r\n  id=\"user-sidebar-menu\"\r\n  [class.sidebar-menu-open]=\"_open\"\r\n  [class.sidebar-menu-close]=\"!_open\"\r\n  class=\"sidebar-half-collapse-{{halfCollapse}} sidebar-collapse-{{collapse}} user-sidebar-menu\"\r\n>\r\n\r\n  <div\r\n    id=\"background-sidebar-menu\"\r\n    class=\"background-sidebar-menu\"\r\n    [class.show-background-sidebar-collaps]=\"showBackground\"\r\n    (click)=\"bgChangeState()\"\r\n  ></div>\r\n\r\n\r\n  <!--\r\n      BASE DO SIDEBAR-MENU.\r\n      CONTENDO IMAGEM BG\r\n    -->\r\n  <div\r\n    id=\"sidebar-wrapper\"\r\n    [class.sidebar-menu-open]=\"_open\"\r\n    [class.sidebar-menu-close]=\"!_open\"\r\n    class=\"sidebar-half-collapse-{{halfCollapse}} sidebar-collapse-{{halfCollapse}} sidebar-wrapper\"\r\n  >\r\n    <!--\r\n        PELICURA DE COR SOBRE SIDEBAR\r\n     -->\r\n    <div id=\"sidebar-pelicula\">\r\n\r\n      <div id=\"sidebar-root\" class=\"sidebar-root\">\r\n\r\n        <ng-content></ng-content>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-sidebar-menu', template: "\r\n<!--\r\n    USADO PAERA DEMARCAR POSI\u00C7\u00D5ES NA TELA\r\n-->\r\n<div\r\n  id=\"user-sidebar-menu\"\r\n  [class.sidebar-menu-open]=\"_open\"\r\n  [class.sidebar-menu-close]=\"!_open\"\r\n  class=\"sidebar-half-collapse-{{halfCollapse}} sidebar-collapse-{{collapse}} user-sidebar-menu\"\r\n>\r\n\r\n  <div\r\n    id=\"background-sidebar-menu\"\r\n    class=\"background-sidebar-menu\"\r\n    [class.show-background-sidebar-collaps]=\"showBackground\"\r\n    (click)=\"bgChangeState()\"\r\n  ></div>\r\n\r\n\r\n  <!--\r\n      BASE DO SIDEBAR-MENU.\r\n      CONTENDO IMAGEM BG\r\n    -->\r\n  <div\r\n    id=\"sidebar-wrapper\"\r\n    [class.sidebar-menu-open]=\"_open\"\r\n    [class.sidebar-menu-close]=\"!_open\"\r\n    class=\"sidebar-half-collapse-{{halfCollapse}} sidebar-collapse-{{halfCollapse}} sidebar-wrapper\"\r\n  >\r\n    <!--\r\n        PELICURA DE COR SOBRE SIDEBAR\r\n     -->\r\n    <div id=\"sidebar-pelicula\">\r\n\r\n      <div id=\"sidebar-root\" class=\"sidebar-root\">\r\n\r\n        <ng-content></ng-content>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; } });

class DgSidebarMenuNavigationItemComponent {
    constructor() {
        this.listNavigation = [];
        this.open = true;
        this.isSubmenu = false;
        this.startHr = false;
        this.endHr = false;
        this.prefixLiClass = '';
        this.changedropdown = new EventEmitter();
        this.IconDropdown = false;
        this.getOpen = () => {
            return this.open;
        };
    }
    ngOnInit() {
    }
    click() {
        this.open = !this.open;
        this.changedropdown.emit(this.open);
    }
    activeItemMenu(menu, dropdown = false) {
        if (menu.url) {
            if (window.location.pathname === menu.url) {
                return true;
            }
            else if (dropdown) {
                return this.activeSubmenuUrl(menu);
            }
        }
        return false;
    }
    activeSubmenuUrl(menu) {
        if (menu.url) {
            if (window.location.pathname === menu.url) {
                return true;
            }
            else {
                const currentUrl = window.location.pathname.split('/');
                let comparaUrl = [];
                menu.url.split('/').map((path, index) => {
                    comparaUrl.push(currentUrl[index]);
                });
                return comparaUrl.join('/') === menu.url;
            }
        }
        return false;
    }
    redirectExternalLink(url = '', event) {
        if (!!event) {
            window.dispatchEvent(new CustomEvent(event));
        }
        else if (url.startsWith('http') || url.startsWith('www')) {
            window.open(url, '_blank');
        }
    }
    clearExternalLinkUrl(url = '', event) {
        if (!!event) {
            return undefined;
        }
        else if (url.startsWith('http') || url.startsWith('www')) {
            return undefined;
        }
        return url;
    }
    convertUrlToClass(url) {
        if (!url)
            return '';
        return url.replace(/\//g, '_');
    }
}
DgSidebarMenuNavigationItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuNavigationItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DgSidebarMenuNavigationItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgSidebarMenuNavigationItemComponent, selector: "dg-sidebar-menu-navigation-item", inputs: { listNavigation: "listNavigation", open: "open", isSubmenu: "isSubmenu", startHr: "startHr", endHr: "endHr", prefixLiClass: "prefixLiClass" }, outputs: { changedropdown: "changedropdown" }, ngImport: i0, template: "<hr *ngIf=\"startHr\" style=\"margin: 0 .1rem\">\r\n<ul\r\n  id=\"{{(!!prefixLiClass ? prefixLiClass + '_' : '')}}navigation-sidebar-component\"\r\n  class=\"nav flex-column sidebar-navigation\"\r\n  [class.subMenu]=\"isSubmenu\"\r\n  [class.open]=\"open\"\r\n  style=\"{{open ? 'height: auto' : 'height: 0'}}\"\r\n>\r\n  <li\r\n    id=\"{{(!!prefixLiClass ? prefixLiClass + '_' : '') + convertUrlToClass(menuAdm.url) + (!!menuAdm.subMenu ? '-subMenu' : '')}}\"\r\n    *ngFor=\"let menuAdm of listNavigation; let i = index\"\r\n    class=\"nav-item\"\r\n    [tabindex]=\"i\"\r\n  >\r\n    <a\r\n      class=\"nav-link\"\r\n      *ngIf=\"!menuAdm.subMenu; else templateSubMenu\"\r\n      [class.checked]=\"activeItemMenu(menuAdm)\"\r\n      [routerLink]=\"clearExternalLinkUrl(menuAdm.url, menuAdm.event)\"\r\n      (click)=\"redirectExternalLink(menuAdm.url, menuAdm.event)\"\r\n    >\r\n      <mat-icon>{{ menuAdm.icon }}</mat-icon>\r\n      <span>{{ menuAdm.nome }}</span>\r\n    </a>\r\n\r\n    <ng-template #templateSubMenu>\r\n\r\n      <a\r\n        class=\"nav-link\"\r\n        (click)=\"navigationComponent.click()\"\r\n        [class.checked]=\"activeItemMenu(menuAdm, true)\"\r\n      >\r\n\r\n        <mat-icon class=\"icon-nav-item\">{{ menuAdm.icon }}</mat-icon>\r\n        <span>{{ menuAdm.nome }}</span>\r\n\r\n        <mat-icon class=\"icon-drowdown\" [class.open-dropdown]=\"IconDropdown\">chevron_left</mat-icon>\r\n\r\n      </a>\r\n\r\n      <dg-sidebar-menu-navigation-item\r\n        #navigationComponent\r\n        [isSubmenu]=\"true\"\r\n        [listNavigation]=\"menuAdm.subMenu\"\r\n        [open]=\"(activeSubmenuUrl(menuAdm) ? true : false)\"\r\n        (changedropdown)=\"IconDropdown = $event\"\r\n      >\r\n      </dg-sidebar-menu-navigation-item>\r\n    </ng-template>\r\n\r\n  </li>\r\n</ul>\r\n<hr *ngIf=\"endHr\" style=\"margin: 0 .1rem\">\r\n", styles: [""], components: [{ type: i1$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { type: DgSidebarMenuNavigationItemComponent, selector: "dg-sidebar-menu-navigation-item", inputs: ["listNavigation", "open", "isSubmenu", "startHr", "endHr", "prefixLiClass"], outputs: ["changedropdown"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuNavigationItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-sidebar-menu-navigation-item', template: "<hr *ngIf=\"startHr\" style=\"margin: 0 .1rem\">\r\n<ul\r\n  id=\"{{(!!prefixLiClass ? prefixLiClass + '_' : '')}}navigation-sidebar-component\"\r\n  class=\"nav flex-column sidebar-navigation\"\r\n  [class.subMenu]=\"isSubmenu\"\r\n  [class.open]=\"open\"\r\n  style=\"{{open ? 'height: auto' : 'height: 0'}}\"\r\n>\r\n  <li\r\n    id=\"{{(!!prefixLiClass ? prefixLiClass + '_' : '') + convertUrlToClass(menuAdm.url) + (!!menuAdm.subMenu ? '-subMenu' : '')}}\"\r\n    *ngFor=\"let menuAdm of listNavigation; let i = index\"\r\n    class=\"nav-item\"\r\n    [tabindex]=\"i\"\r\n  >\r\n    <a\r\n      class=\"nav-link\"\r\n      *ngIf=\"!menuAdm.subMenu; else templateSubMenu\"\r\n      [class.checked]=\"activeItemMenu(menuAdm)\"\r\n      [routerLink]=\"clearExternalLinkUrl(menuAdm.url, menuAdm.event)\"\r\n      (click)=\"redirectExternalLink(menuAdm.url, menuAdm.event)\"\r\n    >\r\n      <mat-icon>{{ menuAdm.icon }}</mat-icon>\r\n      <span>{{ menuAdm.nome }}</span>\r\n    </a>\r\n\r\n    <ng-template #templateSubMenu>\r\n\r\n      <a\r\n        class=\"nav-link\"\r\n        (click)=\"navigationComponent.click()\"\r\n        [class.checked]=\"activeItemMenu(menuAdm, true)\"\r\n      >\r\n\r\n        <mat-icon class=\"icon-nav-item\">{{ menuAdm.icon }}</mat-icon>\r\n        <span>{{ menuAdm.nome }}</span>\r\n\r\n        <mat-icon class=\"icon-drowdown\" [class.open-dropdown]=\"IconDropdown\">chevron_left</mat-icon>\r\n\r\n      </a>\r\n\r\n      <dg-sidebar-menu-navigation-item\r\n        #navigationComponent\r\n        [isSubmenu]=\"true\"\r\n        [listNavigation]=\"menuAdm.subMenu\"\r\n        [open]=\"(activeSubmenuUrl(menuAdm) ? true : false)\"\r\n        (changedropdown)=\"IconDropdown = $event\"\r\n      >\r\n      </dg-sidebar-menu-navigation-item>\r\n    </ng-template>\r\n\r\n  </li>\r\n</ul>\r\n<hr *ngIf=\"endHr\" style=\"margin: 0 .1rem\">\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { listNavigation: [{
                type: Input,
                args: ['listNavigation']
            }], open: [{
                type: Input,
                args: ['open']
            }], isSubmenu: [{
                type: Input,
                args: ['isSubmenu']
            }], startHr: [{
                type: Input,
                args: ['startHr']
            }], endHr: [{
                type: Input,
                args: ['endHr']
            }], prefixLiClass: [{
                type: Input,
                args: ['prefixLiClass']
            }], changedropdown: [{
                type: Output
            }] } });

class DgSidebarMenuLogoComponent {
    constructor() {
        this.img = '';
    }
    ngOnInit() {
    }
}
DgSidebarMenuLogoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DgSidebarMenuLogoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgSidebarMenuLogoComponent, selector: "dg-sidebar-menu-logo", inputs: { img: "img" }, ngImport: i0, template: "<div class=\"sidebar-logo\">\r\n  <img [src]=\"img\">\r\n</div>\r\n", styles: ["::ng-deep .user-sidebar-menu .sidebar-logo{padding:1rem 0;display:inline-flex;justify-content:center;width:100%}::ng-deep .user-sidebar-menu img{max-width:100%!important}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-sidebar-menu-logo', template: "<div class=\"sidebar-logo\">\r\n  <img [src]=\"img\">\r\n</div>\r\n", styles: ["::ng-deep .user-sidebar-menu .sidebar-logo{padding:1rem 0;display:inline-flex;justify-content:center;width:100%}::ng-deep .user-sidebar-menu img{max-width:100%!important}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { img: [{
                type: Input
            }] } });

class DgSidebarMenuModule {
}
DgSidebarMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgSidebarMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuModule, declarations: [DgSidebarMenuComponent,
        DgSidebarMenuNavigationItemComponent,
        DgSidebarMenuLogoComponent], imports: [CommonModule,
        RouterModule,
        MatIconModule], exports: [DgSidebarMenuComponent,
        DgSidebarMenuNavigationItemComponent,
        DgSidebarMenuLogoComponent] });
DgSidebarMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuModule, imports: [[
            CommonModule,
            RouterModule,
            MatIconModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgSidebarMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgSidebarMenuComponent,
                        DgSidebarMenuNavigationItemComponent,
                        DgSidebarMenuLogoComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        MatIconModule
                    ],
                    exports: [
                        DgSidebarMenuComponent,
                        DgSidebarMenuNavigationItemComponent,
                        DgSidebarMenuLogoComponent
                    ]
                }]
        }] });

class DgModalComponent {
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.config = {
            open: false,
            animate: false,
            htmlHeader: false,
            htmlFooter: false,
            zIndex: 800,
            bloqueiaClose: false
        };
        this.classes = '';
        //BUTTONS
        this.textCloseButton = 'Fechar';
        this.showCloseButton = true;
        this.disableCloseButton = false;
        this.actionCloseButton = 'close';
        this.textConfirmButton = 'Salvar';
        this.showConfirmButton = true;
        this.disableConfirmButton = false;
        this.buttonCloseX = 'X';
        // TITULOS E HEADER
        this.title = "titulo padrão";
        // CONFIGS APRESENTAÇÃO
        this.size = 'lg';
        this.alignV = 'center';
        this.alignH = 'center';
        // CONFIGS
        this.bgClose = false;
        this.escClose = true;
        // EMIÇÕES DE RETORNO
        this.afterClose = new EventEmitter();
        this.clickConfirm = new EventEmitter();
        this.closeConfirm = new EventEmitter();
    }
    // EVENTOS
    onKeydownHandler() {
        if (this.escClose) {
            this.close();
        }
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.config.htmlHeader = this.htmlHeader.nativeElement && this.htmlHeader.nativeElement.children.length > 0;
        this.config.htmlFooter = this.htmlFooter.nativeElement && this.htmlFooter.nativeElement.children.length > 0;
        this.cdRef.detectChanges();
    }
    // METODOS PRINCIPAIS
    open(config) {
        if (this.config.open)
            return;
        if (!!config)
            this.registerConfig(config);
        this.config.zIndex = DgModalComponent._addOpen();
        this.config.open = true;
    }
    close(props) {
        let ignoreBeforeClose = false;
        if (props) {
            if ((props === null || props === void 0 ? void 0 : props.ignoreBeforeClose) != undefined) {
                ignoreBeforeClose = props.ignoreBeforeClose;
            }
        }
        if (!ignoreBeforeClose && (this === null || this === void 0 ? void 0 : this.beforeClose)) {
            if (!this.beforeClose()) {
                return;
            }
        }
        DgModalComponent._addClose();
        this.config.open = false;
        this.afterClose.emit();
    }
    closeAll() {
        DgModalComponent._closeAll();
    }
    registerConfig(config) {
        Object.keys(config).map((attr) => {
            if (!attr)
                return;
            //@ts-ignore
            if (!config[attr])
                return;
            if (attr in this) {
                //@ts-ignore
                this[attr] = config[attr];
            }
        });
    }
    _closeAllEvent() {
        this.close();
    }
    // METODOS ESTATICOS
    static _closeAll() {
        window.dispatchEvent(new CustomEvent('event-dg-modal-close-all'));
    }
    static _addOpen() {
        DgModalComponent.listaModalAtivo = DgModalComponent.listaModalAtivo + 1;
        return DgModalComponent.listaModalAtivo;
    }
    static _addClose() {
        DgModalComponent.listaModalAtivo = DgModalComponent.listaModalAtivo - 1;
        return DgModalComponent.listaModalAtivo;
    }
    // METODOS DE CLICK E SUPORTE AO HTML
    bgClick(event) {
        if (!this.carModal.nativeElement.contains(event.target) && this.bgClose) {
            this.close();
        }
    }
    clickBtnClose() {
        if (this.actionCloseButton == 'close') {
            this.close();
        }
        else {
            this.closeConfirm.emit();
        }
    }
}
DgModalComponent.listaModalAtivo = 800;
DgModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
DgModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgModalComponent, selector: "dg-modal", inputs: { classes: "classes", textCloseButton: "textCloseButton", showCloseButton: "showCloseButton", disableCloseButton: "disableCloseButton", actionCloseButton: "actionCloseButton", textConfirmButton: "textConfirmButton", showConfirmButton: "showConfirmButton", disableConfirmButton: "disableConfirmButton", buttonCloseX: "buttonCloseX", title: "title", subTitle: "subTitle", size: "size", alignV: "alignV", alignH: "alignH", bgClose: "bgClose", escClose: "escClose", beforeClose: "beforeClose" }, outputs: { afterClose: "afterClose", clickConfirm: "clickConfirm", closeConfirm: "closeConfirm" }, host: { listeners: { "document:keydown.esc": "onKeydownHandler($event)", "window:event-dg-modal-close-all": "_closeAllEvent()" } }, viewQueries: [{ propertyName: "htmlHeader", first: true, predicate: ["htmlHeader"], descendants: true }, { propertyName: "htmlFooter", first: true, predicate: ["htmlFooter"], descendants: true }, { propertyName: "carModal", first: true, predicate: ["carModal"], descendants: true }], ngImport: i0, template: "<!-- DG-MODAL - Componente de modal para o sistema -->\r\n<div\r\n  class=\"sdk-absolute-content-insert-elements dg-modal {{classes}}\"\r\n  [class.open]=\"config.open\"\r\n  [class.close]=\"!config.open\"\r\n  [ngStyle]=\"{'z-index': config.zIndex }\"\r\n>\r\n\r\n  <!-- Modal root -->\r\n  <div (click)=\"bgClick($event)\" class=\"cdk-dg-root-modal theme-root-modal\">\r\n\r\n    <!-- modal content -->\r\n    <div\r\n      #carModal\r\n      class=\"cdk-dg-modal-content theme-dg-modal-content cdk-dg-modal-size-{{size}} alignV-{{alignV}} alignH-{{alignH}}\"\r\n    >\r\n\r\n      <!-- modal header -->\r\n      <div class=\"cdk-dg-content-header-modal theme-dg-content-header-modal\">\r\n        <!-- HEADER CONTENIER FORNECIDO PELO PAI -->\r\n        <div #htmlHeader [hidden]=\"!config.htmlHeader\" class=\"cdk-dg-header-modal theme-dg-header-modal\">\r\n          <ng-content select=[modal-header]></ng-content>\r\n        </div>\r\n        <!-- HEADER ALIMENTADO POR INPUT -->\r\n        <div [hidden]=\"config.htmlHeader\" class=\"cdk-dg-header-modal theme-dg-header-modal\">\r\n          <h2 class=\"theme-dg-title-modal\">{{title}}</h2>\r\n          <span *ngIf=\"!!subTitle\" class=\"theme-dg-subtitle-modal\">{{subTitle}}</span>\r\n        </div>\r\n        <!-- BOT\u00C3O DE FECHAMENTO -->\r\n        <div (click)=\"close()\" class=\"cdk-dg-content-close-button-modal theme-dg-content-close-button-modal\">\r\n          <span class=\"theme-dg-close-button-modal\" [innerHtml]=\"buttonCloseX\"></span>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- modal body -->\r\n      <div class=\"cdk-dg-modal-body theme-dg-body-modal\">\r\n        <ng-content select=[modal-body]></ng-content>\r\n      </div>\r\n\r\n      <!-- modal footer -->\r\n      <div class=\"cdk-dg-modal-footer theme-dg-footer-modal\">\r\n        <div class=\"theme-dg-modal-footer-row-buttom\" [hidden]=\"config.htmlFooter\">\r\n          <button\r\n            *ngIf=\"showCloseButton\"\r\n            (click)=\"clickBtnClose()\"\r\n            [disabled]=\"disableCloseButton\"\r\n            class=\"theme-dg-modal-close-button\"\r\n            style=\"min-width: 10%;\"\r\n          >\r\n            {{textCloseButton}}\r\n          </button>\r\n          <button\r\n            *ngIf=\"showCloseButton\"\r\n            (click)=\"clickConfirm.emit()\"\r\n            [disabled]=\"disableConfirmButton\"\r\n            class=\"theme-dg-modal-confirm-button\"\r\n            style=\"min-width: 10%;\"\r\n          >\r\n            {{textConfirmButton}}\r\n          </button>\r\n        </div>\r\n        <!-- html footer -->\r\n        <div\r\n          #htmlFooter\r\n          [hidden]=\"!config.htmlFooter\"\r\n          style=\"width: 100%; justify-content: center; display: inline-flex;\"\r\n        >\r\n          <ng-content select=[modal-footer]></ng-content>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], directives: [{ type: i2.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-modal', template: "<!-- DG-MODAL - Componente de modal para o sistema -->\r\n<div\r\n  class=\"sdk-absolute-content-insert-elements dg-modal {{classes}}\"\r\n  [class.open]=\"config.open\"\r\n  [class.close]=\"!config.open\"\r\n  [ngStyle]=\"{'z-index': config.zIndex }\"\r\n>\r\n\r\n  <!-- Modal root -->\r\n  <div (click)=\"bgClick($event)\" class=\"cdk-dg-root-modal theme-root-modal\">\r\n\r\n    <!-- modal content -->\r\n    <div\r\n      #carModal\r\n      class=\"cdk-dg-modal-content theme-dg-modal-content cdk-dg-modal-size-{{size}} alignV-{{alignV}} alignH-{{alignH}}\"\r\n    >\r\n\r\n      <!-- modal header -->\r\n      <div class=\"cdk-dg-content-header-modal theme-dg-content-header-modal\">\r\n        <!-- HEADER CONTENIER FORNECIDO PELO PAI -->\r\n        <div #htmlHeader [hidden]=\"!config.htmlHeader\" class=\"cdk-dg-header-modal theme-dg-header-modal\">\r\n          <ng-content select=[modal-header]></ng-content>\r\n        </div>\r\n        <!-- HEADER ALIMENTADO POR INPUT -->\r\n        <div [hidden]=\"config.htmlHeader\" class=\"cdk-dg-header-modal theme-dg-header-modal\">\r\n          <h2 class=\"theme-dg-title-modal\">{{title}}</h2>\r\n          <span *ngIf=\"!!subTitle\" class=\"theme-dg-subtitle-modal\">{{subTitle}}</span>\r\n        </div>\r\n        <!-- BOT\u00C3O DE FECHAMENTO -->\r\n        <div (click)=\"close()\" class=\"cdk-dg-content-close-button-modal theme-dg-content-close-button-modal\">\r\n          <span class=\"theme-dg-close-button-modal\" [innerHtml]=\"buttonCloseX\"></span>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- modal body -->\r\n      <div class=\"cdk-dg-modal-body theme-dg-body-modal\">\r\n        <ng-content select=[modal-body]></ng-content>\r\n      </div>\r\n\r\n      <!-- modal footer -->\r\n      <div class=\"cdk-dg-modal-footer theme-dg-footer-modal\">\r\n        <div class=\"theme-dg-modal-footer-row-buttom\" [hidden]=\"config.htmlFooter\">\r\n          <button\r\n            *ngIf=\"showCloseButton\"\r\n            (click)=\"clickBtnClose()\"\r\n            [disabled]=\"disableCloseButton\"\r\n            class=\"theme-dg-modal-close-button\"\r\n            style=\"min-width: 10%;\"\r\n          >\r\n            {{textCloseButton}}\r\n          </button>\r\n          <button\r\n            *ngIf=\"showCloseButton\"\r\n            (click)=\"clickConfirm.emit()\"\r\n            [disabled]=\"disableConfirmButton\"\r\n            class=\"theme-dg-modal-confirm-button\"\r\n            style=\"min-width: 10%;\"\r\n          >\r\n            {{textConfirmButton}}\r\n          </button>\r\n        </div>\r\n        <!-- html footer -->\r\n        <div\r\n          #htmlFooter\r\n          [hidden]=\"!config.htmlFooter\"\r\n          style=\"width: 100%; justify-content: center; display: inline-flex;\"\r\n        >\r\n          <ng-content select=[modal-footer]></ng-content>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { classes: [{
                type: Input
            }], textCloseButton: [{
                type: Input
            }], showCloseButton: [{
                type: Input
            }], disableCloseButton: [{
                type: Input
            }], actionCloseButton: [{
                type: Input
            }], textConfirmButton: [{
                type: Input
            }], showConfirmButton: [{
                type: Input
            }], disableConfirmButton: [{
                type: Input
            }], buttonCloseX: [{
                type: Input
            }], title: [{
                type: Input,
                args: ['title']
            }], subTitle: [{
                type: Input,
                args: ['subTitle']
            }], size: [{
                type: Input,
                args: ['size']
            }], alignV: [{
                type: Input,
                args: ['alignV']
            }], alignH: [{
                type: Input,
                args: ['alignH']
            }], bgClose: [{
                type: Input,
                args: ['bgClose']
            }], escClose: [{
                type: Input,
                args: ['escClose']
            }], beforeClose: [{
                type: Input,
                args: ['beforeClose']
            }], afterClose: [{
                type: Output
            }], clickConfirm: [{
                type: Output
            }], closeConfirm: [{
                type: Output
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown.esc', ['$event']]
            }], htmlHeader: [{
                type: ViewChild,
                args: ['htmlHeader']
            }], htmlFooter: [{
                type: ViewChild,
                args: ['htmlFooter']
            }], carModal: [{
                type: ViewChild,
                args: ['carModal']
            }], _closeAllEvent: [{
                type: HostListener,
                args: ['window:event-dg-modal-close-all']
            }] } });

class DgModalModule {
}
DgModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalModule, declarations: [DgModalComponent], imports: [CommonModule], exports: [DgModalComponent] });
DgModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgModalComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        DgModalComponent
                    ]
                }]
        }] });

class AbstractTokenService {
    constructor(_http = HttpClient) {
        this._http = _http;
        // contexto da url de refresh
        this.name_headerToken_refresh = 'Authorization';
        // nome to token no localStoragy
        this.name_localStoragy_token = 'accessToken';
        // nome to token de refresh no localStoragy
        this.name_localStoragy_refreshToken = 'refreshToken';
        // adicionar 'Bearer' como prefixo do token
        this.addBearer = true;
        // Bearer
        this.bearer = 'Bearer ';
        // atributo de verificação de expiração do tokem
        this.expAttributeToken = 'exp';
        this.http_refreshToken = true;
    }
    issetToken() {
        const token = window.localStorage.getItem(this.name_localStoragy_token);
        return !!token && token != 'null' && token != 'undefined';
    }
    getToken() {
        return window.localStorage.getItem(this.name_localStoragy_token) || '';
    }
    abrirToken(token) {
        if (!token) {
            token = String(window.localStorage.getItem(this.name_localStoragy_token));
        }
        if (!token || token == "null") {
            return {};
        }
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    }
    checkExp(token, expAttributeToken) {
        if (!token) {
            token = this.abrirToken();
        }
        if (!((expAttributeToken || this.expAttributeToken) in token)) {
            return false;
        }
        const resultExp = token[this.expAttributeToken] * 1000;
        return resultExp > new Date().getTime();
    }
    getRefreshToken() {
        return window.localStorage.getItem(this.name_localStoragy_refreshToken) || '';
    }
    refreshToken() {
        return this._http.post(this.path_refreshToken, {
            refreshToken: String(window.localStorage.getItem(this.name_localStoragy_refreshToken))
        }, {
            headers: {
                [this.name_headerToken_refresh]: (this.addBearer ? this.bearer : '') + this.getRefreshToken()
            }
        });
    }
    saveToken(token, refreshToken) {
        window.localStorage.removeItem(this.name_localStoragy_token);
        window.localStorage.setItem(this.name_localStoragy_token, token);
        if (!!refreshToken) {
            window.localStorage.removeItem(this.name_localStoragy_refreshToken);
            window.localStorage.setItem(this.name_localStoragy_refreshToken, refreshToken);
        }
    }
    clearToken() {
        window.localStorage.setItem(this.name_localStoragy_token, '-');
        window.localStorage.setItem(this.name_localStoragy_refreshToken, '-');
        window.localStorage.removeItem(this.name_localStoragy_token);
        window.localStorage.removeItem(this.name_localStoragy_refreshToken);
    }
}

class abstractUserSessionEntity {
}
class AbstractSessionService {
    constructor(Token) {
        this.Token = Token;
        this.pathRedirectLogout = window.location.origin;
        this.perfilAttributeToken = 'perfil';
    }
    logout() {
        this.Token.clearToken();
        window.localStorage.clear();
        window.location.href = this.pathRedirectLogout;
    }
    checkPerfil(perfil, perfilAttributeToken) {
        if (!!perfilAttributeToken) {
            if (!(perfilAttributeToken in this.user))
                return false;
        }
        else {
            if (!(this.perfilAttributeToken in this.user))
                return false;
        }
        if (typeof perfil === 'string') {
            // @ts-ignore
            return this.user[perfilAttributeToken] === perfil;
        }
        else if (Array.isArray(perfil)) {
            // @ts-ignore
            return perfil.findIndex(perfil => perfil === this.user[perfilAttributeToken]) !== -1;
        }
        return false;
    }
    //TODO criar metodos de 'crud' de attr dinamicos
    /**
     * @deprecated
     * Metodo ainda não finalizado
     * @param name
     * @param localStorageName
     */
    issetAttr(name, localStorageName) {
        if (name in this) {
            // @ts-ignore
            return !!this[name];
        }
        const item = JSON.parse(String(window.localStorage.getItem((localStorageName || name))));
        return !!item;
    }
    /**
     * @deprecated
     * Metodo ainda não finalizado
     * @param name
     * @param localStorageName
     */
    getAttr(name, localStorageName) {
        if (this.issetAttr(name)) {
            if (name in this) {
                // @ts-ignore
                if (!!this[name])
                    return this[name];
            }
            // @ts-ignore
            this[name] = JSON.parse(String(window.localStorage.getItem((localStorageName || name))));
            // @ts-ignore
            return this[name];
        }
        return false;
    }
    /**
     * @deprecated
     * Metodo ainda não finalizado
     * @param data
     * @param name
     * @param localStorageName
     */
    setAttr(data, name, localStorageName) {
        // @ts-ignore
        this[name] = data;
        window.localStorage.setItem((localStorageName || name), JSON.stringify(data));
    }
    /**
     * @deprecated
     * Metodo ainda não implementado
     * @param name
     * @param localStorageName
     */
    removeAttr(name, localStorageName) { }
}
AbstractSessionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractSessionService, deps: [{ token: AbstractTokenService }], target: i0.ɵɵFactoryTarget.Injectable });
AbstractSessionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractSessionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractSessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: AbstractTokenService }]; }, propDecorators: { logout: [{
                type: HostListener,
                args: ['window:sistem-logout', ['$event']]
            }] } });

class AbstractAddToken {
    constructor(_token) {
        this._token = _token;
        // lista de ROTAS aos quais o token não deve ser inserido
        this.listRouterExcepAddToken = [];
        // lista de endereços de ENDPOINTS aos quais o token não deve ser inserido
        this.listUrlExcepAddToken = [];
        // controlador de estado, verifica se a renovação está em andamento
        this.isRefreshing = false;
        // Observable contendo valor da renovação
        this.refreshTokenSubject = new BehaviorSubject(null);
        // nome do header na requisição
        this.name_headerToken = 'Authorization';
        // adicionar 'Bearer' como prefixo do token
        this.addBearer = true;
        // Bearer
        this.bearer = 'Bearer ';
    }
    /**
     * Metodo para adicionar token após a renovação
     * @param request
     * @param token
     * @param name
     */
    static addTokenHeader(request, token, name) {
        return request.clone({ headers: request.headers.set(name, token) });
    }
    /**
     * verifica se a URL atual faz parte da lista de URL que não deve ser inserido o token
     */
    exceptRouter() {
        const currentUrl = window.location.pathname.split('/');
        return this.listRouterExcepAddToken.findIndex(context => context == currentUrl.join('/')) != -1;
    }
    /**
     * verifica se a URL atual faz parte da lista de URL que não deve ser inserido o token
     */
    exceptUrl(endpoint) {
        return this.listUrlExcepAddToken.findIndex(context => context == endpoint) != -1;
    }
    /**
     * Metodo de refresh token
     * @param request
     * @param next
     * @private
     */
    handle401Error(request, next) {
        if (!this.isRefreshing) {
            // iniciando processo de renovação de token
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            // buscando token atual
            const token = this._token.getToken();
            // renovar token somente caso o mesmo existe
            if (token)
                return this._token.refreshToken().pipe(switchMap((resp) => {
                    this.isRefreshing = false;
                    const token = this.pipeRequestRefreshToken(resp);
                    this._token.saveToken(token);
                    this.refreshTokenSubject.next(token);
                    return next.handle(AbstractAddToken.addTokenHeader(request, (this.addBearer ? this.bearer : '') + token, this.name_headerToken));
                }), catchError((err) => {
                    this.isRefreshing = false;
                    window.dispatchEvent(new CustomEvent('sistem-logout'));
                    return throwError(err);
                }));
        }
        // após renovação do token, é retornado o requeste para uma nova tentativa
        return this.refreshTokenSubject.pipe(filter(token => token !== null), take(1), switchMap((token) => next.handle(AbstractAddToken.addTokenHeader(request, (this.addBearer ? this.bearer : '') + token, this.name_headerToken))));
    }
    rootIntercept(request, next) {
        let authReq = request;
        const token = this._token.getToken();
        const urlPesquisaAnonima = window.location.pathname.split('/');
        urlPesquisaAnonima.pop();
        if (this.exceptRouter() || this.exceptUrl(request.url)) {
            return next.handle(request);
        }
        if (!request.headers.get(this.name_headerToken)) {
            request = request.clone({
                setHeaders: { [this.name_headerToken]: (this.addBearer ? this.bearer : '') + token }
            });
        }
        // request = request.clone({
        //   setHeaders: {[this.name_headerToken]: (this.addBearer ? this.bearer : '') + token}
        // });
        // @ts-ignore
        return next.handle(request).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse && (error.status === 401 || error.status === 403)) {
                if (!this._token.checkExp()) {
                    return this.handle401Error(authReq, next);
                }
            }
            return throwError(error);
        }));
        // return next.handle(request);
    }
}

class DgTableMaterialDataDirective {
    constructor(host) {
        this.host = host;
    }
    ngOnInit() {
        this.dynamicTable.observables.dataSource.subscribe((data) => {
            this.host.dataSource = data.data;
        });
    }
}
DgTableMaterialDataDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableMaterialDataDirective, deps: [{ token: i1$4.MatTable }], target: i0.ɵɵFactoryTarget.Directive });
DgTableMaterialDataDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTableMaterialDataDirective, selector: "[mat-table][dg-table-matrial-data]", inputs: { dynamicTable: ["tableClass", "dynamicTable"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableMaterialDataDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[mat-table][dg-table-matrial-data]'
                }]
        }], ctorParameters: function () { return [{ type: i1$4.MatTable }]; }, propDecorators: { dynamicTable: [{
                type: Input,
                args: ['tableClass']
            }] } });

class DgTableColumnTemplateDirective {
    constructor(template) {
        this.template = template;
        this.columnName = '';
    }
}
DgTableColumnTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableColumnTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DgTableColumnTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTableColumnTemplateDirective, selector: "ng-template[dgTableColumn]", inputs: { columnName: "columnName" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableColumnTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[dgTableColumn]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { columnName: [{
                type: Input,
                args: ['columnName']
            }] } });

class DgTableHeaderTemplateDirective {
    constructor(template) {
        this.template = template;
        this.headerName = '';
    }
}
DgTableHeaderTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableHeaderTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DgTableHeaderTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTableHeaderTemplateDirective, selector: "ng-template[dgTableHeader]", inputs: { headerName: "headerName" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableHeaderTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[dgTableHeader]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { headerName: [{
                type: Input,
                args: ['headerName']
            }] } });

class DgTableActionsTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
DgTableActionsTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableActionsTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
DgTableActionsTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTableActionsTemplateDirective, selector: "ng-template[dgTableActions]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableActionsTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[dgTableActions]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });

var CdkDgTable;
(function (CdkDgTable) {
    function mask(mask, value) {
        value = String(value).replace(/\D/g, "");
        switch (mask) {
            case 'telefone':
                return value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
            case 'celular':
                return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
            case 'cpf':
                return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            case 'cnpj':
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            case 'cep':
                return value.replace(/(\d{5})(\d{3})/, "$1-$2");
            case 'rg':
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3-$4");
            case 'conta':
                return value.replace(/(\d{2})(\d{3})(\d{1})/, "$1.$2-$3");
            case 'egencia':
                return value.replace(/(\d{4})(\d{1})/, "$1-$2");
            case 'cnh':
                return value.replace(/(\d{9})(\d{2})/, "$1-$2");
        }
    }
    CdkDgTable.mask = mask;
    function executDbClick(router, activateRoute, row, action, ev) {
        if (typeof (action === null || action === void 0 ? void 0 : action.action) == 'string') {
            if (!!(action === null || action === void 0 ? void 0 : action.externalLink)) {
                window.open(action.action, '_blank');
                return;
            }
            router.navigate([action.action], { relativeTo: activateRoute }).then();
            return;
        }
        action === null || action === void 0 ? void 0 : action.action(row, ev);
    }
    CdkDgTable.executDbClick = executDbClick;
})(CdkDgTable || (CdkDgTable = {}));

class ConfigDgTable {
    static get() {
        return ConfigDgTable.configs;
    }
    static set(props) {
        // if ('undefinedCell' in props) ConfigDgTable.configs.undefinedCell = props.undefinedCell;
        if (props === null || props === void 0 ? void 0 : props.typeDisabled)
            ConfigDgTable.configs.typeDisabled = props.typeDisabled;
        if (props === null || props === void 0 ? void 0 : props.typeShowActions)
            ConfigDgTable.configs.typeShowActions = props.typeShowActions;
        if (typeof (props === null || props === void 0 ? void 0 : props.undefinedCell) == 'string')
            ConfigDgTable.configs.undefinedCell = props.undefinedCell;
        if (typeof (props === null || props === void 0 ? void 0 : props.headerNameActions) == 'string')
            ConfigDgTable.configs.headerNameActions = props.headerNameActions;
    }
}
ConfigDgTable.configs = {
    undefinedCell: '--',
    typeDisabled: 'display-none',
    typeShowActions: 'dropdown-button',
    headerNameActions: 'Ações',
    showActions: true,
    classes: ''
};

class DefaultTableLoadersComponent {
    constructor() {
        this.typeLoader = 'clock';
    }
    ngOnInit() {
    }
}
DefaultTableLoadersComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DefaultTableLoadersComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DefaultTableLoadersComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DefaultTableLoadersComponent, selector: "default-table-loaders", inputs: { typeLoader: "typeLoader" }, ngImport: i0, template: "<div class=\"default-table-loader loader-clock\" *ngIf=\"typeLoader == 'clock'\">\r\n  <svg class=\"svg-loader\" version=\"1.1\" id=\"L2\" xmlns=\"http://www.w3.org/2000/svg\"\r\n       xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n       viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\r\n          <circle class=\"circle\" fill=\"none\" stroke-width=\"4\" stroke-miterlimit=\"10\" cx=\"50\" cy=\"50\" r=\"48\"/>\r\n    <line class=\"hour-hand\" fill=\"none\" stroke-linecap=\"round\" stroke=\"red\" stroke-width=\"4\" stroke-miterlimit=\"10\"\r\n          x1=\"50\" y1=\"50\" x2=\"85\" y2=\"50.5\">\r\n            <animateTransform\r\n              attributeName=\"transform\"\r\n              dur=\"2s\"\r\n              type=\"rotate\"\r\n              from=\"0 50 50\"\r\n              to=\"360 50 50\"\r\n              repeatCount=\"indefinite\"/>\r\n          </line>\r\n    <line class=\"minute-hand\" fill=\"none\" stroke-linecap=\"round\" stroke-width=\"4\" stroke-miterlimit=\"10\" x1=\"50\" y1=\"50\"\r\n          x2=\"49.5\" y2=\"74\">\r\n            <animateTransform\r\n              attributeName=\"transform\"\r\n              dur=\"15s\"\r\n              type=\"rotate\"\r\n              from=\"0 50 50\"\r\n              to=\"360 50 50\"\r\n              repeatCount=\"indefinite\"/>\r\n          </line>\r\n        </svg>\r\n</div>\r\n\r\n<div class=\"default-table-loader loader-pointer\" *ngIf=\"typeLoader == 'pointer'\">\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\">\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"40\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"-.4\"></animate>\r\n    </circle>\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"100\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"-.2\"></animate>\r\n    </circle>\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"160\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"0\"></animate>\r\n    </circle>\r\n  </svg>\r\n</div>\r\n\r\n<div class=\"default-table-loader loader-circle\" *ngIf=\"typeLoader == 'circle'\">\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\">\r\n    <circle transform-origin=\"center\" fill=\"none\" stroke-linecap=\"round\"\r\n            stroke-dasharray=\"200 1000\" stroke-dashoffset=\"0\" cx=\"100\" cy=\"100\" r=\"70\">\r\n      <animateTransform type=\"rotate\" attributeName=\"transform\" calcMode=\"spline\" dur=\"2\" values=\"360;0\" keyTimes=\"0;1\"\r\n                        keySplines=\"0 0 1 1\" repeatCount=\"indefinite\"></animateTransform>\r\n    </circle>\r\n    <circle transform-origin=\"center\" fill=\"none\" opacity=\".2\" stroke-linecap=\"round\"\r\n            cx=\"100\" cy=\"100\" r=\"70\"></circle>\r\n  </svg>\r\n</div>\r\n", styles: [""], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DefaultTableLoadersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'default-table-loaders', template: "<div class=\"default-table-loader loader-clock\" *ngIf=\"typeLoader == 'clock'\">\r\n  <svg class=\"svg-loader\" version=\"1.1\" id=\"L2\" xmlns=\"http://www.w3.org/2000/svg\"\r\n       xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n       viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\">\r\n          <circle class=\"circle\" fill=\"none\" stroke-width=\"4\" stroke-miterlimit=\"10\" cx=\"50\" cy=\"50\" r=\"48\"/>\r\n    <line class=\"hour-hand\" fill=\"none\" stroke-linecap=\"round\" stroke=\"red\" stroke-width=\"4\" stroke-miterlimit=\"10\"\r\n          x1=\"50\" y1=\"50\" x2=\"85\" y2=\"50.5\">\r\n            <animateTransform\r\n              attributeName=\"transform\"\r\n              dur=\"2s\"\r\n              type=\"rotate\"\r\n              from=\"0 50 50\"\r\n              to=\"360 50 50\"\r\n              repeatCount=\"indefinite\"/>\r\n          </line>\r\n    <line class=\"minute-hand\" fill=\"none\" stroke-linecap=\"round\" stroke-width=\"4\" stroke-miterlimit=\"10\" x1=\"50\" y1=\"50\"\r\n          x2=\"49.5\" y2=\"74\">\r\n            <animateTransform\r\n              attributeName=\"transform\"\r\n              dur=\"15s\"\r\n              type=\"rotate\"\r\n              from=\"0 50 50\"\r\n              to=\"360 50 50\"\r\n              repeatCount=\"indefinite\"/>\r\n          </line>\r\n        </svg>\r\n</div>\r\n\r\n<div class=\"default-table-loader loader-pointer\" *ngIf=\"typeLoader == 'pointer'\">\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\">\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"40\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"-.4\"></animate>\r\n    </circle>\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"100\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"-.2\"></animate>\r\n    </circle>\r\n    <circle stroke-width=\"15\" r=\"15\" cx=\"160\" cy=\"65\">\r\n      <animate attributeName=\"cy\" calcMode=\"spline\" dur=\"2\" values=\"65;135;65;\" keySplines=\".5 0 .5 1;.5 0 .5 1\"\r\n               repeatCount=\"indefinite\" begin=\"0\"></animate>\r\n    </circle>\r\n  </svg>\r\n</div>\r\n\r\n<div class=\"default-table-loader loader-circle\" *ngIf=\"typeLoader == 'circle'\">\r\n  <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\">\r\n    <circle transform-origin=\"center\" fill=\"none\" stroke-linecap=\"round\"\r\n            stroke-dasharray=\"200 1000\" stroke-dashoffset=\"0\" cx=\"100\" cy=\"100\" r=\"70\">\r\n      <animateTransform type=\"rotate\" attributeName=\"transform\" calcMode=\"spline\" dur=\"2\" values=\"360;0\" keyTimes=\"0;1\"\r\n                        keySplines=\"0 0 1 1\" repeatCount=\"indefinite\"></animateTransform>\r\n    </circle>\r\n    <circle transform-origin=\"center\" fill=\"none\" opacity=\".2\" stroke-linecap=\"round\"\r\n            cx=\"100\" cy=\"100\" r=\"70\"></circle>\r\n  </svg>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { typeLoader: [{
                type: Input
            }] } });

class DefaultTdActionsDgTableComponent {
    constructor(router, activatedRoute) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.actionList = {};
        this.row = [];
        this.dropDownClasses = 'btn btn-secondary';
        this.typeActions = 'inline-action';
        this.open = false;
        this.uniqId = uniqIdHtml(val => 'dropdown-action-id' + val);
        this.resolvePositionDropdown = () => {
            const dropdownButton = document.getElementById(this.uniqId + '-button');
            const dropdownContainer = document.getElementById(this.uniqId + '-div');
            if (!dropdownContainer || !dropdownButton)
                return;
            // Obter a posição do botão
            const buttonRect = dropdownButton.getBoundingClientRect();
            // const containerRect = dropdownContainer.getBoundingClientRect();
            let positionY = this.verifyPositionY(buttonRect);
            const contaierStyles = {
                height: '',
                transform: '',
                width: `${buttonRect.right + buttonRect.width}px`,
            };
            if (positionY == 'top') {
                console.log('entrei no top');
                // dropdownContainer.classList.remove('positionY-bottom');
                // dropdownContainer.classList.add('positionY-top');
                contaierStyles.height = `${buttonRect.top}px`;
            }
            else {
                console.log('entrei no bottom');
                // dropdownContainer.classList.remove('positionY-top')
                // dropdownContainer.classList.add('positionY-bottom')
                // contaierStyles.transform = `translateY(${buttonRect.top + buttonRect.height}px)`;
                // contaierStyles.transform = `translateY(${buttonRect.top}px)`;
                dropdownContainer.style.top = `${buttonRect.bottom}px`;
                contaierStyles.height = `${window.innerHeight - buttonRect.bottom}px`;
            }
            console.log('buttonRect', buttonRect);
            console.log('contaierStyles', contaierStyles);
            // Ajustar posição do dropdown
            dropdownContainer.style.height = contaierStyles.height;
            dropdownContainer.style.width = contaierStyles.width;
            // dropdownContainer.style.transform = contaierStyles.transform;
            console.log('containerRect', dropdownContainer.getBoundingClientRect());
        };
        this.closeDropdown = () => {
            this.togleDropdown();
        };
    }
    ngOnInit() {
        // const dropdownButton = document.getElementById('dropdownButton');
        // const dropdownContainer = document.getElementById('dropdownContainer');
        //
        // // Alternar a visibilidade do dropdown
        // dropdownButton?.addEventListener('click', () => {
        //   if (dropdownContainer!.style.display === 'block') {
        //     dropdownContainer!.style.display = 'none';
        //   } else {
        //     dropdownContainer!.style.display = 'block';
        //
        //     // Atualiza a posição do dropdown com base no botão
        //     const buttonRect = dropdownButton.getBoundingClientRect();
        //     dropdownContainer!.style.top = `${buttonRect.bottom}px`;
        //     dropdownContainer!.style.left = `${buttonRect.left}px`;
        //   }
        // });
        //
        // // Fechar dropdown ao clicar fora dele
        // document.addEventListener('click', (event: any) => {
        //   if (!dropdownButton!.contains(event.target) && !dropdownContainer!.contains(event.target)) {
        //     dropdownContainer!.style.display = 'none';
        //   }
        // });
    }
    togleDropdown() {
        if (this.open) {
            // Remover event listeners ao fechar
            document.removeEventListener('wheel', this.resolvePositionDropdown);
            window.removeEventListener('resize', this.resolvePositionDropdown);
            window.removeEventListener('click', this.closeDropdown);
            this.open = false;
        }
        else {
            document.addEventListener('wheel', this.resolvePositionDropdown, false);
            window.addEventListener('resize', this.resolvePositionDropdown);
            this.open = true;
            this.resolvePositionDropdown();
            setTimeout(() => {
                window.addEventListener('click', this.closeDropdown);
            }, 100);
        }
    }
    verifyDisabled(action) {
        if ('permission' in action) {
            if (typeof action.permission == 'boolean')
                return action.permission;
            if (action === null || action === void 0 ? void 0 : action.permission)
                return action.permission(this.row);
        }
        return true;
    }
    clickItem(ev, action) {
        try {
            if (!this.verifyDisabled(action))
                return;
            CdkDgTable.executDbClick(this.router, this.activatedRoute, this.row, action, ev);
        }
        catch (e) {
            console.error('action error', e);
        }
    }
    typeDisabled(action) {
        if (ConfigDgTable.get().typeDisabled == 'display-none') {
            return !this.verifyDisabled(action) ? 'none' : 'block';
        }
        return 'block';
    }
    getListActions() {
        const result = [];
        Object.keys(this.actionList || {}).map(itemKey => {
            result.push({
                name: this.actionList[itemKey].name || itemKey,
                action: this.actionList[itemKey],
                key: itemKey
            });
        });
        return result;
    }
    verifyPositionY(elementInputCoordinates) {
        // verifica se o BOTTOM é menor que o mínimo '300px'
        if ((window.innerHeight - elementInputCoordinates.top + elementInputCoordinates.height) < 300) {
            // verifica se o TOP é menor do que o BOTTOM
            if ((window.innerHeight - elementInputCoordinates.top + (elementInputCoordinates.height / 2)) > elementInputCoordinates.top + (elementInputCoordinates.height / 2)) {
                return 'bottom';
            }
            else {
                return 'top';
            }
        }
        return "bottom";
    }
}
DefaultTdActionsDgTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DefaultTdActionsDgTableComponent, deps: [{ token: i1$3.Router }, { token: i1$3.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
DefaultTdActionsDgTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DefaultTdActionsDgTableComponent, selector: "default-td-actions-dg-table", inputs: { actionList: "actionList", row: "row", dropDownClasses: "dropDownClasses", typeActions: "typeActions" }, viewQueries: [{ propertyName: "buttonDropdown", first: true, predicate: ["buttonDropdown"], descendants: true }, { propertyName: "divDropdown", first: true, predicate: ["divDropdown"], descendants: true }], ngImport: i0, template: "<!--<div *ngIf=\"typeActions == 'dropdown-button'\" class=\"dropdown default-dropdown-actions-dg-table\">-->\r\n<!--  <button-->\r\n<!--    class=\"dg-table-dropdown-button-action {{dropDownClasses}}\"-->\r\n<!--    type=\"button\"-->\r\n<!--    (click)=\"togleDropdown()\"-->\r\n<!--    [id]=\"uniqId+'-button'\"-->\r\n<!--  >-->\r\n<!--    <svg width=\"18\" height=\"18\" style=\"fill: white\" viewBox=\"0 0 192 512\" xmlns=\"http://www.w3.org/2000/svg\">-->\r\n<!--      <path d=\"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z\"/>-->\r\n<!--    </svg>-->\r\n<!--  </button>-->\r\n<!--</div>-->\r\n\r\n<!--<div-->\r\n<!--  *ngIf=\"typeActions == 'dropdown-button'\"-->\r\n<!--  class=\"root-dropdown\"-->\r\n<!--  [class.open]=\"open\"-->\r\n<!--&gt;-->\r\n<!--  <div style=\"position: relative; width: 100%; height: 100%; background-color: red; overflow: hidden\">-->\r\n<!--    <div [id]=\"uniqId+'-div'\" style=\"position: fixed; top: 0; left: 0; background: #496244; overflow: hidden\">-->\r\n<!--      teste-->\r\n<!--&lt;!&ndash;      <div class=\"dropdown-menu-action\">&ndash;&gt;-->\r\n<!--&lt;!&ndash;        <ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;          <li&ndash;&gt;-->\r\n<!--&lt;!&ndash;            class=\"dropdown-item dg-table-action dg-table-action-{{item.name}}\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            *ngFor=\"let item of getListActions()\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            [class.disabled]=\"!verifyDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            [style.display]=\"typeDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            (click)=\"clickItem($event, item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;          >&ndash;&gt;-->\r\n<!--&lt;!&ndash;            {{item.name}}&ndash;&gt;-->\r\n<!--&lt;!&ndash;          </li>&ndash;&gt;-->\r\n<!--&lt;!&ndash;        </ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;      </div>&ndash;&gt;-->\r\n<!--    </div>-->\r\n<!--  </div>-->\r\n<!--&lt;!&ndash;  <div class=\"dropdown-menu-action\">&ndash;&gt;-->\r\n<!--&lt;!&ndash;    <ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;      <li&ndash;&gt;-->\r\n<!--&lt;!&ndash;        class=\"dropdown-item dg-table-action dg-table-action-{{item.name}}\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        *ngFor=\"let item of getListActions()\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        [class.disabled]=\"!verifyDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        [style.display]=\"typeDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        (click)=\"clickItem($event, item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;      >&ndash;&gt;-->\r\n<!--&lt;!&ndash;        {{item.name}}&ndash;&gt;-->\r\n<!--&lt;!&ndash;      </li>&ndash;&gt;-->\r\n<!--&lt;!&ndash;    </ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;  </div>&ndash;&gt;-->\r\n<!--</div>-->\r\n\r\n\r\n\r\n<div *ngIf=\"typeActions == 'dropdown-button'\" class=\"dropdown default-dropdown-actions-dg-table\">\r\n  <button\r\n    class=\"dg-table-dropdown-button-action {{dropDownClasses}}\"\r\n    type=\"button\"\r\n    id=\"dropdownMenuButton\"\r\n    data-bs-toggle=\"dropdown\"\r\n    aria-haspopup=\"true\"\r\n    aria-expanded=\"false\"\r\n  >\r\n    <svg width=\"18\" height=\"18\" style=\"fill: white\" viewBox=\"0 0 192 512\" xmlns=\"http://www.w3.org/2000/svg\">\r\n      <path d=\"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z\"/>\r\n    </svg>\r\n  </button>\r\n  <div class=\"dropdown-menu dropdown-menu-action\" aria-labelledby=\"dropdownMenuButton\">\r\n    <span\r\n      class=\"dropdown-item dg-table-action-{{item.name}}\"\r\n      *ngFor=\"let item of getListActions()\"\r\n      [class.disabled]=\"!verifyDisabled(item.action)\"\r\n      [style.display]=\"typeDisabled(item.action)\"\r\n      (click)=\"clickItem($event, item.action)\"\r\n    >\r\n      {{item.name}}\r\n    </span>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"typeActions != 'dropdown-button'\" class=\"default-inline-actions-dg-table\">\r\n  <span\r\n    class=\"dg-table-action-{{item.key}} {{item.action?.classes || ''}}\"\r\n    *ngFor=\"let item of getListActions()\"\r\n    [class.disabled]=\"!verifyDisabled(item.action)\"\r\n    [style.display]=\"typeDisabled(item.action)\"\r\n    (click)=\"clickItem($event, item.action)\"\r\n    [title]=\"typeActions == 'inline-action' ? item.action.name : ''\"\r\n  >\r\n    <i *ngIf=\"typeActions != 'inline-name'\" class=\"{{item.action?.icon || ''}}\"></i>\r\n    {{typeActions == 'inline-action-name' || typeActions == 'inline-name' ? item.action.name : ''}}\r\n  </span>\r\n</div>\r\n", styles: [".default-inline-actions-dg-table{width:100%;display:inline-flex;max-width:100%}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DefaultTdActionsDgTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'default-td-actions-dg-table', template: "<!--<div *ngIf=\"typeActions == 'dropdown-button'\" class=\"dropdown default-dropdown-actions-dg-table\">-->\r\n<!--  <button-->\r\n<!--    class=\"dg-table-dropdown-button-action {{dropDownClasses}}\"-->\r\n<!--    type=\"button\"-->\r\n<!--    (click)=\"togleDropdown()\"-->\r\n<!--    [id]=\"uniqId+'-button'\"-->\r\n<!--  >-->\r\n<!--    <svg width=\"18\" height=\"18\" style=\"fill: white\" viewBox=\"0 0 192 512\" xmlns=\"http://www.w3.org/2000/svg\">-->\r\n<!--      <path d=\"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z\"/>-->\r\n<!--    </svg>-->\r\n<!--  </button>-->\r\n<!--</div>-->\r\n\r\n<!--<div-->\r\n<!--  *ngIf=\"typeActions == 'dropdown-button'\"-->\r\n<!--  class=\"root-dropdown\"-->\r\n<!--  [class.open]=\"open\"-->\r\n<!--&gt;-->\r\n<!--  <div style=\"position: relative; width: 100%; height: 100%; background-color: red; overflow: hidden\">-->\r\n<!--    <div [id]=\"uniqId+'-div'\" style=\"position: fixed; top: 0; left: 0; background: #496244; overflow: hidden\">-->\r\n<!--      teste-->\r\n<!--&lt;!&ndash;      <div class=\"dropdown-menu-action\">&ndash;&gt;-->\r\n<!--&lt;!&ndash;        <ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;          <li&ndash;&gt;-->\r\n<!--&lt;!&ndash;            class=\"dropdown-item dg-table-action dg-table-action-{{item.name}}\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            *ngFor=\"let item of getListActions()\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            [class.disabled]=\"!verifyDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            [style.display]=\"typeDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;            (click)=\"clickItem($event, item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;          >&ndash;&gt;-->\r\n<!--&lt;!&ndash;            {{item.name}}&ndash;&gt;-->\r\n<!--&lt;!&ndash;          </li>&ndash;&gt;-->\r\n<!--&lt;!&ndash;        </ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;      </div>&ndash;&gt;-->\r\n<!--    </div>-->\r\n<!--  </div>-->\r\n<!--&lt;!&ndash;  <div class=\"dropdown-menu-action\">&ndash;&gt;-->\r\n<!--&lt;!&ndash;    <ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;      <li&ndash;&gt;-->\r\n<!--&lt;!&ndash;        class=\"dropdown-item dg-table-action dg-table-action-{{item.name}}\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        *ngFor=\"let item of getListActions()\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        [class.disabled]=\"!verifyDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        [style.display]=\"typeDisabled(item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;        (click)=\"clickItem($event, item.action)\"&ndash;&gt;-->\r\n<!--&lt;!&ndash;      >&ndash;&gt;-->\r\n<!--&lt;!&ndash;        {{item.name}}&ndash;&gt;-->\r\n<!--&lt;!&ndash;      </li>&ndash;&gt;-->\r\n<!--&lt;!&ndash;    </ul>&ndash;&gt;-->\r\n<!--&lt;!&ndash;  </div>&ndash;&gt;-->\r\n<!--</div>-->\r\n\r\n\r\n\r\n<div *ngIf=\"typeActions == 'dropdown-button'\" class=\"dropdown default-dropdown-actions-dg-table\">\r\n  <button\r\n    class=\"dg-table-dropdown-button-action {{dropDownClasses}}\"\r\n    type=\"button\"\r\n    id=\"dropdownMenuButton\"\r\n    data-bs-toggle=\"dropdown\"\r\n    aria-haspopup=\"true\"\r\n    aria-expanded=\"false\"\r\n  >\r\n    <svg width=\"18\" height=\"18\" style=\"fill: white\" viewBox=\"0 0 192 512\" xmlns=\"http://www.w3.org/2000/svg\">\r\n      <path d=\"M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z\"/>\r\n    </svg>\r\n  </button>\r\n  <div class=\"dropdown-menu dropdown-menu-action\" aria-labelledby=\"dropdownMenuButton\">\r\n    <span\r\n      class=\"dropdown-item dg-table-action-{{item.name}}\"\r\n      *ngFor=\"let item of getListActions()\"\r\n      [class.disabled]=\"!verifyDisabled(item.action)\"\r\n      [style.display]=\"typeDisabled(item.action)\"\r\n      (click)=\"clickItem($event, item.action)\"\r\n    >\r\n      {{item.name}}\r\n    </span>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"typeActions != 'dropdown-button'\" class=\"default-inline-actions-dg-table\">\r\n  <span\r\n    class=\"dg-table-action-{{item.key}} {{item.action?.classes || ''}}\"\r\n    *ngFor=\"let item of getListActions()\"\r\n    [class.disabled]=\"!verifyDisabled(item.action)\"\r\n    [style.display]=\"typeDisabled(item.action)\"\r\n    (click)=\"clickItem($event, item.action)\"\r\n    [title]=\"typeActions == 'inline-action' ? item.action.name : ''\"\r\n  >\r\n    <i *ngIf=\"typeActions != 'inline-name'\" class=\"{{item.action?.icon || ''}}\"></i>\r\n    {{typeActions == 'inline-action-name' || typeActions == 'inline-name' ? item.action.name : ''}}\r\n  </span>\r\n</div>\r\n", styles: [".default-inline-actions-dg-table{width:100%;display:inline-flex;max-width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.Router }, { type: i1$3.ActivatedRoute }]; }, propDecorators: { actionList: [{
                type: Input
            }], row: [{
                type: Input
            }], dropDownClasses: [{
                type: Input
            }], typeActions: [{
                type: Input
            }], buttonDropdown: [{
                type: ViewChild,
                args: ['buttonDropdown']
            }], divDropdown: [{
                type: ViewChild,
                args: ['divDropdown']
            }] } });

class TdInnerHtmlDirective {
    constructor(host) {
        this.host = host;
        this.innerHtml = false;
        this.valueInnerHtml = '';
    }
    ngOnInit() {
        if (this.innerHtml) {
            this.host.nativeElement.innerHTML = this.valueInnerHtml;
        }
    }
    ngAfterViewChecked() {
        if (this.innerHtml) {
            this.host.nativeElement.innerHTML = this.valueInnerHtml;
        }
    }
}
TdInnerHtmlDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TdInnerHtmlDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
TdInnerHtmlDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: TdInnerHtmlDirective, selector: "td[td-inner-html]", inputs: { innerHtml: ["td-inner-html", "innerHtml"], valueInnerHtml: ["td-inner-html-value", "valueInnerHtml"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TdInnerHtmlDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'td[td-inner-html]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { innerHtml: [{
                type: Input,
                args: ['td-inner-html']
            }], valueInnerHtml: [{
                type: Input,
                args: ['td-inner-html-value']
            }] } });

class DgTableComponent {
    constructor() {
        /**
         * entrada de dados
         */
        // Array de dados sendo apresentados na tabela
        this.dataSource = [];
        // Colunas existentes na tabela
        this.columns = [];
        // permite reordenação das colunas na tabela
        this.draggable = false;
        // Apresentar loader
        this.showLoading = false;
        // tipos padrões de loader.
        // você ainda pode inserir um template-loader
        this.typeLoader = 'circle';
        // ENTRADAS DA ORDENAÇÃO
        // Habilita/desabilita filtros total ou parcial
        // boolean = habilita/desabilita todos de uma vez
        // string[] = habilita todos que existirem no array, a string deve ser igual ao nome da coluna
        this.sort = false;
        // dados do ordenação atuais da tabela
        this.sortIcon = [['id', 'asc']];
        // Permite a utilização de multiplos SORT's
        this.acceptMultSort = false;
        // objeto contendo todos os actions existentes
        this.actionsList = {};
        /**
         * saída de dados
         */
        this.dbClick = new EventEmitter();
        this.changeSort = new EventEmitter();
        this.changeSortColumns = new EventEmitter();
        /**
         * Grupo de controles de ações e trocas de dados
         */
        this.control = {
            templates: {
                verify: {
                    columns: (columnName) => {
                        const result = this.templateTableColumns.find(template => {
                            return template.columnName == (typeof columnName == 'string' ? columnName : columnName.name);
                        });
                        return !!result;
                    },
                    header: (headerName) => {
                        const result = this.templateTableHeaders.find(template => {
                            return template.headerName == (typeof headerName == 'string' ? headerName : headerName.name);
                        });
                        return !!result;
                    },
                    actions: () => {
                        return this.templateTableActions.length > 0;
                    },
                    loader: () => {
                        return !!(this === null || this === void 0 ? void 0 : this.tableLoader);
                    }
                },
                get: {
                    column: (columnName) => {
                        const result = this.templateTableColumns.find(template => {
                            return template.columnName == (typeof columnName == 'string' ? columnName : columnName.name);
                        });
                        if (!result) {
                            throw 'erro tamplate da coluna declarado mas não encontrado';
                        }
                        return result.template;
                    },
                    header: (headerName) => {
                        const result = this.templateTableHeaders.find(template => {
                            return template.headerName == (typeof headerName == 'string' ? headerName : headerName.name);
                        });
                        if (!result) {
                            throw 'erro tamplate do header declarado mas não encontrado';
                        }
                        return result.template;
                    },
                    actions: () => {
                        if (!this.control.templates.verify.actions()) {
                            throw 'Template de ações declarado mas não encontrado';
                        }
                        const elementRef = this.templateTableActions.get(this.templateTableActions.length - 1);
                        if (!elementRef) {
                            throw 'Template de ações declarado mas não encontrado';
                        }
                        return elementRef.template;
                    }
                },
                data: {
                    getHeaders: (d) => {
                        const columnName = (typeof d == 'string' ? d : d.name);
                        const headerName = (typeof d == 'string' ? d : d.headerName || d.name);
                        const sortAttrKey = (typeof d == 'string' ? d : d.sortAttrKey || d.name);
                        return {
                            columnName,
                            headerName,
                            sortAttrKey,
                            sort: this.sortIcon,
                            verifyDirectionIcon: (direction) => this.control.sort.verifyDirectionIcon(d, direction),
                            clickSort: (direction, appendIfNotExist) => this.control.sort.clickSort(d, direction, appendIfNotExist),
                            removeSort: (emitEvent) => this.control.sort.removeSort(d, emitEvent)
                        };
                    },
                    getActions: (row, index) => {
                        return { row, index, actions: this.actionsList };
                    },
                    getColumnData: (row, cel, index) => {
                        return {
                            row,
                            cel: Object.assign(Object.assign({}, cel), { value: this.control.innerHTML.column(row, cel) }),
                            index
                        };
                    }
                }
            },
            innerHTML: {
                column: (row, column) => {
                    const columnName = typeof column == 'string' ? column : column.name || '&notfount';
                    if (!(columnName in row)) {
                        if (typeof column == 'string')
                            return this.undefinedCell;
                        if (!(column === null || column === void 0 ? void 0 : column.resource))
                            return this.undefinedCell;
                    }
                    if (typeof column == 'string')
                        return row[columnName];
                    if (!!(column === null || column === void 0 ? void 0 : column.resource)) {
                        if (typeof column.resource == 'function') {
                            return column.resource(row[columnName], row);
                        }
                        if (Array.isArray(column.resource) || typeof column.resource == 'object') {
                            if (!!row[columnName] || row[columnName] === 0) {
                                if (!!column.resource[row[columnName]]) {
                                    return column.resource[row[columnName]];
                                }
                            }
                            console.warn('O valor ' + row[columnName] + ' não foi encontrado em : ', column.resource);
                            return '';
                        }
                    }
                    if (!!(column === null || column === void 0 ? void 0 : column.mask)) {
                        return CdkDgTable.mask(column.mask, row[columnName]);
                    }
                    return row[columnName];
                },
                header: (column) => {
                    if (typeof column == 'string')
                        return column;
                    return (column === null || column === void 0 ? void 0 : column.headerName) || '';
                }
            },
            cssClass: {
                th: (column) => {
                    if (typeof column == "string")
                        return '';
                    if (!!(column === null || column === void 0 ? void 0 : column.thClass)) {
                        if (typeof column.thClass == 'string') {
                            return column.thClass;
                        }
                        else {
                            return column.thClass();
                        }
                    }
                    return '';
                },
                td: (column, row, cel) => {
                    if (typeof column == "string")
                        return '';
                    if (!!(column === null || column === void 0 ? void 0 : column.tdClass)) {
                        if (typeof column.tdClass == 'string') {
                            return column.tdClass;
                        }
                        else {
                            return column.tdClass(cel, row);
                        }
                    }
                    return '';
                },
                /**
                 * Função para retornar classe padrão obrigatória em todas as celulas
                 * @param column
                 */
                getCellClass: (column) => {
                    if (typeof column == 'string') {
                        return column;
                    }
                    return column.name;
                },
                row: (column, row) => {
                    // TODO O metodo ainda não foi criado pela limitação técnica de onde por a entrada desse metodo
                    //  POR NO NOVO METODO DE RETORNO DAS TEMPLATES E NO @DynamicEntity
                    throw 'O metodo ainda não implementado';
                },
            },
            columns: {
                verifyShow: (column) => {
                    if (typeof column == 'string')
                        return true;
                    if ('visible' in column) {
                        return !!column.visible;
                    }
                    return true;
                },
                drop: (event) => {
                    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
                    this.changeSortColumns.emit(this.columns);
                }
            },
            sort: {
                /**
                 * Verifica se a ordenação está ativa para a coluna desejada
                 * @param column
                 */
                verifyActiveClickSort: (column) => {
                    if (this.control.templates.verify.header(column)) {
                        return false;
                    }
                    if (typeof this.sort == 'boolean')
                        return this.sort;
                    const columnName = typeof column == 'string' ? column : (column === null || column === void 0 ? void 0 : column.sortAttrKey) || column.name;
                    return this.sort.findIndex(sort => sort == columnName) != -1;
                },
                // TODO metodo usado em "clickSort" verificar possibilidade de incorporação
                changeSingleSort: (column) => {
                    let columnName = (typeof column == 'string' ? column : (column === null || column === void 0 ? void 0 : column.sortAttrKey) || column.name);
                    const columnFilter = this.sortIcon[0];
                    if (columnName == columnFilter[0]) {
                        columnFilter[1] = columnFilter[1] == 'asc' ? 'desc' : 'asc';
                    }
                    else {
                        if (!!columnName) {
                            columnFilter[0] = columnName;
                            columnFilter[1] = 'asc';
                        }
                    }
                },
                removeSort: (column, emitEvent = true) => {
                    const columnName = (typeof column == 'string' ? column : (column === null || column === void 0 ? void 0 : column.sortAttrKey) || column.name);
                    const columnFilterIndex = this.sortIcon.findIndex(val => val[0] == columnName);
                    if (columnFilterIndex == -1)
                        return;
                    this.sortIcon.splice(columnFilterIndex, 1);
                    if (emitEvent) {
                        this.changeSort.emit(this.sortIcon.map(val => val.join(',')));
                    }
                },
                /**
                 * Função de click para mudança de SORT.
                 * @param column
                 * @param directions
                 * @param appendIfNotExist
                 */
                clickSort: (column, directions, appendIfNotExist) => {
                    let columnName = (typeof column == 'string' ? column : (column === null || column === void 0 ? void 0 : column.sortAttrKey) || column.name);
                    // fluxo de ordenação multipla
                    if (this.acceptMultSort) {
                        let columnFilterIndex = this.sortIcon.findIndex(val => val[0] == columnName);
                        if (columnFilterIndex == -1) {
                            if (!appendIfNotExist) {
                                this.sortIcon = [[columnName, directions || 'asc']];
                            }
                            else {
                                this.sortIcon.push([columnName, directions || 'asc']);
                            }
                        }
                        else {
                            const columnFilter = this.sortIcon[columnFilterIndex];
                            this.control.sort.removeSort(column, false);
                            columnFilter[1] = !!directions ? directions : columnFilter[1] == 'asc' ? 'desc' : 'asc';
                            this.sortIcon.push(columnFilter);
                        }
                    }
                    else {
                        // fluxo de ordenação unitária
                        this.control.sort.changeSingleSort(columnName);
                    }
                    this.changeSort.emit(this.sortIcon.map(val => val.join(',')));
                },
                /**
                 * Verificador de apresentação de icones de ordenação de tabela
                 * @param column
                 * @param direction
                 */
                verifyDirectionIcon: (column, direction) => {
                    const columnName = typeof column == 'string' ? column : (column === null || column === void 0 ? void 0 : column.sortAttrKey) || column.name || '&notfount';
                    const columnFilter = this.sortIcon.find(val => val[0] == columnName);
                    if (!columnFilter)
                        return false;
                    return columnFilter[1] == direction;
                    // return this.sortIcon[0] == columnName && this.sortIcon[1] == direction
                }
            },
            actions: {
                verifyShow: (origin) => {
                    if (!this.showActions)
                        return false;
                    if (origin == "defaultDropdown") {
                        return !this.control.templates.verify.actions() && Object.keys(this.actionsList).length > 0;
                    }
                    if (origin == 'template') {
                        return this.control.templates.verify.actions();
                    }
                    return Object.keys(this.actionsList).length > 0 || this.control.templates.verify.actions();
                }
            }
        };
        const rootConfig = ConfigDgTable.get();
        this.undefinedCell = rootConfig.undefinedCell;
        this.typeShowActions = rootConfig.typeShowActions;
        this.showActions = rootConfig.showActions;
        this.classes = rootConfig.classes;
        this.headerNameActions = rootConfig.headerNameActions;
    }
    ngOnInit() {
    }
    // TODO acredito que essa função inteira poderia ser substituida por ' colspan="100%" '
    //  mas precisa ser testado em vários cenários
    totalColspan() {
        let allColunms = this.columns.map(item => this.control.columns.verifyShow(item)).length;
        if (this.control.actions.verifyShow('template') || this.control.actions.verifyShow('defaultDropdown')) {
            allColunms = allColunms + 1;
        }
        return allColunms;
    }
}
DgTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DgTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgTableComponent, selector: "dg-table", inputs: { dataSource: "dataSource", columns: "columns", classes: "classes", undefinedCell: "undefinedCell", draggable: "draggable", showLoading: "showLoading", typeLoader: "typeLoader", sort: "sort", sortIcon: "sortIcon", acceptMultSort: "acceptMultSort", showActions: "showActions", typeShowActions: "typeShowActions", headerNameActions: "headerNameActions", actionsList: "actionsList" }, outputs: { dbClick: "dbClick", changeSort: "changeSort", changeSortColumns: "changeSortColumns" }, queries: [{ propertyName: "tableLoader", first: true, predicate: ["tableLoader"], descendants: true }, { propertyName: "templateTableActions", predicate: DgTableActionsTemplateDirective, read: DgTableActionsTemplateDirective }, { propertyName: "templateTableColumns", predicate: DgTableColumnTemplateDirective, read: DgTableColumnTemplateDirective }, { propertyName: "templateTableHeaders", predicate: DgTableHeaderTemplateDirective, read: DgTableHeaderTemplateDirective }], ngImport: i0, template: "<table class=\"dg-table {{classes || ''}}\" [class.draggable]=\"draggable\">\r\n  <thead class=\"header-dg-table\">\r\n    <tr\r\n      cdkDropList\r\n      cdkDropListOrientation=\"horizontal\"\r\n      (cdkDropListDropped)=\"control.columns.drop($event)\"\r\n    >\r\n      <th\r\n        *ngFor=\"let column of columns\"\r\n        (click)=\"control.sort.verifyActiveClickSort(column) ? control.sort.clickSort(column, undefined, $event.ctrlKey) : null\"\r\n        class=\"dg-table-th th-{{control.cssClass.getCellClass(column)}} {{control.cssClass.th(column)}}\"\r\n        [class.hidde-column]=\"!control.columns.verifyShow(column)\"\r\n        cdkDrag\r\n        [cdkDragDisabled]=\"!draggable\"\r\n      >\r\n        <!-- apresenta\u00E7\u00E3o padr\u00E3o do header -->\r\n\r\n        <span *ngIf=\"!control.templates.verify.header(column)\" style=\"word-wrap: break-word; display: inline-flex; align-items: center\">\r\n         {{ control.innerHTML.header(column) }}\r\n<!--         {{ !verifyTemplates.header(column) ? getInnerHtml.header(column) : null }}-->\r\n          <div class=\"th-content-icons\" *ngIf=\"control.sort.verifyActiveClickSort(column) && !control.templates.verify.header(column)\">\r\n            <span class=\"ng-util-icon icon-arrow-drop-up\" [class.active]=\"control.sort.verifyDirectionIcon(column, 'desc')\"></span>\r\n            <span class=\"ng-util-icon icon-arrow-drop-down\" [class.active]=\"control.sort.verifyDirectionIcon(column, 'asc')\"></span>\r\n          </div>\r\n        </span>\r\n\r\n        <!-- custom header -->\r\n        <ng-container\r\n          *ngIf=\"control.templates.verify.header(column)\"\r\n          [ngTemplateOutlet]=\"control.templates.get.header(column)\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getHeaders(column)}\"\r\n        >\r\n        </ng-container>\r\n      </th>\r\n      <th class=\"th-actions\" *ngIf=\"control.actions.verifyShow()\">{{headerNameActions}}</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody class=\"body-dg-table\">\r\n    <tr *ngIf=\"(dataSource.length < 1 && !showLoading)\">\r\n      <td [attr.colspan]=\"totalColspan()\">Nenhum registro encontrado</td>\r\n    </tr>\r\n    <tr *ngIf=\"(dataSource.length < 1 && showLoading)\" class=\"tr-loader\">\r\n      <td *ngIf=\"!control.templates.verify.loader()\" [attr.colspan]=\"totalColspan()\" class=\"td-loader\">\r\n        <default-table-loaders [typeLoader]=\"typeLoader\"></default-table-loaders>\r\n      </td>\r\n      <td *ngIf=\"control.templates.verify.loader()\" colspan=\"100%\" class=\"td-custom-loader\">\r\n        <ng-container style=\"width: 100%\" [ngTemplateOutlet]=\"tableLoader\">\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n    <tr\r\n      *ngFor=\"let row of dataSource; let index = index\"\r\n      (dblclick)=\"dbClick.emit({ row, index, eventMouse: $event })\"\r\n    >\r\n      <td\r\n        *ngFor=\"let column of columns\"\r\n        class=\"td-{{control.cssClass.getCellClass(column)}} {{control.cssClass.td(column, row, dataSource[index])}}\"\r\n        [class.hidde-column]=\"!control.columns.verifyShow(column)\"\r\n        [td-inner-html]=\"!control.templates.verify.columns(column)\"\r\n        [td-inner-html-value]=\"control.innerHTML.column(row, column)\"\r\n      >\r\n\r\n        <ng-container\r\n          *ngIf=\"control.templates.verify.columns(column)\"\r\n          [ngTemplateOutlet]=\"control.templates.get.column(column)\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getColumnData(row, column, index)}\"\r\n        >\r\n        </ng-container>\r\n      </td>\r\n      <!-- apresenta\u00E7\u00E3o de actions padr\u00E3o -->\r\n      <td class=\"td-actions\" *ngIf=\"control.actions.verifyShow('defaultDropdown')\">\r\n        <default-td-actions-dg-table [typeActions]=\"typeShowActions\" [row]=\"row\" [actionList]=\"actionsList\"></default-td-actions-dg-table>\r\n      </td>\r\n      <!-- custom actions -->\r\n      <td class=\"td-actions\" *ngIf=\"control.actions.verifyShow('template')\">\r\n        <ng-container\r\n          [ngTemplateOutlet]=\"control.templates.get.actions()\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getActions(row, index)}\"\r\n        >\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n", styles: [""], components: [{ type: DefaultTableLoadersComponent, selector: "default-table-loaders", inputs: ["typeLoader"] }, { type: DefaultTdActionsDgTableComponent, selector: "default-td-actions-dg-table", inputs: ["actionList", "row", "dropDownClasses", "typeActions"] }], directives: [{ type: i3.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: TdInnerHtmlDirective, selector: "td[td-inner-html]", inputs: ["td-inner-html", "td-inner-html-value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-table', template: "<table class=\"dg-table {{classes || ''}}\" [class.draggable]=\"draggable\">\r\n  <thead class=\"header-dg-table\">\r\n    <tr\r\n      cdkDropList\r\n      cdkDropListOrientation=\"horizontal\"\r\n      (cdkDropListDropped)=\"control.columns.drop($event)\"\r\n    >\r\n      <th\r\n        *ngFor=\"let column of columns\"\r\n        (click)=\"control.sort.verifyActiveClickSort(column) ? control.sort.clickSort(column, undefined, $event.ctrlKey) : null\"\r\n        class=\"dg-table-th th-{{control.cssClass.getCellClass(column)}} {{control.cssClass.th(column)}}\"\r\n        [class.hidde-column]=\"!control.columns.verifyShow(column)\"\r\n        cdkDrag\r\n        [cdkDragDisabled]=\"!draggable\"\r\n      >\r\n        <!-- apresenta\u00E7\u00E3o padr\u00E3o do header -->\r\n\r\n        <span *ngIf=\"!control.templates.verify.header(column)\" style=\"word-wrap: break-word; display: inline-flex; align-items: center\">\r\n         {{ control.innerHTML.header(column) }}\r\n<!--         {{ !verifyTemplates.header(column) ? getInnerHtml.header(column) : null }}-->\r\n          <div class=\"th-content-icons\" *ngIf=\"control.sort.verifyActiveClickSort(column) && !control.templates.verify.header(column)\">\r\n            <span class=\"ng-util-icon icon-arrow-drop-up\" [class.active]=\"control.sort.verifyDirectionIcon(column, 'desc')\"></span>\r\n            <span class=\"ng-util-icon icon-arrow-drop-down\" [class.active]=\"control.sort.verifyDirectionIcon(column, 'asc')\"></span>\r\n          </div>\r\n        </span>\r\n\r\n        <!-- custom header -->\r\n        <ng-container\r\n          *ngIf=\"control.templates.verify.header(column)\"\r\n          [ngTemplateOutlet]=\"control.templates.get.header(column)\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getHeaders(column)}\"\r\n        >\r\n        </ng-container>\r\n      </th>\r\n      <th class=\"th-actions\" *ngIf=\"control.actions.verifyShow()\">{{headerNameActions}}</th>\r\n    </tr>\r\n  </thead>\r\n  <tbody class=\"body-dg-table\">\r\n    <tr *ngIf=\"(dataSource.length < 1 && !showLoading)\">\r\n      <td [attr.colspan]=\"totalColspan()\">Nenhum registro encontrado</td>\r\n    </tr>\r\n    <tr *ngIf=\"(dataSource.length < 1 && showLoading)\" class=\"tr-loader\">\r\n      <td *ngIf=\"!control.templates.verify.loader()\" [attr.colspan]=\"totalColspan()\" class=\"td-loader\">\r\n        <default-table-loaders [typeLoader]=\"typeLoader\"></default-table-loaders>\r\n      </td>\r\n      <td *ngIf=\"control.templates.verify.loader()\" colspan=\"100%\" class=\"td-custom-loader\">\r\n        <ng-container style=\"width: 100%\" [ngTemplateOutlet]=\"tableLoader\">\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n    <tr\r\n      *ngFor=\"let row of dataSource; let index = index\"\r\n      (dblclick)=\"dbClick.emit({ row, index, eventMouse: $event })\"\r\n    >\r\n      <td\r\n        *ngFor=\"let column of columns\"\r\n        class=\"td-{{control.cssClass.getCellClass(column)}} {{control.cssClass.td(column, row, dataSource[index])}}\"\r\n        [class.hidde-column]=\"!control.columns.verifyShow(column)\"\r\n        [td-inner-html]=\"!control.templates.verify.columns(column)\"\r\n        [td-inner-html-value]=\"control.innerHTML.column(row, column)\"\r\n      >\r\n\r\n        <ng-container\r\n          *ngIf=\"control.templates.verify.columns(column)\"\r\n          [ngTemplateOutlet]=\"control.templates.get.column(column)\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getColumnData(row, column, index)}\"\r\n        >\r\n        </ng-container>\r\n      </td>\r\n      <!-- apresenta\u00E7\u00E3o de actions padr\u00E3o -->\r\n      <td class=\"td-actions\" *ngIf=\"control.actions.verifyShow('defaultDropdown')\">\r\n        <default-td-actions-dg-table [typeActions]=\"typeShowActions\" [row]=\"row\" [actionList]=\"actionsList\"></default-td-actions-dg-table>\r\n      </td>\r\n      <!-- custom actions -->\r\n      <td class=\"td-actions\" *ngIf=\"control.actions.verifyShow('template')\">\r\n        <ng-container\r\n          [ngTemplateOutlet]=\"control.templates.get.actions()\"\r\n          [ngTemplateOutletContext]=\"{$implicit:control.templates.data.getActions(row, index)}\"\r\n        >\r\n        </ng-container>\r\n      </td>\r\n    </tr>\r\n  </tbody>\r\n</table>\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { dataSource: [{
                type: Input
            }], columns: [{
                type: Input
            }], classes: [{
                type: Input
            }], undefinedCell: [{
                type: Input
            }], draggable: [{
                type: Input
            }], showLoading: [{
                type: Input
            }], typeLoader: [{
                type: Input
            }], sort: [{
                type: Input
            }], sortIcon: [{
                type: Input
            }], acceptMultSort: [{
                type: Input
            }], showActions: [{
                type: Input
            }], typeShowActions: [{
                type: Input
            }], headerNameActions: [{
                type: Input
            }], actionsList: [{
                type: Input
            }], dbClick: [{
                type: Output,
                args: ['dbClick']
            }], changeSort: [{
                type: Output,
                args: ['changeSort']
            }], changeSortColumns: [{
                type: Output,
                args: ['changeSortColumns']
            }], tableLoader: [{
                type: ContentChild,
                args: ['tableLoader', { static: false }]
            }], templateTableActions: [{
                type: ContentChildren,
                args: [DgTableActionsTemplateDirective,
                    { read: DgTableActionsTemplateDirective }]
            }], templateTableColumns: [{
                type: ContentChildren,
                args: [DgTableColumnTemplateDirective,
                    { read: DgTableColumnTemplateDirective }]
            }], templateTableHeaders: [{
                type: ContentChildren,
                args: [DgTableHeaderTemplateDirective,
                    { read: DgTableHeaderTemplateDirective }]
            }] } });

class DgDynamicTableDirective {
    constructor(host, router, activatedRoute) {
        this.host = host;
        this.router = router;
        this.activatedRoute = activatedRoute;
        /**
         * Esse input controla a inicialização automatica da dynamicTable.
         * È naturalmente ativa.
         * Quando ativa realiza a busca de dados logo após iniciar o componente
         */
        this.autoInitLoader = true;
    }
    ngOnInit() {
        this.dynamicTable.observables.dataSource.subscribe((data) => {
            this.host.dataSource = data.data;
        });
        this.dynamicTable.observables.actions.subscribe((actions) => {
            this.host.actionsList = actions;
        });
        this.dynamicTable.observables.columns.subscribe((columns) => {
            this.host.columns = columns;
        });
        this.dynamicTable.observables.sortList.subscribe((sort) => {
            this.host.sort = sort;
        });
        this.dynamicTable.observables.pagination.subscribe((pagination) => {
            this.host.acceptMultSort = pagination.typePagination == 'MULTIPLE';
            this.host.sortIcon = pagination.sort.map(val => val.split(','));
        });
        this.dynamicTable.observables.loader.subscribe((loader) => {
            this.host.showLoading = loader;
        });
        if (this.autoInitLoader)
            this.dynamicTable.controls.data.find();
    }
    dbClick(ev) {
        const { row, eventMouse } = ev;
        const listActions = this.dynamicTable.controls.actions.get();
        const action = Object.values(listActions).find(action => action.dbClick);
        if (!action)
            return;
        CdkDgTable.executDbClick(this.router, this.activatedRoute, row, action, eventMouse);
    }
    changeSort(sort) {
        this.dynamicTable.controls.pagination.set({ sort: sort }, { find: true });
    }
}
DgDynamicTableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgDynamicTableDirective, deps: [{ token: DgTableComponent }, { token: i1$3.Router }, { token: i1$3.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Directive });
DgDynamicTableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgDynamicTableDirective, selector: "dg-table[dg-dynamic-table]", inputs: { dynamicTable: "dynamicTable", autoInitLoader: ["initAutoLoader", "autoInitLoader"] }, host: { listeners: { "dbClick": "dbClick($event)", "changeSort": "changeSort($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgDynamicTableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'dg-table[dg-dynamic-table]'
                }]
        }], ctorParameters: function () { return [{ type: DgTableComponent }, { type: i1$3.Router }, { type: i1$3.ActivatedRoute }]; }, propDecorators: { dynamicTable: [{
                type: Input,
                args: ['dynamicTable']
            }], autoInitLoader: [{
                type: Input,
                args: ['initAutoLoader']
            }], dbClick: [{
                type: HostListener,
                args: ['dbClick', ['$event']]
            }], changeSort: [{
                type: HostListener,
                args: ['changeSort', ['$event']]
            }] } });

class DgTableMaterialPaginatorDirective {
    constructor(host) {
        this.host = host;
    }
    ngOnInit() {
        this.dynamicTable.observables.pagination.subscribe(pagination => {
            this.host.pageIndex = pagination.page;
            this.host.pageSize = pagination.size;
            this.host.length = pagination.totalElements;
        });
    }
    changePage(ev) {
        this.dynamicTable.controls.pagination.set({
            page: ev.pageIndex,
            size: ev.pageSize,
        });
    }
}
DgTableMaterialPaginatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableMaterialPaginatorDirective, deps: [{ token: i1$5.MatPaginator }], target: i0.ɵɵFactoryTarget.Directive });
DgTableMaterialPaginatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTableMaterialPaginatorDirective, selector: "mat-paginator[dg-table-matrial-paginator]", inputs: { dynamicTable: "dynamicTable" }, host: { listeners: { "page": "changePage($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableMaterialPaginatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-paginator[dg-table-matrial-paginator]'
                }]
        }], ctorParameters: function () { return [{ type: i1$5.MatPaginator }]; }, propDecorators: { dynamicTable: [{
                type: Input,
                args: ['dynamicTable']
            }], changePage: [{
                type: HostListener,
                args: ['page', ['$event']]
            }] } });

class DgPaginatorComponent {
    constructor() {
        this.pageIndex = 0;
        this.pageSize = 10;
        this.totalPages = 0;
        this.totalElements = 0;
        this.pageSizeOptions = [5, 10, 25, 50, 100];
        this.showSizeSelect = true;
        this.showAllElements = true;
        this.changePage = new EventEmitter();
    }
    ngOnInit() {
    }
    changePagination(value) {
        this.pageIndex = value;
        this.changePage.emit({ pageSize: this.pageSize, pageIndex: this.pageIndex });
    }
    verificarMenores(value) {
        return ((Number(this.pageIndex) + 1) - value) > 0;
    }
    disabled(data, valor) {
        if (data === 'menos') {
            if (!!valor) {
                return (this.pageIndex - valor) < 0;
            }
            else {
                return this.pageIndex <= 0;
            }
        }
        else {
            if (!!valor) {
                return Number(this.pageIndex) + valor >= this.totalPages;
            }
            else {
                return Number(this.pageIndex) + 1 >= this.totalPages;
            }
        }
    }
    verificarMaiores(value) {
        return ((Number(this.pageIndex) + 1) + value) <= this.totalPages;
    }
    alterSize(size) {
        this.changePage.emit({ pageSize: this.pageSize, pageIndex: this.pageIndex });
    }
}
DgPaginatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DgPaginatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgPaginatorComponent, selector: "dg-paginator", inputs: { pageIndex: "pageIndex", pageSize: "pageSize", totalPages: "totalPages", totalElements: "totalElements", pageSizeOptions: "pageSizeOptions", showSizeSelect: "showSizeSelect", showAllElements: "showAllElements" }, outputs: { changePage: "changePage" }, ngImport: i0, template: "<nav class=\"cdk-dg-paginator theme-dg-paginator\">\r\n  <ul class=\"pagination-ul\">\r\n    <!-- item de startPage -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos', 2) ? null : changePagination(0)\"\r\n      [class.disabled]=\"disabled('menos', 2)\"\r\n    >\r\n      <span class=\"page-link\"> << </span>\r\n    </li>\r\n    <!-- item para retroceder uma p\u00E1gina -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos') ? null : changePagination(pageIndex - 1)\"\r\n      [class.disabled]=\"disabled('menos')\"\r\n    >\r\n      <span class=\"page-link\"> < </span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" (click)=\"changePagination(pageIndex + - 2)\" *ngIf=\"verificarMenores(2)\">\r\n      <span class=\"page-link\" href=\"#\">{{  pageIndex - 1 }}</span>\r\n    </li>\r\n    <li class=\"page-item\" (click)=\"changePagination(pageIndex + - 1)\" *ngIf=\"verificarMenores(1)\">\r\n      <span class=\"page-link\" href=\"#\">{{ pageIndex }}</span>\r\n    </li>\r\n\r\n    <!-- -->\r\n    <li class=\"page-item active-pagination\">\r\n      <span class=\"page-link\">{{ (pageIndex + 1) }}</span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(1)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(pageIndex + 1)\">{{ (pageIndex + 2) }}</span>\r\n    </li>\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(2)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(pageIndex + 2)\">{{ (pageIndex + 3) }}</span>\r\n    </li>\r\n\r\n    <!-- item de lastPage -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais') ? null : changePagination(pageIndex + 1)\"\r\n      [class.disabled]=\"disabled('mais')\"\r\n    >\r\n      <span class=\"page-link\"> > </span>\r\n    </li>\r\n    <!-- item para retroceder uma p\u00E1gina -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais', 2) ? null : changePagination(totalPages - 1)\"\r\n      [class.disabled]=\"disabled('mais', 2)\"\r\n    >\r\n      <span class=\"page-link\"> >> </span>\r\n    </li>\r\n  </ul>\r\n\r\n  <ul *ngIf=\"showSizeSelect\" class=\"pagination-ul size\" style=\"margin-left: .5rem\">\r\n    <li class=\"page-item\">\r\n      <select class=\"page-link h-100\" [(ngModel)]=\"pageSize\" (ngModelChange)=\"alterSize($event)\">\r\n        <option *ngFor=\"let option of pageSizeOptions\" [value]=\"option\">{{option}}</option>\r\n      </select>\r\n    </li>\r\n\r\n    <li class=\"page-item\">\r\n      <span class=\"page-link\">\r\n        P\u00E1gina {{pageIndex + 1}} de {{totalPages}}\r\n      </span>\r\n    </li>\r\n\r\n    <li class=\"page-item\" *ngIf=\"showAllElements\">\r\n      <span class=\"page-link\">\r\n        {{totalElements}} registros\r\n      </span>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n", styles: [""], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i1$1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-paginator', template: "<nav class=\"cdk-dg-paginator theme-dg-paginator\">\r\n  <ul class=\"pagination-ul\">\r\n    <!-- item de startPage -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos', 2) ? null : changePagination(0)\"\r\n      [class.disabled]=\"disabled('menos', 2)\"\r\n    >\r\n      <span class=\"page-link\"> << </span>\r\n    </li>\r\n    <!-- item para retroceder uma p\u00E1gina -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('menos') ? null : changePagination(pageIndex - 1)\"\r\n      [class.disabled]=\"disabled('menos')\"\r\n    >\r\n      <span class=\"page-link\"> < </span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" (click)=\"changePagination(pageIndex + - 2)\" *ngIf=\"verificarMenores(2)\">\r\n      <span class=\"page-link\" href=\"#\">{{  pageIndex - 1 }}</span>\r\n    </li>\r\n    <li class=\"page-item\" (click)=\"changePagination(pageIndex + - 1)\" *ngIf=\"verificarMenores(1)\">\r\n      <span class=\"page-link\" href=\"#\">{{ pageIndex }}</span>\r\n    </li>\r\n\r\n    <!-- -->\r\n    <li class=\"page-item active-pagination\">\r\n      <span class=\"page-link\">{{ (pageIndex + 1) }}</span>\r\n    </li>\r\n\r\n\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(1)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(pageIndex + 1)\">{{ (pageIndex + 2) }}</span>\r\n    </li>\r\n    <li class=\"page-item\" *ngIf=\"verificarMaiores(2)\">\r\n      <span class=\"page-link\" (click)=\"changePagination(pageIndex + 2)\">{{ (pageIndex + 3) }}</span>\r\n    </li>\r\n\r\n    <!-- item de lastPage -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais') ? null : changePagination(pageIndex + 1)\"\r\n      [class.disabled]=\"disabled('mais')\"\r\n    >\r\n      <span class=\"page-link\"> > </span>\r\n    </li>\r\n    <!-- item para retroceder uma p\u00E1gina -->\r\n    <li\r\n      class=\"page-item\"\r\n      (click)=\"disabled('mais', 2) ? null : changePagination(totalPages - 1)\"\r\n      [class.disabled]=\"disabled('mais', 2)\"\r\n    >\r\n      <span class=\"page-link\"> >> </span>\r\n    </li>\r\n  </ul>\r\n\r\n  <ul *ngIf=\"showSizeSelect\" class=\"pagination-ul size\" style=\"margin-left: .5rem\">\r\n    <li class=\"page-item\">\r\n      <select class=\"page-link h-100\" [(ngModel)]=\"pageSize\" (ngModelChange)=\"alterSize($event)\">\r\n        <option *ngFor=\"let option of pageSizeOptions\" [value]=\"option\">{{option}}</option>\r\n      </select>\r\n    </li>\r\n\r\n    <li class=\"page-item\">\r\n      <span class=\"page-link\">\r\n        P\u00E1gina {{pageIndex + 1}} de {{totalPages}}\r\n      </span>\r\n    </li>\r\n\r\n    <li class=\"page-item\" *ngIf=\"showAllElements\">\r\n      <span class=\"page-link\">\r\n        {{totalElements}} registros\r\n      </span>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n", styles: [""] }]
        }], ctorParameters: function () { return []; }, propDecorators: { pageIndex: [{
                type: Input
            }], pageSize: [{
                type: Input
            }], totalPages: [{
                type: Input
            }], totalElements: [{
                type: Input
            }], pageSizeOptions: [{
                type: Input
            }], showSizeSelect: [{
                type: Input
            }], showAllElements: [{
                type: Input
            }], changePage: [{
                type: Output
            }] } });

class DgTablePaginatorDirective {
    constructor(host) {
        this.host = host;
    }
    ngOnInit() {
        this.dynamicTable.observables.pagination.subscribe(pagination => {
            this.host.pageIndex = Number(pagination.page);
            this.host.pageSize = Number(pagination.size);
            this.host.totalPages = pagination.totalPages;
            this.host.totalElements = pagination.totalElements;
        });
    }
    changePage(ev) {
        this.dynamicTable.controls.pagination.set({
            page: ev.pageIndex,
            size: ev.pageSize,
        });
    }
}
DgTablePaginatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTablePaginatorDirective, deps: [{ token: DgPaginatorComponent }], target: i0.ɵɵFactoryTarget.Directive });
DgTablePaginatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DgTablePaginatorDirective, selector: "dg-paginator[dg-dynamic-paginator]", inputs: { dynamicTable: "dynamicTable" }, host: { listeners: { "changePage": "changePage($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTablePaginatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'dg-paginator[dg-dynamic-paginator]'
                }]
        }], ctorParameters: function () { return [{ type: DgPaginatorComponent }]; }, propDecorators: { dynamicTable: [{
                type: Input,
                args: ['dynamicTable']
            }], changePage: [{
                type: HostListener,
                args: ['changePage', ['$event']]
            }] } });

class CdkDynamicTableModule {
}
CdkDynamicTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CdkDynamicTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableModule, declarations: [DgTableMaterialDataDirective,
        DgTableColumnTemplateDirective,
        DgTableHeaderTemplateDirective,
        DgTableActionsTemplateDirective,
        DgDynamicTableDirective,
        DgTableMaterialPaginatorDirective,
        DgTablePaginatorDirective], imports: [CommonModule], exports: [DgTableMaterialDataDirective,
        DgTableColumnTemplateDirective,
        DgTableHeaderTemplateDirective,
        DgTableActionsTemplateDirective,
        DgDynamicTableDirective,
        DgTableMaterialPaginatorDirective,
        DgTablePaginatorDirective] });
CdkDynamicTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgTableMaterialDataDirective,
                        DgTableColumnTemplateDirective,
                        DgTableHeaderTemplateDirective,
                        DgTableActionsTemplateDirective,
                        DgDynamicTableDirective,
                        DgTableMaterialPaginatorDirective,
                        DgTablePaginatorDirective,
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        DgTableMaterialDataDirective,
                        DgTableColumnTemplateDirective,
                        DgTableHeaderTemplateDirective,
                        DgTableActionsTemplateDirective,
                        DgDynamicTableDirective,
                        DgTableMaterialPaginatorDirective,
                        DgTablePaginatorDirective,
                    ]
                }]
        }] });

class ConfigDynamicTable {
    static get() {
        return ConfigDynamicTable.configs;
    }
    static set(d) {
        if (d === null || d === void 0 ? void 0 : d.apiData) {
            this.configs.apiData = Object.assign(Object.assign({}, this.configs.apiData), d.apiData);
        }
        if (d === null || d === void 0 ? void 0 : d.actions)
            this.configs.actions = d.actions;
    }
}
ConfigDynamicTable.configs = {
    // objeto com dados de conexão com o back-end para realizar o request
    apiData: {
        path: '',
        context: '',
        inputPipe: (resp) => resp.data,
        inputPaginationPipe: resp => {
            const _a = resp.page, { number } = _a, rest = __rest(_a, ["number"]);
            return Object.assign({ page: number }, rest);
        },
    },
    // conjunto de actions padrão do sistema
    actions: {},
};

class AbstractDynamicTableData {
    constructor(_root) {
        this._root = _root;
        this.typeTable = "array";
        this.dataSource = [];
        this.dispacherChanges = (data) => { };
    }
    registerDispacher(ev) {
        this.dispacherChanges = ev;
        ev(this.dataSource);
    }
}

/**
 * Função para buscar dentro de um array de objetos o "atributeName" e gerar um novo
 * nnumero diferente de todos os existentes
 * @param objectArray
 * @param atributeName
 * @constructor
 */
function UnidIdListObjects(objectArray, atributeName = 'dynamicFakeId') {
    let tentativaFakeId;
    do {
        // Gera um fakeId aleatório com até 5 dígitos
        tentativaFakeId = Math.floor(Math.random() * 100000).toString().padStart(5, '0');
    } while (objectArray.some(objeto => objeto[atributeName] === tentativaFakeId));
    return tentativaFakeId;
}
/**
 * Função que percorre um array de objetos adicionando um "fakeId" em todos os objetos com o
 * nome do "atributeName" informado
 * @param objectArray
 * @param atributeName
 * @param onlyIfIsNotExist
 */
function addFakeIdInListObject(objectArray, atributeName = 'dynamicFakeId', onlyIfIsNotExist = false) {
    for (const objectArrayKey in objectArray) {
        if (onlyIfIsNotExist) {
            if (!(atributeName in objectArray[objectArrayKey])) {
                objectArray[objectArrayKey][atributeName] = UnidIdListObjects(objectArray);
            }
        }
        else {
            objectArray[objectArrayKey][atributeName] = UnidIdListObjects(objectArray);
        }
    }
    return objectArray;
}

class DynamicTableArray extends AbstractDynamicTableData {
    constructor(root) {
        super(root);
        this.root = root;
        /**
         * atribudo que guarda todos os registros existentes no array.
         * a partir desses dados serão selecionados os dados de apresentação
         * da tabela considerando os filtros e a paginação atual.
         * @private
         */
        this.data = [];
    }
    find() {
        let data = this._sort(this.filter(this.data));
        let dataResult = data.slice(Number(this.root.getPagination().page) * Number(this.root.getPagination().size), (Number(this.root.getPagination().page) + 1) * Number(this.root.getPagination().size));
        this.root.setPagination({
            totalElements: this.data.length,
            totalPages: Math.ceil(this.data.length / Number(this.root.getPagination().size))
        }, { find: false });
        this.dataSource = [...dataResult];
        this.root.changes.dataSource.next({ type: 'end', data: this.dataSource });
        this.root.changes.loader.next(false);
    }
    get() {
        return JSON.parse(JSON.stringify(this.data));
    }
    set(data) {
        this.data = addFakeIdInListObject(data);
    }
    getItem(index) {
        return 'ainda não';
    }
    setItem(data) {
        this.data = addFakeIdInListObject([...this.data, data]);
        if (this.data.length <= Number(this.root.getPagination().size)) {
            this.find();
        }
    }
    removeItem(fakeIdOrIndex, typeKey) {
        if (typeKey == 'index') {
            this.data.splice(Number(fakeIdOrIndex), 1);
        }
        else {
            const index = this.data.findIndex(item => (item === null || item === void 0 ? void 0 : item.dynamicFakeId) == fakeIdOrIndex);
            if (index != -1) {
                this.data.splice(index, 1);
            }
        }
        this.root.changes.dataSource.next({ type: 'start', data: this.dataSource });
        this.find();
    }
    /**
     * Ordenação da tabela
     * @param data
     * @private
     */
    _sort(data) {
        const sorts = this.root.getPagination().sort.map(sort => {
            const [columnName, order] = sort.split(',');
            return { column: columnName, order: order.toUpperCase() };
        });
        let sortedData = [...data];
        // A ordenação é revertida para manter a ordem dos ordenadores do mais antugo para o mais novo
        sorts.reverse().forEach(({ column, order }) => {
            sortedData.sort((v1, v2) => {
                const valor1 = this._executSortFunc(column, v1[column], v1);
                const valor2 = this._executSortFunc(column, v2[column], v2);
                if (valor1 == null || valor2 == null) {
                    return 0;
                }
                if (typeof valor1 === 'string' && typeof valor2 === 'string') {
                    return order === 'DESC'
                        ? valor2.localeCompare(valor1)
                        : valor1.localeCompare(valor2);
                }
                const comparison = valor1 < valor2 ? -1 : valor1 > valor2 ? 1 : 0;
                return order === 'DESC' ? -comparison : comparison;
            });
        });
        return sortedData;
    }
    _executSortFunc(columnName, val, row) {
        const column = this.root.getColumn(columnName);
        if (column && typeof column !== 'string' && column.sortFunc) {
            return column.sortFunc(val, row);
        }
        return val;
    }
    filter(data) {
        var _a;
        const filters = this.root.params();
        let result = data;
        const objFilters = ((_a = this.root.filters) === null || _a === void 0 ? void 0 : _a.controls.filters.getFiltersObj()) || {};
        if (Object.keys(filters).length < 1)
            return result;
        Object.keys(filters).map(filterKey => {
            const filterValue = filters[filterKey];
            // verificação especial para multiplos dados
            if (Array.isArray(filterValue)) {
                if (filterValue.length < 1)
                    return;
                if (filterValue.every((val) => typeof val === 'string' || typeof val === 'number')) {
                    result = result.filter(item => {
                        if (filterKey in objFilters) {
                            if (!!objFilters[filterKey].pipeFilterArray) {
                                const pipeFilterArray = objFilters[filterKey].pipeFilterArray;
                                return filterValue.includes(pipeFilterArray(item[filterKey], item));
                            }
                        }
                        return filterValue.includes(item[filterKey]);
                    });
                }
                else {
                    result = result.filter(item => JSON.stringify(item[filterKey]) == JSON.stringify(filterValue));
                }
            }
            else {
                // verificação direta de dados
                result = result.filter(item => {
                    // verifica se existe metodo "pipeFilterArray" ecaso exista aplica função
                    // para ajustar os dados antes da verificação
                    if (filterKey in objFilters) {
                        if (!!objFilters[filterKey].pipeFilterArray) {
                            const pipeFilterArray = objFilters[filterKey].pipeFilterArray;
                            return this.verifyMatch(pipeFilterArray(item[filterKey], item), filterValue);
                        }
                    }
                    return this.verifyMatch(item[filterKey], filterValue);
                });
            }
        });
        return result;
    }
    verifyMatch(tableValue, filterValue) {
        if (typeof tableValue == 'string') {
            return String(clearString((tableValue || '')).toUpperCase())
                .includes(clearString(filterValue).toUpperCase());
        }
        else if (typeof tableValue == 'number') {
            return tableValue == filterValue;
        }
        return JSON.stringify(tableValue) == JSON.stringify(filterValue);
    }
}

class DynamicTableRequest extends AbstractDynamicTableData {
    constructor(root, http, server) {
        super(root);
        this.root = root;
        this.http = http;
        this.server = server;
    }
    setServer(server) {
        this.server = Object.assign(Object.assign({}, this.server), server);
    }
    find(rootParams) {
        var _a, _b;
        if (!!this.request) {
            this.request.unsubscribe();
            this.request = undefined;
        }
        const rooPagination = this.root.getPagination();
        let pagination = rooPagination;
        let params = this.root.params();
        if (!!((_a = this.root.apiData) === null || _a === void 0 ? void 0 : _a.outputPaginationPipe)) {
            pagination = this.root.apiData.outputPaginationPipe(this.root.getPagination());
        }
        this.request = this.http.get(this.server.path + this.server.context, {
            params: Object.assign(Object.assign(Object.assign(Object.assign({}, pagination), params), (((_b = this.server) === null || _b === void 0 ? void 0 : _b.params) || {})), (rootParams || {}))
        }).subscribe((resp) => {
            var _a, _b;
            let resultDataSource = !!((_a = this.root.apiData) === null || _a === void 0 ? void 0 : _a.inputPipe)
                ? this.root.apiData.inputPipe(resp) : resp;
            this.dataSource = addFakeIdInListObject(resultDataSource);
            this.root.changes.dataSource.next({ type: 'end', data: this.dataSource });
            this.root.changes.loader.next(false);
            if (!((_b = this.root.apiData) === null || _b === void 0 ? void 0 : _b.inputPaginationPipe)) {
                throw 'Ajsute o pipe de paginação (pipePagination), a DynamicTable esperava coletar os dados de paginação' +
                    ' com esse recurso. A falta desse recurso implica na incapacidade de paginar os dados';
            }
            const resultPipePagination = this.root.apiData.inputPaginationPipe(resp);
            if (resultPipePagination['page'] == undefined ||
                resultPipePagination['page'] == null ||
                resultPipePagination['totalPages'] == undefined ||
                resultPipePagination['totalPages'] == null) {
                throw 'O pipePagination não conseguiu extrair os dados basicos (page, totalPages) para realizar as' +
                    ' alterações de paginação, favor reveja seu pipe de paginação para extrair essas informações.';
            }
            this.root.setPagination(resultPipePagination, { find: false });
        });
    }
    get() {
        return JSON.parse(JSON.stringify(this.dataSource));
    }
    getItem(index) {
    }
    /**
     * @deprecated
     * Não existe implementação de set em tabelas de request
     * @param index
     */
    set(data) {
        this.dataSource = addFakeIdInListObject(data);
        this.root.changes.dataSource.next({ type: 'end', data: this.dataSource });
        this.root.changes.loader.next(false);
    }
    removeItem(fakeIdOrIndex, typeKey) {
        if (typeKey == 'index') {
            this.dataSource.splice(Number(fakeIdOrIndex), 1);
        }
        else {
            const index = this.dataSource.findIndex(item => (item === null || item === void 0 ? void 0 : item.dynamicFakeId) == fakeIdOrIndex);
            if (index != -1) {
                this.dataSource.splice(index, 1);
            }
        }
        this.root.changes.dataSource.next({ type: 'end', data: this.dataSource });
    }
    /**
     * @deprecated
     * Não existe implementação de set em tabelas de request
     * @param index
     */
    setItem(data) {
    }
    changeServer(value) {
        this.server = Object.assign(Object.assign({}, this.server), value);
    }
}

class DynamicGroupClass {
    constructor(group, config) {
        this.group = group;
        // Variavel de controle de busca. Caso esteja ativo irá chamar o find sempre
        // que houver uma mudança, caso não aguardará o chamado do find
        this.reactive = false;
        // metodo final de saída de dados, é usado para fazer uma última verificação
        // com todos os dados antes do envio
        this.outPutParams = val => val;
        // valores de parametros registrados
        this.values = {};
        this._filters = new Map();
        this.timoutClear = null;
        /**
         * Atributo coringa para conter dados de apresentação do filtro.
         * Use para salvar opções que podem não estar na tela quando essa for atualizada.
         *
         * Exemplo:
         * Fiz isso, pois preciso carregar as opções de selecionadas no autocomplete quando esse for do tipo "outside".
         */
        this.opitionalData = undefined;
        this.functionsEventListner = {
            directiveFindInstance: (e) => {
                if (e.detail.group != this.group)
                    return;
                console.log('connect group', this.group);
                this.sendInstanceToDirective();
            },
            serviceFindInstance: (e) => {
                if (e.detail.group != this.group)
                    return;
                this.sendInstanceToService(e.detail);
            },
            controlClear: (e) => {
                if (e.detail.group != this.group)
                    return;
                if (this.timoutClear) {
                    clearTimeout(this.timoutClear);
                }
                this.timoutClear = setTimeout(() => this.controls.values.clearAll(), 100);
            },
            controlFilter: (e) => {
                if (e.detail.group != this.group)
                    return;
                console.log('coletando grupo', this.group);
                if (this.timoutClear) {
                    clearTimeout(this.timoutClear);
                }
                this.timoutClear = setTimeout(() => this.sends.filter(), 100);
            }
        };
        /**##############################################
         * ## OBSERVABLES
         ##############################################*/
        this.rootObservables = {
            sendFilter: new ReplaySubject(),
            clearFilter: new ReplaySubject(),
            change: new ReplaySubject(),
            all: new ReplaySubject(),
        };
        this.observables = {
            sendFilter: this.rootObservables.sendFilter.asObservable(),
            clearFilter: this.rootObservables.clearFilter.asObservable(),
            change: this.rootObservables.change.asObservable(),
            all: this.rootObservables.all.asObservable(),
        };
        /**##############################################
         * ## DIAPARADORES DE OBSERVABLES
         ##############################################*/
        this.sends = {
            clear: () => {
                const dataObservable = {
                    from: 'clear',
                    value: undefined,
                    allRawValues: this.controls.values.getRaw(),
                    allValues: this.controls.values.get()
                };
                this.rootObservables.all.next(dataObservable);
                this.rootObservables.clearFilter.next(dataObservable);
            },
            filter: () => {
                const dataObservable = {
                    from: 'filter',
                    value: undefined,
                    allRawValues: this.controls.values.getRaw(),
                    allValues: this.controls.values.get()
                };
                this.rootObservables.all.next(dataObservable);
                this.rootObservables.sendFilter.next(dataObservable);
            },
            change: (from, value) => {
                const dataObservable = {
                    from: from,
                    value: value,
                    allRawValues: this.controls.values.getRaw(),
                    allValues: this.controls.values.get()
                };
                this.rootObservables.all.next(Object.assign(Object.assign({}, dataObservable), { from: 'change' }));
                this.rootObservables.change.next(dataObservable);
            }
        };
        /**##############################################
         * ## METODOS DE MANIPULAÇÃO DO INPUT
         ##############################################*/
        this._controls = {
            refreshValues: () => {
                this.values = this.controls.values.getRaw();
            },
            executClear: () => {
                if (!!this.functionClear) {
                    if (typeof this.functionClear == 'function') {
                        return this.functionClear();
                    }
                    return this.functionClear;
                }
                return {};
            }
        };
        this.controls = {
            filters: {
                set: (key, filter) => {
                    this._filters.set(key, {
                        reactive: !!filter.reactive,
                        findFunc: !!filter.findFunc ? filter.findFunc : val => { return { [key]: val }; },
                        data: filter.data != undefined ? filter.data : null,
                        pipeFilterArray: filter === null || filter === void 0 ? void 0 : filter.pipeFilterArray
                    });
                },
                setObject: (filters) => {
                    const filtersKey = Object.keys(filters);
                    if (filtersKey.length > 0) {
                        filtersKey.map(key => {
                            this.controls.filters.set(key, filters[key]);
                        });
                    }
                },
                update: (key, filter) => {
                    const currentValue = this._filters.get(key);
                    if (!!currentValue) {
                        this._filters.set(key, Object.assign(Object.assign({}, currentValue), filter));
                    }
                },
                delete: (key) => {
                    if (typeof key == "string") {
                        this._filters.delete(key);
                        return;
                    }
                    key.map(k => this._filters.delete(k));
                },
                getFilters: (typeReturn = "object") => {
                    if (typeReturn == 'object') {
                        const result = {};
                        Array.from(this._filters).map((key) => {
                            result[key[0]] = key[1];
                        });
                        return result;
                    }
                    else if (typeReturn == 'array') {
                        return Array.from(this._filters).map((key) => key);
                    }
                    return this._filters;
                },
                getFiltersObj: () => {
                    const result = {};
                    Array.from(this._filters).map((key) => {
                        result[key[0]] = key[1];
                    });
                    return result;
                }
            },
            values: {
                /**
                 * Setar valores nos registros existentes.
                 * @param values
                 */
                patchValue: (values) => {
                    Object.keys(values).map(key => {
                        const currentValue = this._filters.get(key);
                        if (!currentValue) {
                            this._filters.set(key, {
                                data: values[key],
                                findFunc: v => { return { [key]: v }; }
                            });
                        }
                        else {
                            this._filters.set(key, Object.assign(Object.assign({}, (currentValue || {})), { data: values[key] }));
                        }
                        this._controls.refreshValues();
                        this.sends.change(key, values[key]);
                    });
                    this._controls.refreshValues();
                },
                get: () => {
                    let result = {};
                    const values = this.controls.values.getRaw();
                    Object.keys(values).map((keyParam) => {
                        if (!values[keyParam])
                            return;
                        const filter = this._filters.get(keyParam);
                        if (!!filter) {
                            const resultFilter = filter.findFunc(values[keyParam]);
                            if (typeof resultFilter == 'object' && !Array.isArray(resultFilter)) {
                                result = Object.assign(Object.assign({}, result), resultFilter);
                            }
                            else {
                                result[keyParam] = 'resultFilter';
                            }
                        }
                        else {
                            result[keyParam] = values[keyParam];
                        }
                    });
                    return result;
                },
                getRaw: () => {
                    let result = {};
                    Array.from(this._filters).map((key) => {
                        const resultFilter = key[1].data;
                        if (!!resultFilter) {
                            if (typeof resultFilter == 'object' && !Array.isArray(resultFilter)) {
                                result = Object.assign(Object.assign({}, result), (key[1].data));
                            }
                            else {
                                result[key[0]] = key[1].data;
                            }
                        }
                        else {
                            result[key[0]] = '';
                        }
                    });
                    return result;
                },
                clearAll: () => {
                    let defaultData = this._controls.executClear();
                    Array.from(this._filters).map((key) => {
                        let data = null;
                        if (key[0] in defaultData) {
                            data = { [key[0]]: defaultData[key[0]] };
                        }
                        this._filters.set(key[0], Object.assign(Object.assign({}, key[1]), { data: data }));
                    });
                    this._controls.refreshValues();
                    this.sends.clear();
                }
            },
            setClearFunctions: (clear) => {
                this.functionClear = clear;
            },
            optionalData: {
                get: (name) => { var _a; return ((_a = this.opitionalData) === null || _a === void 0 ? void 0 : _a[name]) || undefined; },
                set: (name, value) => {
                    if (!this.opitionalData) {
                        this.opitionalData = {};
                    }
                    this.opitionalData[name] = value;
                },
                clearAll: () => this.opitionalData = undefined,
                getAll: () => this.opitionalData,
                setAll: (value) => this.opitionalData = value,
            }
        };
        if (!!(config === null || config === void 0 ? void 0 : config.outPutParams))
            this.outPutParams = config.outPutParams;
        if ((config === null || config === void 0 ? void 0 : config.reactive) != undefined)
            this.reactive = config.reactive;
        if (!!(config === null || config === void 0 ? void 0 : config.filters))
            this.controls.filters.setObject(config.filters);
        if (!!(config === null || config === void 0 ? void 0 : config.clear))
            this.controls.setClearFunctions(config === null || config === void 0 ? void 0 : config.clear);
        /**
         * recebendo o pedido do input para se conectar no grupo
         */
        window.addEventListener('dynamic-group-directive-find-instance', this.functionsEventListner.directiveFindInstance, true);
        /**
         * recebendo o pedido do service(angular) para acessar instancia do grupo
         */
        window.addEventListener('dynamic-group-service-find-instance', this.functionsEventListner.serviceFindInstance, true);
        /**
         * recebendo pedido de limpeza dos dados de filters
         */
        window.addEventListener('dynamic-group-control-clear', this.functionsEventListner.controlClear, true);
        /**
         * recebendo pedido de filtragem dos dados
         */
        window.addEventListener('dynamic-group-control-filter', this.functionsEventListner.controlFilter, true);
        this._controls.refreshValues();
        this.sendInstanceToDirective();
    }
    destroy() {
        window.removeEventListener('dynamic-group-directive-find-instance', this.functionsEventListner.directiveFindInstance, true);
        window.removeEventListener('dynamic-group-service-find-instance', this.functionsEventListner.serviceFindInstance, true);
        window.removeEventListener('dynamic-group-control-clear', this.functionsEventListner.controlClear, true);
        window.removeEventListener('dynamic-group-control-filter', this.functionsEventListner.controlFilter, true);
    }
    /**##############################################
     * ## METODOS DE CONEXÃO
     ##############################################*/
    // envia um evento com dados de subscrição para os inputs se conectarem
    // Esse envio ocorre no início pos os pedidos feitos antes da criação
    // não foram atendidos, ou quando um input solicita conexão
    sendInstanceToDirective() {
        window.dispatchEvent(new CustomEvent('dp-directive-receive-instance', { detail: this }));
    }
    // envia um evento com a instância requerida e uma chave identificadora recebida e será comparada
    // no metodo que o chamou.
    // esse evento ocorrerá apenas quando solicitado
    sendInstanceToService(ev) {
        window.dispatchEvent(new CustomEvent('dynamic-group-class-find-service', {
            detail: Object.assign(Object.assign({}, ev), { instance: this })
        }));
    }
    /**
     * METODOS ESTATICOS
     * Usados para realizar pedido de conexão externa a instância desejada.
     */
    static dispacherFilter(group) {
        window.dispatchEvent(new CustomEvent('dynamic-group-control-filter', { detail: { group } }));
    }
    static dispacherClear(group) {
        window.dispatchEvent(new CustomEvent('dynamic-group-control-clear', { detail: { group } }));
    }
    static findInstance(group) {
        window.dispatchEvent(new CustomEvent('dynamic-group-directive-find-instance', { detail: { group } }));
    }
    static serviceFindInstance(group, keyPort) {
        window.dispatchEvent(new CustomEvent('dynamic-group-service-find-instance', {
            detail: { group, keyPort }
        }));
    }
}

var CdkDynamicGroup;
(function (CdkDynamicGroup) {
    /**
     * Metodo de criação da dynamic-group.
     * @param group
     * @param config
     */
    function newClass(group, config) {
        return new DynamicGroupClass(group, config);
    }
    CdkDynamicGroup.newClass = newClass;
})(CdkDynamicGroup || (CdkDynamicGroup = {}));

class QueryParamsGroup {
    constructor(configs) {
        this.encript = true;
        this.group = '';
        this.save = true;
        this.encript = (configs === null || configs === void 0 ? void 0 : configs.encrypt) == undefined ? true : configs.encrypt;
        this.group = configs.group;
        this.save = !!(configs === null || configs === void 0 ? void 0 : configs.save);
    }
    /**
     * Busca parametros existentes na url
     * @private
     */
    getQueryParams() {
        const queryString = window.location.search.substring(1);
        const params = {};
        const queries = queryString.split("&");
        queries.forEach((query) => {
            const [key, value] = query.split("=");
            if (key) {
                params[key] = decodeURIComponent(value);
            }
        });
        return params;
    }
    /**
     * Atualiza valores na URL
     * @param data
     * @private
     */
    updateQueryParams(data) {
        const params = this.getQueryParams();
        if (data !== null) {
            params[this.group] = data;
        }
        else {
            delete params[this.group];
        }
        const newQueryString = Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join("&");
        const newUrl = !!newQueryString ? `${window.location.pathname}?${newQueryString}` : window.location.pathname;
        window.history.replaceState({}, "", newUrl);
    }
    encriptData(data) {
        if (!!data) {
            return btoa(JSON.stringify(data));
        }
        return '';
    }
    decriptData(data) {
        if (!!data) {
            return JSON.parse(atob(data));
        }
        return {};
    }
    getParams() {
        const params = this.getQueryParams();
        if (this.group in params) {
            return this.encript ? this.decriptData(params[this.group]) : JSON.parse(params[this.group]);
        }
        return {};
    }
    setParam(attrGroup, value) {
        let data = this.getParams();
        if (!!value) {
            data = Object.assign(Object.assign({}, (data || {})), { [attrGroup]: !!value ? value : null });
        }
        if (!value && attrGroup in data) {
            delete data[attrGroup];
        }
        if (Object.keys(data).length <= 0) {
            data = null;
        }
        else {
            data = this.encript ? this.encriptData(data) : JSON.stringify(data);
        }
        this.updateQueryParams(data);
    }
    setParams(params) {
        let data = this.getParams();
        if (Object.keys(params).length > 0) {
            data = Object.assign(Object.assign({}, (data || {})), (params || {}));
        }
        Object.keys(data).map(key => {
            if (!data[key] && data[key] != 0) {
                delete data[key];
            }
            else if (Array.isArray(data[key])) {
                if (data[key].length == 0) {
                    delete data[key];
                }
            }
            else if (typeof data[key] == 'object') {
                if (data[key].length == 0) {
                    delete data[key];
                }
            }
        });
        if (Object.keys(data).length <= 0) {
            data = null;
        }
        else {
            data = this.encript ? this.encriptData(data) : JSON.stringify(data);
        }
        this.updateQueryParams(data);
    }
    clearAll() {
        this.updateQueryParams(null);
    }
}

var DynamicQueryParams;
(function (DynamicQueryParams) {
    function group(configs) {
        return new QueryParamsGroup(configs);
    }
    DynamicQueryParams.group = group;
})(DynamicQueryParams || (DynamicQueryParams = {}));

class DynamicTableClass {
    constructor(typeTable, configs, http) {
        var _a, _b, _c, _d;
        // tipo de tabela
        this.typeTable = 'array';
        // dados de reset da paginação da tabela, esse atributo atualizado
        // sempre com os dados iniciais de paginação da tavela
        this._rootPagination = {
            typePagination: 'SINGLE',
            size: 10,
            page: 0,
            sort: ['id,asc'],
            totalElements: 0,
            totalPages: 0
        };
        // dados reais da paginação da tabela
        this.rootPagination = {
            typePagination: 'SINGLE',
            size: 10,
            page: 0,
            sort: ['id,asc'],
            totalElements: 0,
            totalPages: 0
        };
        // permite ou não a ordenação total, ou parcial
        this.sort = false;
        this.rootParams = {};
        this.rootColumns = [];
        this.actionList = new Map();
        /**######################################################
         * Observables
         ######################################################*/
        this.changes = {
            columns: new BehaviorSubject(this.rootColumns),
            pagination: new BehaviorSubject(this.rootPagination),
            dataSource: new Subject(),
            sortList: new BehaviorSubject(false),
            actions: new BehaviorSubject({}),
            loader: new BehaviorSubject(true)
        };
        this.observables = {
            columns: this.changes.columns.asObservable(),
            dataSource: this.changes.dataSource.asObservable(),
            pagination: this.changes.pagination.asObservable(),
            sortList: this.changes.sortList.asObservable(),
            actions: this.changes.actions.asObservable(),
            loader: this.changes.loader.asObservable(),
            filters: () => {
                if (!this.group)
                    return;
                return this.group.observables;
            },
        };
        // @ts-ignore
        /**######################################################
         * Controles de acesso aos metodos e classes da dynamicTable.
         *
         * Os controles são divididos em grupos por responsabilidades
         ######################################################*/
        this.controls = {
            /**
             * Controles dos filtros.
             * Esse controle é feito por meio da DynamicGroup
             */
            filters: {
                start: (key, config) => {
                    var _a;
                    this.group = CdkDynamicGroup.newClass(key, config);
                    this.rootParams = ((_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.values.get()) || {};
                    this.onSubscribeGroup = this.group.observables.all.subscribe(resp => {
                        var _a, _b;
                        this.rootParams = ((_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.values.get()) || {};
                        if (((_b = this.group) === null || _b === void 0 ? void 0 : _b.reactive) || resp.from == 'filter' || resp.from == 'clear') {
                            // O "find()" executado será disparado pelo "pagination.set"
                            this.controls.pagination.set({ page: 0 });
                            // this.controls.data.find()
                        }
                    });
                },
                restart: () => {
                    var _a;
                    if (!((_a = this.group) === null || _a === void 0 ? void 0 : _a.group))
                        return;
                    this.controls.filters.start(this.group.group || this.tableKey, this.group);
                },
                set: (key, filter) => { var _a; return (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.filters.set(key, filter); },
                setObject: (filters) => { var _a; return (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.filters.setObject(filters); },
                update: (key, filter) => { var _a; return (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.filters.update(key, filter); },
                delete: (key) => { var _a; return (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.filters.delete(key); },
                patchValue: (values) => {
                    var _a;
                    (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.values.patchValue(values);
                },
                setClearFunctions: (clear) => {
                    var _a;
                    (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.setClearFunctions(clear);
                },
                getFilters: (typeReturn) => { var _a; return (_a = this.group) === null || _a === void 0 ? void 0 : _a.controls.filters.getFilters(typeReturn); }
            },
            /**
             * Controles de dados para alterar dados da apiData.
             * Esse campo só terá funcionará em tabelas do tipo REQUEST
             */
            apiData: {
                get: () => {
                    if (!(this.data instanceof DynamicTableRequest)) {
                        return undefined;
                    }
                    return this.data.server;
                },
                set: (value) => {
                    if (!(this.data instanceof DynamicTableRequest)) {
                        return undefined;
                    }
                    this.data.changeServer(value);
                },
                params: {
                    remove: (keys) => {
                        if (!(this.data instanceof DynamicTableRequest)) {
                            return;
                        }
                        const apiData = this.controls.apiData.get() || {};
                        if (Object.keys(apiData.params || {}).length <= 0)
                            return;
                        keys.map(key => {
                            if (key in apiData.params) {
                                delete apiData.params[key];
                            }
                        });
                        this.data.changeServer(apiData);
                    },
                    resete: (newValues) => {
                        if (!(this.data instanceof DynamicTableRequest)) {
                            return;
                        }
                        const apiData = this.controls.apiData.get() || {};
                        apiData['params'] = newValues || {};
                        this.data.changeServer(apiData);
                    },
                }
            },
            /**
             * Controle de actions
             */
            actions: {
                get: () => {
                    // const result = Array.from(this.actionList.values());
                    var result = {};
                    this.actionList.forEach(function (key, index) {
                        result[index] = key;
                    });
                    return result;
                },
                getOne: (key) => this.actionList.get(key),
                set: (key, action) => {
                    if (!!action.dbClick) {
                        this.controls.actions.removeAllDbClick();
                    }
                    this.actionList.set(key, action);
                    this.changes.actions.next(this.controls.actions.get());
                },
                setObject: (objectActions) => {
                    const actionsKey = Object.keys(objectActions);
                    if (actionsKey.length > 0) {
                        actionsKey.map(key => {
                            this.controls.actions.set(key, objectActions[key]);
                        });
                        this.changes.actions.next(this.controls.actions.get());
                    }
                },
                update: (key, action) => {
                    const currentAction = this.actionList.get(key);
                    if (!currentAction) {
                        throw 'Ação não encontrada';
                    }
                    if (!!action.dbClick) {
                        this.controls.actions.removeAllDbClick();
                    }
                    this.actionList.set(key, Object.assign(Object.assign({}, currentAction), action));
                    this.changes.actions.next(this.controls.actions.get());
                },
                delete: (key) => this.actionList.delete(key),
                deleteAll: () => {
                    this.actionList = new Map();
                },
                removeAllDbClick: () => {
                    Array.from(this.actionList.keys()).map(key => {
                        this.actionList.set(key, Object.assign(Object.assign({}, (this.actionList.get(key) || {})), { dbClick: false }));
                    });
                }
            },
            /**
             * Controles de columns
             */
            columns: {
                get: () => this.rootColumns,
                getOne: (key) => {
                    const index = this.rootColumns.findIndex(item => {
                        if (typeof item == 'string') {
                            return item == key;
                        }
                        return item.name == key;
                    });
                    if (index == -1) {
                        return null;
                    }
                    return this.rootColumns[index];
                },
                set: (actions) => {
                    this.rootColumns = [
                        ...this.rootColumns,
                        ...actions
                    ];
                    this.changes.columns.next(this.controls.columns.get());
                },
                update: (key, action) => {
                    const index = this.rootColumns.findIndex(item => {
                        if (typeof item == 'string') {
                            return item == key;
                        }
                        return item.name == key;
                    });
                    if (index == -1) {
                        throw 'Não foi possível encontrar a column ' + key;
                    }
                    if (typeof action == 'string') {
                        this.rootColumns[index] = action;
                        this.changes.columns.next(this.controls.columns.get());
                        return;
                    }
                    if (typeof this.rootColumns[index] == 'string') {
                        this.rootColumns[index] = Object.assign({ 
                            // @ts-ignore
                            name: this.rootColumns[index], 
                            // @ts-ignore
                            headerName: this.rootColumns[index] }, (action || {}));
                        this.changes.columns.next(this.controls.columns.get());
                        return;
                    }
                    this.rootColumns[index] = Object.assign(Object.assign({}, (this.rootColumns[index] || {})), action);
                    this.changes.columns.next(this.controls.columns.get());
                    return;
                },
                remove: (key) => {
                    const index = this.rootColumns.findIndex(item => {
                        if (typeof item == 'string') {
                            return item == key;
                        }
                        return item.name == key;
                    });
                    if (index != -1) {
                        this.rootColumns.splice(index, 1);
                    }
                    this.changes.columns.next(this.controls.columns.get());
                },
                removeAll: () => {
                    this.rootColumns = [];
                    this.changes.columns.next(this.controls.columns.get());
                },
                visible: (visible, columns) => {
                    let columnList = [];
                    if (!columns) {
                        columnList = this.rootColumns;
                    }
                    else {
                        columnList = columns;
                    }
                    columnList.map((item) => {
                        let name = '';
                        if (typeof item == "string") {
                            name = item;
                        }
                        else {
                            name = item.name || '';
                        }
                        if (!name)
                            return;
                        this.controls.columns.update(name, { visible });
                    });
                },
                reorderBKP: (columns) => {
                    const restReorder = [];
                    const newColumns = columns.map(columnRoot => this.rootColumns.find(columnNewOrder => {
                        let nameRoot = typeof columnRoot == 'string' ? columnRoot : columnRoot.name;
                        let nameNewOrder = typeof columnNewOrder == 'string' ? columnNewOrder : columnNewOrder.name;
                        if (nameRoot === nameNewOrder) {
                            return columnRoot;
                        }
                        restReorder.push(columnRoot);
                        return false;
                    }));
                },
                reorder: (columns) => {
                    const newColumns = columns.map(columnRoot => this.rootColumns.find(columnNewOrder => {
                        let nameRoot = typeof columnRoot == 'string' ? columnRoot : columnRoot.name;
                        let nameNewOrder = typeof columnNewOrder == 'string' ? columnNewOrder : columnNewOrder.name;
                        if (nameRoot === nameNewOrder) {
                            return columnRoot;
                        }
                        return false;
                    })).filter(column => !!column);
                    const restReorder = [];
                    this.rootColumns.map(columnRoot => {
                        const nameColumnRoot = typeof columnRoot == 'string' ? columnRoot : columnRoot.name;
                        const index = newColumns.findIndex((itemColumnNewOrder => {
                            const nameItemColumnNewOrder = typeof itemColumnNewOrder == 'string' ? itemColumnNewOrder : itemColumnNewOrder === null || itemColumnNewOrder === void 0 ? void 0 : itemColumnNewOrder.name;
                            return nameItemColumnNewOrder == nameColumnRoot;
                        }));
                        if (index == -1) {
                            restReorder.push(columnRoot);
                        }
                        return false;
                    }).filter(item => item);
                    this.rootColumns = [
                        ...newColumns,
                        ...restReorder
                    ];
                    this.changes.columns.next(this.controls.columns.get());
                },
                sort: (sort) => {
                    this.sort = sort;
                    this.changes.sortList.next(this.sort);
                }
            },
            /**
             * Controles de paginação
             */
            pagination: {
                get: () => this.rootPagination,
                set: (pagination, config) => {
                    const _config = Object.assign({ emitteEvent: true, find: true }, config);
                    if ('size' in pagination) {
                        if (pagination['size'] != this.rootPagination.size) {
                            this.rootPagination.page = 0;
                            pagination['page'] = pagination['page'] || 0;
                        }
                    }
                    this.rootPagination = Object.assign(Object.assign({}, this.rootPagination), pagination);
                    if (_config.emitteEvent) {
                        this.changes.pagination.next(this.rootPagination);
                    }
                    if (_config.find) {
                        this.controls.data.find();
                    }
                },
                reset: (config) => {
                    const _config = Object.assign({ emitteEvent: true, find: true }, config);
                    this.rootPagination = JSON.parse(JSON.stringify(this._rootPagination));
                    if (_config.emitteEvent) {
                        this.changes.pagination.next(this.rootPagination);
                    }
                    if (_config.find) {
                        this.controls.data.find();
                    }
                },
                setDefault: (pagination) => {
                    this._rootPagination = Object.assign(Object.assign({}, this._rootPagination), pagination);
                },
            },
            /**
             * Controles de para acesso ao gerenciador de dados
             */
            data: {
                timoutFindRequest: null,
                dataSource: [],
                get: () => {
                    return this.data.get();
                },
                find: (config = true) => {
                    clearTimeout(this.controls.data.timoutFindRequest);
                    let loader = typeof config == 'boolean' ? config : 'loader' in config ? config['loader'] : false;
                    let params = typeof config == 'boolean' ? {} : 'params' in config ? config['params'] : {};
                    if (loader) {
                        this.changes.dataSource.next({ type: 'start', data: [] });
                        this.changes.loader.next(true);
                    }
                    this.controls.data.timoutFindRequest = setTimeout(() => {
                        var _a;
                        (_a = this.data) === null || _a === void 0 ? void 0 : _a.find(params);
                    }, 250);
                },
                set: (data, find = false, configs) => {
                    this.data.set(data);
                    if (find) {
                        this.controls.data.find(configs === null || configs === void 0 ? void 0 : configs.loader);
                    }
                },
                setItem: (data, find = false, configs) => {
                    var _a;
                    (_a = this.data) === null || _a === void 0 ? void 0 : _a.setItem(data);
                    if (find) {
                        this.controls.data.find(configs === null || configs === void 0 ? void 0 : configs.loader);
                    }
                },
                getItem: (index) => { var _a; return (_a = this.data) === null || _a === void 0 ? void 0 : _a.getItem(index); },
                changeServer: (data) => {
                    if (this.data instanceof DynamicTableRequest) {
                        this.data.changeServer(data);
                    }
                },
                removeItem: (fakeIdOrIndex, typeFind = 'fakeId') => {
                    var _a;
                    if (typeFind == 'index-dataSource' && this.typeTable == 'array') {
                        if (this.controls.data.dataSource[fakeIdOrIndex]) {
                            if ((_a = this.controls.data.dataSource[fakeIdOrIndex]) === null || _a === void 0 ? void 0 : _a.dynamicFakeId) {
                                this.data.removeItem(this.controls.data.dataSource[fakeIdOrIndex].dynamicFakeId, 'fakeId');
                            }
                        }
                        return;
                    }
                    this.data.removeItem(fakeIdOrIndex, typeFind == 'fakeId' ? 'fakeId' : 'index');
                }
            },
            /**
             *
             */
            queryParams: {
            // verifySave: (): boolean => {
            //   if (!!this?.saveQueryParams) {
            //     if (!!this.saveQueryParams?.save) {
            //       if (!!this.saveQueryParams.nameGroup || !!this.tableKey) {
            //         return true
            //       } else {
            //         console.error(
            //           'Dynamic-table:',
            //           'A função de salvamento de parametros da tabela foi ativado mas nenhum nome foi dado para o ' +
            //           'nome da variável "queryParam". Informa a "tableKey" para referencia de nome, ou a ' +
            //           '"saveQueryParams: {save:true, nameGroup: \'NOME-DO-GRUPO\'}" caso queira salvar a paginação em ' +
            //           'uma variável separada'
            //         );
            //         return false
            //       }
            //     }
            //   }
            //
            //   return false;
            // },
            // getInstance: () => {
            //   if (!this.saveQueryParams) {
            //     console.error(
            //       'Dynamic-table:',
            //       'A função de salvamento de parametros da tabela deve ser iniciada junto com a tabela. ' +
            //       'Nenhuma "saveQueryParams: {save:true}" na construção da sua tabela'
            //     );
            //     return null;
            //   }
            //   if (!this.saveQueryParams.nameGroup && !this.tableKey) {
            //     console.error(
            //       'Dynamic-table:',
            //       'A função de salvamento de parametros da tabela foi ativado mas nenhum nome foi dado para o ' +
            //       'nome da variável "queryParam". Informa a "tableKey" para referencia de nome, ou a ' +
            //       '"saveQueryParams: {save:true, nameGroup: \'NOME-DO-GRUPO\'}" caso queira salvar a paginação em ' +
            //       'uma variável separada'
            //     );
            //     return null
            //   }
            //   return this.saveQueryParams?.queryParamsInstance?.group(this.saveQueryParams.nameGroup || this.tableKey) || null
            // },
            // getAll: (): {[key: string]: any} | null => {
            //   return this.controls.queryParams.getInstance()?.getAll() || null
            // }
            }
        };
        this.tableKey = (configs === null || configs === void 0 ? void 0 : configs.tableKey) || '';
        if (configs === null || configs === void 0 ? void 0 : configs.saveQueryParams) {
            // @ts-ignore
            this.queryParamsGroup = DynamicQueryParams.group(Object.assign(Object.assign({}, configs.saveQueryParams), { group: configs.saveQueryParams.group || this.tableKey }));
        }
        if (configs === null || configs === void 0 ? void 0 : configs.columns) {
            this.controls.columns.set(configs.columns);
        }
        if (configs === null || configs === void 0 ? void 0 : configs.pagination) {
            this.rootPagination = Object.assign(Object.assign({}, this.rootPagination), configs.pagination);
            this._rootPagination = JSON.parse(JSON.stringify(this.rootPagination));
        }
        if (configs === null || configs === void 0 ? void 0 : configs.sort) {
            this.sort = configs.sort;
            this.changes.sortList.next(this.sort);
        }
        if ((configs === null || configs === void 0 ? void 0 : configs.actions) !== null) {
            if (configs === null || configs === void 0 ? void 0 : configs.actions) {
                this.controls.actions.setObject(configs.actions);
            }
        }
        // if (!this.rootPagination?.pipePagination) {
        //   if (!!globalConfig?.pipePagination) {
        //     this.rootPagination['pipePagination'] = globalConfig.pipePagination;
        //   }
        // }
        // if (!this.rootPagination?.outputParamsPagination) {
        //   if (!!globalConfig?.outputParamsPagination) {
        //     this.rootPagination['outputParamsPagination'] = globalConfig.outputParamsPagination;
        //   }
        // }
        if (configs === null || configs === void 0 ? void 0 : configs.filters) {
            const _e = configs.filters, { group } = _e, rest = __rest(_e, ["group"]);
            this.controls.filters.start(group, rest);
        }
        const configDynamicTable = {
            getPagination: this.controls.pagination.get,
            setPagination: this.controls.pagination.set,
            getColumns: () => this.rootColumns,
            getColumn: (columnName) => {
                const index = this.rootColumns.findIndex(column => {
                    if (typeof column == 'string') {
                        return columnName == column;
                    }
                    return columnName == column.name;
                });
                if (index != -1)
                    return this.rootColumns[index];
                return null;
            },
            changes: this.changes,
            pipeRequest: this.pipeRequest,
            params: () => this.rootParams,
            apiData: configs === null || configs === void 0 ? void 0 : configs.apiData,
            filters: this.group
        };
        if (!!((_a = this.queryParamsGroup) === null || _a === void 0 ? void 0 : _a.save)) {
            const params = this.queryParamsGroup.getParams();
            console.log('params', params);
            if ('pagination' in params) {
                const pagination = params['pagination'];
                this.rootPagination = Object.assign(Object.assign({}, params['pagination']), (pagination || {}));
            }
            if ('filters' in params) {
                if (!!((_b = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _b === void 0 ? void 0 : _b.filters)) {
                    const filters = params['filters'];
                    const _filters = {};
                    Object.keys(filters).map(key => {
                        var _a;
                        if (!((_a = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _a === void 0 ? void 0 : _a.filters))
                            return;
                        if (key in configs.filters.filters) {
                            _filters[key] = filters[key].data;
                            // configs.filters.filters[key].data = filters[key].data
                        }
                    });
                    this.controls.filters.patchValue(_filters);
                }
            }
            if ('optionalData' in params) {
                (_c = this.group) === null || _c === void 0 ? void 0 : _c.controls.optionalData.setAll(params['optionalData']);
            }
        }
        if (typeTable == 'array') {
            this.data = new DynamicTableArray(configDynamicTable);
        }
        else {
            if (!http) {
                throw 'Uma tabela dynamica de requests foi iniciada sem o HttpClint';
            }
            if (!(configs === null || configs === void 0 ? void 0 : configs.apiData)) {
                throw 'Uma tabela dynamica de requests foi iniciada sem os valores de busca ao servidor';
            }
            if (!!((_d = configs.apiData) === null || _d === void 0 ? void 0 : _d.inputPipe)) {
                this.pipeRequest = configs.apiData.inputPipe;
            }
            this.data = new DynamicTableRequest(configDynamicTable, http, configs.apiData);
        }
        this.observables.dataSource.subscribe(resp => {
            var _a, _b, _c, _d;
            this.controls.data.dataSource = Array.isArray(resp.data) ? resp.data : [];
            if (resp.type == 'start') {
                /**
                 * Salvando registros no queryParams
                 */
                if (!!((_a = this.queryParamsGroup) === null || _a === void 0 ? void 0 : _a.save)) {
                    const params = {};
                    const _e = this.controls.pagination.get(), { totalPages, totalElements } = _e, pagination = __rest(_e, ["totalPages", "totalElements"]);
                    const _rootPagination = this._rootPagination;
                    // verificando salvamento para paginação
                    if (JSON.stringify(pagination.sort) != JSON.stringify(_rootPagination.sort) ||
                        pagination.page != _rootPagination.page ||
                        pagination.size != _rootPagination.size ||
                        pagination.typePagination != _rootPagination.typePagination) {
                        console.log('salvando paginação');
                        params['pagination'] = pagination;
                    }
                    else {
                        delete params['pagination'];
                    }
                    // verificando salvamento para filtros
                    const filter = this.controls.filters.getFilters();
                    Object.keys(filter).map(filtr => {
                        var _a, _b, _c, _d, _e;
                        if (!((_a = filter[filtr]) === null || _a === void 0 ? void 0 : _a.data)) {
                            delete filter[filtr];
                            return;
                        }
                        if (Array.isArray((_b = filter[filtr]) === null || _b === void 0 ? void 0 : _b.data)) {
                            if (((_c = filter[filtr]) === null || _c === void 0 ? void 0 : _c.data.length) == 0) {
                                delete filter[filtr];
                                return;
                            }
                        }
                        else if (typeof ((_d = filter[filtr]) === null || _d === void 0 ? void 0 : _d.data) == 'object') {
                            delete filter[filtr];
                            return;
                        }
                        filter[filtr] = { data: ((_e = filter[filtr]) === null || _e === void 0 ? void 0 : _e.data) || '' };
                    });
                    if (Object.keys(filter).length > 0) {
                        console.log('salvando flitros', filter);
                        params['filters'] = filter;
                    }
                    else {
                        delete params['filters'];
                    }
                    if (!!params['filters'] && ((_b = this.group) === null || _b === void 0 ? void 0 : _b.controls.optionalData.getAll())) {
                        params['optionalData'] = (_c = this.group) === null || _c === void 0 ? void 0 : _c.controls.optionalData.getAll();
                    }
                    else {
                        (_d = this.group) === null || _d === void 0 ? void 0 : _d.controls.optionalData.setAll(undefined);
                    }
                    // salvando os dados
                    if (Object.keys(params).length > 0) {
                        console.log('params', params);
                        this.queryParamsGroup.setParams(params);
                    }
                    else {
                        this.queryParamsGroup.clearAll();
                    }
                }
            }
        });
    }
    /**
     * metodo para facilitar o reload dos dados
     */
    find(loader = true) {
        this.controls.data.find(loader);
    }
    destroy() {
        var _a, _b;
        (_a = this.onSubscribeGroup) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.rootParams = {};
        (_b = this.group) === null || _b === void 0 ? void 0 : _b.destroy();
        console.log('clear dynamic-table');
    }
}

var CdkDynamicTable;
(function (CdkDynamicTable) {
    /**
     * Metodos de criação das classes de controle de dados
     */
    // cria um gerenciador de dados em array
    function createArrayTable(configs) {
        return new DynamicTableClass('array', configs);
    }
    CdkDynamicTable.createArrayTable = createArrayTable;
    // cria um gerenciador de dados por request API
    function createRequestTable(http, configs) {
        return new DynamicTableClass('request', configs, http);
    }
    CdkDynamicTable.createRequestTable = createRequestTable;
})(CdkDynamicTable || (CdkDynamicTable = {}));

class CdkSaveQueryParamsService {
    constructor(activate, router) {
        this.activate = activate;
        this.router = router;
        this.encript = true;
    }
    group(group) {
        const allParams = this.activate.snapshot.queryParams;
        let dataGroup = {};
        if (group in allParams) {
            dataGroup = this.encript ? this.decriptData(allParams[group]) : JSON.parse(allParams[group]);
        }
        return {
            setAttr: (attrGroup, value) => this.addParam(dataGroup, group, attrGroup, value),
            getAttr: (attrGroup) => {
                if (attrGroup in dataGroup)
                    return dataGroup[attrGroup];
                return undefined;
            },
            getAll: () => dataGroup,
            saveAll: () => {
                window.dispatchEvent(new CustomEvent('save-query-params-awaited-directive', { detail: group }));
            }
        };
    }
    clearAll() {
    }
    addParam(data, group, attrGroup, value) {
        if (!!value) {
            data = Object.assign(Object.assign({}, (data || {})), { [attrGroup]: !!value ? value : null });
        }
        if (!value && attrGroup in data) {
            delete data[attrGroup];
        }
        if (Object.keys(data).length <= 0) {
            data = null;
        }
        else {
            data = this.encript ? this.encriptData(data) : JSON.stringify(data);
        }
        this.router.navigate([], {
            relativeTo: this.activate,
            queryParams: {
                [group]: data
            },
            queryParamsHandling: 'merge'
        }).then();
    }
    getParam(group) {
        const params = this.activate.snapshot.queryParams;
        if (this.encript) {
            if (!!params[group])
                return this.decriptData(params[group]);
        }
        if (!!params[group])
            return params[group];
        return null;
    }
    encriptData(data) {
        if (!!data) {
            return btoa(JSON.stringify(data));
        }
        return '';
    }
    decriptData(data) {
        if (!!data) {
            return JSON.parse(atob(data));
        }
        return {};
    }
}
CdkSaveQueryParamsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkSaveQueryParamsService, deps: [{ token: i1$3.ActivatedRoute }, { token: i1$3.Router }], target: i0.ɵɵFactoryTarget.Injectable });
CdkSaveQueryParamsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkSaveQueryParamsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkSaveQueryParamsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.ActivatedRoute }, { type: i1$3.Router }]; } });

class CdkDynamicTableService {
    constructor(http, queryParams) {
        this.http = http;
        this.queryParams = queryParams;
    }
    create(typeData, configs) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const dataCreate = {
            columns: [],
            apiData: {
                path: '',
                context: ''
            }
        };
        const rootConfig = ConfigDynamicTable.get();
        if ('apiData' in rootConfig) {
            // @ts-ignore
            dataCreate['apiData'] = rootConfig.apiData;
        }
        if ('actions' in rootConfig) {
            dataCreate['actions'] = Object.assign(Object.assign({}, (dataCreate['actions'] || {})), rootConfig.actions);
        }
        /**
         * Buscando dados no config informado na criação
         */
        if (!!configs) {
            if ('apiData' in configs) {
                dataCreate["apiData"] = Object.assign(Object.assign({}, dataCreate.apiData), configs.apiData);
            }
            if ('columns' in configs) {
                dataCreate["columns"] = configs.columns || [];
            }
            if (configs === null || configs === void 0 ? void 0 : configs.filters) {
                const filters = dataCreate['filters'] || {};
                if (!(filters === null || filters === void 0 ? void 0 : filters.filters))
                    filters['filters'] = {};
                if ((_a = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _a === void 0 ? void 0 : _a.group)
                    filters['group'] = (_b = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _b === void 0 ? void 0 : _b.group;
                if ((_c = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _c === void 0 ? void 0 : _c.clear)
                    filters['clear'] = (_d = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _d === void 0 ? void 0 : _d.clear;
                if ((_e = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _e === void 0 ? void 0 : _e.reactive)
                    filters['reactive'] = (_f = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _f === void 0 ? void 0 : _f.reactive;
                if ((_g = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _g === void 0 ? void 0 : _g.params)
                    filters['params'] = (_h = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _h === void 0 ? void 0 : _h.params;
                if ((_j = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _j === void 0 ? void 0 : _j.outPutParams)
                    filters['outPutParams'] = (_k = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _k === void 0 ? void 0 : _k.outPutParams;
                filters['filters'] = ((_l = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _l === void 0 ? void 0 : _l.filters) || {};
                dataCreate['filters'] = filters;
            }
            if ('actions' in configs) {
                let actions = dataCreate['actions'] || {};
                actions = configs.actions || {};
                let existDbClick = Object.values((configs.actions || {})).filter(item => item.dbClick).length > 0;
                dataCreate['actions'] = actions;
            }
            if ('sort' in configs) {
                dataCreate['sort'] = configs === null || configs === void 0 ? void 0 : configs.sort;
            }
            if ('pagination' in configs) {
                dataCreate['pagination'] = Object.assign(Object.assign({}, (dataCreate['pagination'] || {})), (configs.pagination || {}));
            }
            if ('saveQueryParams' in configs) {
                dataCreate['saveQueryParams'] = Object.assign(Object.assign({}, (dataCreate['saveQueryParams'] || {})), (configs.saveQueryParams || {}));
            }
        }
        if (typeData == 'array') {
            return CdkDynamicTable.createArrayTable(Object.assign({}, dataCreate));
        }
        return CdkDynamicTable.createRequestTable(this.http, Object.assign({}, dataCreate));
    }
    createByEntity(entity, configs, typeData = 'request') {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        const dataCreate = {
            columns: [],
            apiData: {
                path: '',
                context: ''
            }
        };
        const rootConfig = ConfigDynamicTable.get();
        if ('apiData' in rootConfig) {
            // @ts-ignore
            dataCreate['apiData'] = rootConfig.apiData;
        }
        if ('actions' in rootConfig) {
            dataCreate['actions'] = Object.assign(Object.assign({}, (dataCreate['actions'] || {})), rootConfig.actions);
        }
        /**
         * Buscando dados presentes nas endidades, criados pelos @DECORATORS
         * @DynamicTable
         * @dynamicTableColumn
         */
        if ('rootDynamicTable' in entity) {
            const rootDynamicTable = entity['rootDynamicTable'];
            if ('api' in rootDynamicTable) {
                dataCreate['apiData'] = Object.assign(Object.assign({}, dataCreate['apiData']), rootDynamicTable.api);
            }
            if ('columns' in rootDynamicTable) {
                dataCreate['columns'] = [];
                const mapColunms = rootDynamicTable['columns'] || [];
                mapColunms.forEach((val, key) => {
                    var _a;
                    let column = key;
                    if (typeof val != "string") {
                        column = Object.assign({ name: key, headerName: val.headerName || key }, (val || {}));
                    }
                    (_a = dataCreate['columns']) === null || _a === void 0 ? void 0 : _a.push(column);
                });
            }
            if ('actions' in rootDynamicTable) {
                dataCreate['actions'] = Object.assign(Object.assign({}, (dataCreate['actions'] || {})), rootDynamicTable.actions);
            }
            if ('filters' in rootDynamicTable) {
                dataCreate['filters'] = Object.assign(Object.assign({}, (dataCreate['filters'] || {})), rootDynamicTable.filters);
            }
            if ('sort' in rootDynamicTable) {
                dataCreate['sort'] = rootDynamicTable === null || rootDynamicTable === void 0 ? void 0 : rootDynamicTable.sort;
            }
            // if ('tdClass' in rootDynamicTable) {
            //   dataCreate['tdClass'] = rootDynamicTable?.tdClass;
            // }
            //
            // if ('thClass' in rootDynamicTable) {
            //   dataCreate['thClass'] = rootDynamicTable?.thClass;
            // }
            if ('pagination' in rootDynamicTable) {
                dataCreate['pagination'] = Object.assign(Object.assign({}, (dataCreate['pagination'] || {})), (rootDynamicTable.pagination || {}));
            }
            if ('saveQueryParams' in rootDynamicTable) {
                dataCreate['saveQueryParams'] = Object.assign(Object.assign({}, (dataCreate['saveQueryParams'] || {})), (rootDynamicTable.saveQueryParams || {}));
            }
            // if ('pipeRequest' in rootDynamicTable) {
            //   dataCreate['pipeRequest'] = rootDynamicTable.pipeRequest
            // }
            // if ('pipePagination' in rootDynamicTable) {
            //   dataCreate['pipePagination'] = rootDynamicTable.pipePagination
            // }
        }
        /**
         * Buscando dados no config informado na criação
         */
        if (!!configs) {
            if ('api' in configs) {
                dataCreate["apiData"] = Object.assign(Object.assign({}, dataCreate.apiData), configs.api);
            }
            if ('columns' in configs) {
                if ((_a = configs.columns) === null || _a === void 0 ? void 0 : _a.add) {
                    dataCreate["columns"] = [
                        ...(dataCreate["columns"] || []),
                        ...(configs.columns.add || [])
                    ];
                }
                if ((_b = configs.columns) === null || _b === void 0 ? void 0 : _b.update) {
                    (_c = configs.columns) === null || _c === void 0 ? void 0 : _c.update.map((columnUpdate) => {
                        dataCreate.columns.map((columnCurrent, index) => {
                            const name2 = typeof columnCurrent == 'string' ? columnCurrent : columnCurrent.name;
                            if (columnUpdate.name == name2) {
                                if (dataCreate.columns[index]) {
                                    dataCreate.columns[index] = Object.assign(Object.assign({}, (typeof columnCurrent == 'string' ? { name: columnCurrent } : columnCurrent)), (columnUpdate || {}));
                                }
                                console.log(dataCreate.columns[index]);
                                // @ts-ignore
                                dataCreate.columns[index] = Object.assign(Object.assign({}, (typeof columnCurrent == 'string' ? { name: columnCurrent } : columnCurrent)), (columnUpdate || {}));
                            }
                        });
                    });
                }
                if ((_d = configs.columns) === null || _d === void 0 ? void 0 : _d.remove) {
                    configs.columns.remove.map(columnRemove => {
                        const index = dataCreate.columns.findIndex(item => {
                            const name = typeof item == 'string' ? item : item.name;
                            return columnRemove == name;
                        });
                        if (index > -1) {
                            dataCreate.columns.splice(index, 1);
                        }
                    });
                }
            }
            if (configs === null || configs === void 0 ? void 0 : configs.filters) {
                const filters = dataCreate['filters'] || {};
                if (!(filters === null || filters === void 0 ? void 0 : filters.filters))
                    filters['filters'] = {};
                if ((_e = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _e === void 0 ? void 0 : _e.group)
                    filters['group'] = (_f = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _f === void 0 ? void 0 : _f.group;
                if ((_g = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _g === void 0 ? void 0 : _g.clear)
                    filters['clear'] = (_h = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _h === void 0 ? void 0 : _h.clear;
                if ((_j = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _j === void 0 ? void 0 : _j.reactive)
                    filters['reactive'] = (_k = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _k === void 0 ? void 0 : _k.reactive;
                if ((_l = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _l === void 0 ? void 0 : _l.params)
                    filters['params'] = (_m = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _m === void 0 ? void 0 : _m.params;
                if ((_o = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _o === void 0 ? void 0 : _o.outPutParams)
                    filters['outPutParams'] = (_p = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _p === void 0 ? void 0 : _p.outPutParams;
                if ((_r = (_q = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _q === void 0 ? void 0 : _q.filters) === null || _r === void 0 ? void 0 : _r.add) {
                    filters['filters'] = Object.assign(Object.assign({}, (filters['filters'] || {})), (((_t = (_s = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _s === void 0 ? void 0 : _s.filters) === null || _t === void 0 ? void 0 : _t.add) || {}));
                }
                if ((_v = (_u = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _u === void 0 ? void 0 : _u.filters) === null || _v === void 0 ? void 0 : _v.update) {
                    Object.keys((_x = (_w = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _w === void 0 ? void 0 : _w.filters) === null || _x === void 0 ? void 0 : _x.update).map(key => {
                        if (key in (filters === null || filters === void 0 ? void 0 : filters.filters)) {
                            filters.filters[key] = Object.assign(Object.assign({}, filters === null || filters === void 0 ? void 0 : filters.filters[key]), (configs.filters.filters.update[key] || {}));
                        }
                    });
                }
                if ((_z = (_y = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _y === void 0 ? void 0 : _y.filters) === null || _z === void 0 ? void 0 : _z.remove) {
                    (_1 = (_0 = configs === null || configs === void 0 ? void 0 : configs.filters) === null || _0 === void 0 ? void 0 : _0.filters) === null || _1 === void 0 ? void 0 : _1.remove.map(key => {
                        if (key in (filters === null || filters === void 0 ? void 0 : filters.filters)) {
                            filters === null || filters === void 0 ? true : delete filters.filters[key];
                        }
                    });
                }
                dataCreate['filters'] = filters;
            }
            if ('actions' in configs) {
                let actions = dataCreate['actions'] || {};
                if ((_2 = configs.actions) === null || _2 === void 0 ? void 0 : _2.add) {
                    actions = Object.assign(Object.assign({}, actions), configs.actions.add);
                }
                let existDbClick = Object.values((((_3 = configs.actions) === null || _3 === void 0 ? void 0 : _3.edit) || {})).filter(item => item.dbClick).length > 0;
                if ((_4 = configs.actions) === null || _4 === void 0 ? void 0 : _4.edit) {
                    Object.keys(configs.actions.edit).map(key => {
                        var _a, _b;
                        if (((_a = configs.actions) === null || _a === void 0 ? void 0 : _a.edit) && existDbClick) {
                            if (key in ((_b = configs.actions) === null || _b === void 0 ? void 0 : _b.edit)) {
                                if (!!configs.actions.edit[key].dbClick) {
                                    Object.keys(actions).map(keyAction => {
                                        actions[keyAction].dbClick = false;
                                    });
                                }
                            }
                        }
                        if (key in actions) {
                            actions[key] = Object.assign(Object.assign({}, actions[key]), (configs.actions.edit[key] || {}));
                        }
                    });
                }
                if ((_5 = configs.actions) === null || _5 === void 0 ? void 0 : _5.remove) {
                    configs.actions.remove.map(key => {
                        if (key in actions) {
                            delete actions[key];
                        }
                    });
                }
                dataCreate['actions'] = actions;
            }
            if (configs === null || configs === void 0 ? void 0 : configs.api) {
                // esse ignore e por conta da entrada ser um parcial
                // e o IDE querer a interface inteira
                // @ts-ignore
                dataCreate['apiData'] = Object.assign(Object.assign({}, (dataCreate['apiData'] || {})), (configs['api'] || {}));
            }
            if ('sort' in configs) {
                dataCreate['sort'] = configs === null || configs === void 0 ? void 0 : configs.sort;
            }
            if ('pagination' in configs) {
                dataCreate['pagination'] = Object.assign(Object.assign({}, (dataCreate['pagination'] || {})), (configs.pagination || {}));
            }
            if ('saveQueryParams' in configs) {
                dataCreate['saveQueryParams'] = Object.assign(Object.assign({}, (dataCreate['saveQueryParams'] || {})), (configs.saveQueryParams || {}));
            }
        }
        const resultTable = this.create(typeData, dataCreate);
        resultTable.typeTable = typeData;
        return resultTable;
    }
}
CdkDynamicTableService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableService, deps: [{ token: i1.HttpClient }, { token: CdkSaveQueryParamsService }], target: i0.ɵɵFactoryTarget.Injectable });
CdkDynamicTableService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicTableService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: CdkSaveQueryParamsService }]; } });

/**
 * Esse Sumbol representa as ocorrencias de assinaturas de COLUNAS na entidade
 */
const dynamicTableColumnKey = Symbol('isTableColumn');
/**
 *
 * @param key
 * @param origin
 */
function getFilteredProperties(key, origin) {
    return Reflect.getMetadata(key, origin);
}
/**
 * Decorator de entidade
 * Esse decorator será responsável por coletar os decorators de colunas.
 * por aqui também é possível realizar quase todas as configurações existentes
 * da tabela.
 *
 * @param props
 * @constructor
 */
function DynamicTableEntity(props) {
    return (constructor) => {
        return class extends constructor {
            constructor(...args) {
                super(...args);
                let tableColunms = getFilteredProperties(dynamicTableColumnKey, this);
                let rootDynamicTable = {};
                if (!!props) {
                    rootDynamicTable = props;
                }
                rootDynamicTable['columns'] = !!tableColunms ? tableColunms : new Map();
                this['rootDynamicTable'] = rootDynamicTable;
            }
        };
    };
}

class DynamicColumnClass {
}

function DynamicColumn(props) {
    return function (target, propertyKey) {
        let properties = Reflect.getMetadata(dynamicTableColumnKey, target);
        if (!properties) {
            properties = new Map();
        }
        let tableColumn = new DynamicColumnClass();
        tableColumn = Object.assign(Object.assign({}, tableColumn), (props || {}));
        properties.set(propertyKey, tableColumn);
        return Reflect.defineMetadata(dynamicTableColumnKey, properties, target);
    };
}

class AbstractGenericService {
    constructor(http, path) {
        this.http = http;
        this.path = path;
    }
    changePath(path) {
        this.path = path;
    }
    get(context, options) {
        const contextFinal = [this.path, context];
        return this.http.get(this.resolveEndpointUrl(contextFinal), options);
    }
    post(context, data, options) {
        const contextFinal = [this.path, context];
        return this.http.post(this.resolveEndpointUrl(contextFinal), data, options);
    }
    patch(context, data, options) {
        const contextFinal = [this.path, context];
        return this.http.patch(this.resolveEndpointUrl(contextFinal), data, options);
    }
    put(context, data, options) {
        const contextFinal = [this.path, context];
        return this.http.put(this.resolveEndpointUrl(contextFinal), data, options);
    }
    delete(context, options) {
        const contextFinal = [this.path, context];
        return this.http.delete(this.resolveEndpointUrl(contextFinal), options);
    }
    deleteById(context, id, options) {
        const contextFinal = [this.path, context, id];
        return this.http.delete(this.resolveEndpointUrl(contextFinal), options);
    }
    resolveEndpointUrl(val) {
        val = val.map(v => {
            if (!!v) {
                v = String(v).endsWith('/') ? String(v).substring(0, String(v).length - 1) : v;
                v = String(v).startsWith('/') ? String(v).substring(1) : v;
                return v;
            }
            return null;
        }).filter(v => !!v);
        return val.join('/');
    }
}

class AutocompleteManageHtmlService {
    constructor() {
        /**
         * Conjunto de configurações
         */
        this.config = {
            position: "outside",
            positionY: 'bottom',
            positionX: 'start',
            widthDivList: 'justify'
        };
        /**
         * ID de referencia do input. Serve para posicionar a lista abaixo do input
         */
        this.inputReferenceId = '';
        /**
         * ID de referencia da lista. Serve para buscar elementos internos e realizar o seu alinhamento
         */
        this.listReferenceId = '';
        /**
         * Esse atributo é responsável pela posição de abertura da lista.
         * INSIDE = abrirá no início do elemento que o chamou, sobre ele.
         * OUTSIDE = Abrirá abaixo ou acima respeitando o elemento que o chamou.
         */
        // public position: 'inside' | 'outside' = "outside";
        /**
         * Atributos de CSS a serem importados nos elementos HTML
         * @private
         */
        this.attrCssElements = {
            content: {},
            listBox: {}
        };
    }
    setConfig(config) {
        if (!!config.position)
            this.config.position = config.position;
        if (!!config.positionY)
            this.config.positionY = config.positionY;
        if (!!config.positionX)
            this.config.positionX = config.positionX;
        if (!!config.widthDivList)
            this.config.widthDivList = config.widthDivList;
    }
    /**
     * Metoro de controle vertica da abertura da lista.
     * caso nenhum valor seja informado para o INPUT positionY, esse metodo irá verificar
     * se o espaço abaixo é menor que 300px, caso seja, ele irá verificar o espaço acima.
     * Caso o espaço acima seja >= 300px ele abrirá acima, do contrário abrirá abaixo.
     *
     * A div list sempre utilizará um espaço de 10px para o fim da tela, isso para melhorar a
     * experiência do usuário.
     *
     * @private
     * @param referenceId
     */
    setHtmlParamsOpen(referenceId) {
        if (!!referenceId)
            this.inputReferenceId = referenceId;
        // buscando referencia do input para posicionar a lista
        const elementInputCoordinates = this.getReferenceElement(this.inputReferenceId).getBoundingClientRect();
        // todo esse elemento tenta levar o scrol da ul para 0 mas não está funcionando, verificar
        this.attrCssElements.listBox['scrollX'] = '0';
        this.config.positionY = this.verifyPositionY(elementInputCoordinates);
        // verificando posição vertical
        if (this.config.positionY == 'top') {
            this.setParamsTop(elementInputCoordinates);
        }
        else {
            this.setParamsBottom(elementInputCoordinates);
        }
        // verificando alinhamento horizontal
        if (this.config.positionX == 'start') {
            this.attrCssElements.content['margin-left'] = elementInputCoordinates.left + 'px';
            this.attrCssElements.content['maxWidth'] = window.innerWidth - elementInputCoordinates.left - 30 + 'px';
        }
        else {
            this.attrCssElements.content['maxWidth'] =
                elementInputCoordinates.left + elementInputCoordinates.width - 10 + 'px';
        }
        // ajustando tamanho
        if (this.config.widthDivList == 'justify') {
            this.attrCssElements.listBox['width'] = elementInputCoordinates.width + 'px';
        }
        else if (this.config.widthDivList == 'min-justify') {
            this.attrCssElements.listBox['minWidth'] = elementInputCoordinates.width + 'px';
        }
        else {
            this.attrCssElements.listBox['width'] = 'auto';
        }
        this.attrCssElements.content['maxWidth'] =
            elementInputCoordinates.left + elementInputCoordinates.width - 10 + 'px';
        this.insertAttrInHtmlElement();
    }
    /*********************************************************
     * GERENCIAMENTO DO DOM
     *********************************************************/
    // seta atributos css nos elemebtos
    insertAttrInHtmlElement() {
        const elementContent = this.getElementHtml('content');
        const elementDivList = this.getElementHtml('listBox');
        if (this.config.position == 'outside') {
            this.getReferenceElement(this.inputReferenceId).classList.add('dg-autocomplete2-search-input-open');
        }
        // set CONTENT DIVLIST
        Object.keys(this.attrCssElements.content).map((attr) => {
            // @ts-ignore
            elementContent.style[attr] = this.attrCssElements.content[attr];
        });
        // set DIVLIST
        Object.keys(this.attrCssElements.listBox).map((attr) => {
            // @ts-ignore
            elementDivList.style[attr] = this.attrCssElements.listBox[attr];
        });
    }
    removeAttrInputReference() {
        this.getReferenceElement(this.inputReferenceId).classList.remove('dg-autocomplete2-search-input-open');
    }
    getReferenceElement(idReference) {
        const element = window.document.getElementById(idReference);
        if (!element)
            throw "Não foi possível encontrar o elemento '" + idReference + "'";
        return element;
    }
    getElementHtml(elementString) {
        const transIdElement = {
            content: 'key-content-autocomplete2',
            listBox: 'key-listbox-autocomplete2',
        };
        const elementClass = this.getReferenceElement(this.listReferenceId)
            .getElementsByClassName(transIdElement[elementString])[0];
        if (!elementClass)
            throw "Não foi possível encontrar o elemento '" + transIdElement[elementString] + "'";
        return elementClass;
    }
    /*********************************************************
     * POSICIONAMENTO DA LISTA
     *********************************************************/
    verifyPositionY(elementInputCoordinates) {
        // if (!!this.root.positionY) return this.root.positionY
        // verifica se o BOTTOM é menor que o mínimo '300px'
        if ((window.innerHeight - elementInputCoordinates.top + elementInputCoordinates.height) < 300) {
            // verifica se o TOP é menor do que o BOTTOM
            if ((window.innerHeight - elementInputCoordinates.top + (elementInputCoordinates.height / 2)) > elementInputCoordinates.top + (elementInputCoordinates.height / 2)) {
                return 'bottom';
            }
            else {
                return 'top';
            }
        }
        return "bottom";
    }
    // seta parametros de apresentação TOP
    setParamsTop(elementInputCoordinates) {
        this.attrCssElements.content['marginBottom'] = window.innerHeight - elementInputCoordinates.top + 'px';
        this.attrCssElements.content['maxHeight'] = elementInputCoordinates.top - 10 + 'px';
    }
    // seta parametros de apresentação BOTTOM
    setParamsBottom(elementInputCoordinates) {
        this.attrCssElements.content['marginTop'] = elementInputCoordinates.top + (this.config.position == 'inside' ? 0 : elementInputCoordinates.height) + 'px';
        this.attrCssElements.content['maxHeight'] = window.innerHeight - (elementInputCoordinates.top + elementInputCoordinates.height) - 10 + 'px';
    }
}

class AutocompleteListStickyComponent {
    constructor(cdRef) {
        this.cdRef = cdRef;
        /**
         * Atributo responsável por guardar uma instância de setTimeOut(), essa por sua vez é cancelada
         * sempre que uma nova é feita em tempo menor que o informado no INPUT "timeOutDelay" que por padrão
         * é 300ms
         */
        this.timeout = null;
        // atributi exibido na lista
        this.label = '';
        // atributo recolhido como id
        this.key = '';
        // lista de dados para apresentar na tabela
        this.data = [];
        // seletor de apresentação de posição da lista
        //  inside: em cima do componente;
        //  outside: fora do componente;
        this.position = "outside";
        // seletor de verificação da lista
        //  inside: filtros feitos pelo autocomplete;
        //  outside: filtros feitos externamente;
        this.typeFilter = "inside";
        // seletor de comportamento de auto-desselecionar ao clicar em item selecionado
        this.itenSelfUnselect = true;
        // RAÇÃO DOS MEUS PROBLEMAS
        this.search = '';
        // classes CSS repassadas ao componente
        this.classes = '';
        // seletor de apresentação do check que deve apresentar
        this.typeCheckInputOption = 'checkbox';
        // seletor de comportamento limpar escrita ao sair
        this.clearSearchOnClose = true;
        // seletor de comportamento limpar escrita ao entrar
        this.clearSearchOnOpen = true;
        this.setValue = new EventEmitter();
        this.closeList = new EventEmitter();
        this.searchFilterValue = new EventEmitter();
        // id HTML do componente
        this.id = '';
        // controlador de aberto ou fechado
        this.show = false;
        // lista de itens selecionados
        this.selectedList = [];
        this.contentChilds = {
            listOptionSelected: (option, index) => {
                return {
                    row: option,
                    label: this.getLabel(option),
                    key: this.getKey(option),
                    selected: true
                };
            },
            listOption: (option, index) => {
                return {
                    row: option,
                    label: this.getLabel(option),
                    key: this.getKey(option),
                    selected: this.verifySelectedItem(index)
                };
            }
        };
        this.verifications = {
            ocultarItemSelecionado: () => {
                if (!this.multiple) {
                    if (this.showSelectedOption == undefined)
                        return false;
                    return !this.showSelectedOption;
                }
                if (this.showSelectedOption == undefined)
                    return true;
                return !this.showSelectedOption;
            }
        };
        this.htmlManage = new AutocompleteManageHtmlService();
        this.id = 'key-autocomplete2-' + uniqIdHtml(val => 'key-autocomplete2-' + val);
        this.htmlManage.listReferenceId = this.id;
        this.createEvents();
    }
    ngOnInit() {
    }
    open(referenceId) {
        if (this.show)
            return;
        this.show = true;
        this.htmlManage.setConfig({
            position: this.position,
            widthDivList: this.widthDivList
        });
        this.htmlManage.setHtmlParamsOpen(referenceId);
        if (this.position == 'inside') {
            this.cdRef.detectChanges();
            this.inputSearchFilterInsideList.nativeElement.focus();
        }
    }
    close() {
        setTimeout(() => {
            this.show = false;
            this.htmlManage.removeAttrInputReference();
            this.search = '';
            this.closeList.emit(this.selectedList.map(item => this.getLabel(item)).join(', '));
        }, 200);
    }
    // buscando label
    getLabel(item, label = this.label) {
        if (typeof item == 'string')
            return item;
        if (typeof label == 'string') {
            if (label in (item || {})) {
                return item[label];
            }
            else {
                return '--';
            }
        }
        if (Array.isArray(label)) {
            const labelArray = Array.isArray(label) ? label : [];
            let result = item;
            labelArray.map((nivelArray) => {
                if (nivelArray in result) {
                    result = result[nivelArray];
                }
            });
            return result;
        }
        return '--';
    }
    // buscando key
    getKey(item, key = this.key) {
        if (typeof item == 'string')
            return item;
        if (!key)
            return item;
        if (typeof key == 'string') {
            if (key in (item || {})) {
                return item[key];
            }
            else {
                return '--';
            }
        }
        if (Array.isArray(key)) {
            const keysArray = Array.isArray(key) ? key : [];
            let result = item;
            keysArray.map((nivelArray) => {
                if (nivelArray in result) {
                    result = result[nivelArray];
                }
            });
            return result;
        }
        return '--';
    }
    filter(search, delay) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
            this.searchFilterValue.emit(search);
            this.search = search;
        }, 200);
    }
    closeClickOut(ev) {
        if (this.divRoot.nativeElement.contains(ev.target) &&
            !this.divListBox.nativeElement.contains(ev.target)) {
            this.close();
        }
    }
    selectOption(itemSelected, index) {
        if (this.itenSelfUnselect) {
            const indexItemSelected = this.selectedList.findIndex(item => this.getKey(item) == this.getKey(itemSelected));
            if (indexItemSelected != -1) {
                this.unSelectOption(indexItemSelected);
                return;
            }
        }
        if (!this.multiple)
            this.selectedList = [];
        this.selectedList.push(this.getListFiltered()[index]);
        this.writeValue();
        this.search = '';
        if (!this.multiple) {
            setTimeout(() => this.close(), 10);
        }
    }
    unSelectOption(index) {
        this.selectedList.splice(index, 1);
        this.writeValue();
    }
    writeValue() {
        const value = this.selectedList.map(item => this.getKey(item));
        this.setValue.emit(!this.multiple ? value[0] : value);
    }
    verifySelectedItem(index) {
        const indexItemSelected = this.selectedList.findIndex(item => {
            if (!this.key) {
                return JSON.stringify(item) == JSON.stringify(this.data[index]);
            }
            return this.getKey(item) == this.getKey(this.data[index]);
        });
        return indexItemSelected != -1;
    }
    verifyShowSelectedList() {
        if (typeof this.showSelectedList == 'boolean') {
            return this.showSelectedList;
        }
        return this.multiple;
    }
    createEvents() {
        addEventListener("scroll", () => {
            if (this.show) {
                this.htmlManage.setHtmlParamsOpen();
            }
        });
        addEventListener("resize", () => {
            if (this.show) {
                this.htmlManage.setHtmlParamsOpen();
            }
        });
    }
    receiveNewValues(value, key, label) {
        this.selectedList = [];
        const setOption = (value) => {
            let index = -1;
            if (!!this.key || !!key) {
                index = this.data.findIndex(item => this.getKey(item, this.key || key) == value);
            }
            else {
                index = this.data.findIndex(item => JSON.stringify(item) == JSON.stringify(value));
            }
            if (index != -1) {
                // this.selectedList.push((this.typeFilter == 'inside' ? this.dataSource : this.data)[index]);
                this.selectedList.push(this.data[index]);
            }
        };
        if (Array.isArray(value)) {
            value.map(item => setOption(item));
        }
        else {
            setOption(value);
        }
        return this.selectedList.map(item => this.getLabel(item, this.label || label)).join(', ');
    }
    /**
     * metodo de retorno de itens filtrados.
     */
    getListFiltered() {
        // caso a busca seja externa, apenas retorna a lista
        if (!this.search || this.typeFilter == 'outside')
            return this.data;
        // filtros internos
        return this.data.filter(item => clearString(this.getLabel(item) || '').toUpperCase().includes(clearString(this.search).toUpperCase()));
    }
}
AutocompleteListStickyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AutocompleteListStickyComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
AutocompleteListStickyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: AutocompleteListStickyComponent, selector: "autocomplete-list-sticky", inputs: { label: "label", key: "key", data: "data", multiple: "multiple", showSelectedList: "showSelectedList", showSelectedOption: "showSelectedOption", showInputSearch: "showInputSearch", position: "position", typeFilter: "typeFilter", widthDivList: "widthDivList", itenSelfUnselect: "itenSelfUnselect", search: "search", classes: "classes", showCheckInputOption: "showCheckInputOption", typeCheckInputOption: "typeCheckInputOption", clearSearchOnClose: "clearSearchOnClose", clearSearchOnOpen: "clearSearchOnOpen" }, outputs: { setValue: "setValue", closeList: "closeList", searchFilterValue: "searchFilterValue" }, queries: [{ propertyName: "headerList", first: true, predicate: ["header_list"], descendants: true }, { propertyName: "listOption", first: true, predicate: ["list_option"], descendants: true }, { propertyName: "headerListSelected", first: true, predicate: ["header_list_selected"], descendants: true }, { propertyName: "listOptionSelected", first: true, predicate: ["list_option_selected"], descendants: true }], viewQueries: [{ propertyName: "divRoot", first: true, predicate: ["root"], descendants: true }, { propertyName: "divListBox", first: true, predicate: ["listBox"], descendants: true }, { propertyName: "inputSearchFilterInsideList", first: true, predicate: ["inputSearchFilterInsideList"], descendants: true }], ngImport: i0, template: "<div\r\n  [class.show]=\"show\"\r\n  [id]=\"id\"\r\n  class=\"dg-autocomplete2 sdk-absolute-content-insert-elements {{classes}}\"\r\n>\r\n  <div\r\n    #root\r\n    class=\"root-autocomplete2 theme-root-autocomplete2\"\r\n    [class.cdk-root-dg-autocomplete-position-y-bottom]=\"htmlManage.config.positionY == 'bottom'\"\r\n    [class.cdk-root-dg-autocomplete-position-y-top]=\"htmlManage.config.positionY == 'top'\"\r\n    (click)=\"closeClickOut($event)\"\r\n  >\r\n    <div class=\"cdk-content-autocomplete2 key-content-autocomplete2\">\r\n      <div\r\n        #listBox\r\n        class=\"cdk-list-box-autocomplete2 theme-list-box-autocomplete2 key-listbox-autocomplete2\"\r\n        [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.config.positionY == 'bottom'\"\r\n        [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.config.positionY == 'top'\"\r\n        [class.cdk-dg-autocomplete-position-x-start]=\"htmlManage.config.positionX == 'start'\"\r\n        [class.cdk-dg-autocomplete-position-x-end]=\"htmlManage.config.positionX == 'end'\"\r\n        [class.cdk-dg-cutocomplete-ajuste-width-auto]=\"htmlManage.config.widthDivList == 'auto'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-justify]=\"htmlManage.config.widthDivList == 'justify'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-min-justify]=\"htmlManage.config.widthDivList == 'min-justify'\"\r\n      >\r\n        <div class=\"cdk-list-content-autocomplete2\">\r\n          <!--\r\n        #################################################################\r\n        ##### INPUT DE FILTRO\r\n        #################################################################\r\n        -->\r\n          <div *ngIf=\"((position == 'inside' && showInputSearch != false) || !!showInputSearch)\" class=\"cdk-content-section-list\">\r\n            <input\r\n              #inputSearchFilterInsideList\r\n              class=\"form-control\"\r\n              placeholder=\"Pesquisar...\"\r\n              [(ngModel)]=\"search\"\r\n              (ngModelChange)=\"filter($event)\"\r\n            >\r\n          </div>\r\n\r\n\r\n          <!--\r\n          #################################################################\r\n          ##### LISTA DE ITENS SELECIONADOS\r\n          #################################################################\r\n          -->\r\n          <div class=\"cdk-content-section-list\" *ngIf=\"verifyShowSelectedList()\">\r\n            <div class=\"cdk-content-section-list theme-list-selected-header\">\r\n              <!-- CONTENT DE HEADER DA LISTA DE ITENS SELECIONADOS -->\r\n              <ng-container\r\n                *ngIf=\"headerListSelected\"\r\n                [ngTemplateOutlet]=\"headerListSelected\"\r\n              >\r\n              </ng-container>\r\n\r\n              <!-- #### HEADER PADR\u00C3O DA LISTA DE SELECIONADOS -->\r\n              <span *ngIf=\"!headerListSelected\" class=\"theme-list-selected-header-title\">Itens selecionados</span>\r\n            </div>\r\n\r\n\r\n            <div class=\"cdk-content-section-list theme-list-selected-body\" *ngIf=\"selectedList.length > 0\">\r\n              <ul class=\"theme-ul-items-selected-autocomplete2\">\r\n                <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n                <li *ngFor=\"let item of selectedList; let i = index\" (click)=\"unSelectOption(i)\">\r\n                  <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n                  <div *ngIf=\"!listOptionSelected && !listOption\">\r\n                    <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                    {{getLabel(item)}}\r\n                  </div>\r\n                  <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n                  <ng-container\r\n                    *ngIf=\"listOptionSelected\"\r\n                    [ngTemplateOutlet]=\"listOptionSelected\"\r\n                  >\r\n                  </ng-container>\r\n                  <!--\r\n                     CONTENT DA LISTA\r\n                     nesse caso quando houver um template para os itens a selecionar e n\u00E3o houver uma de itens selecionados\r\n                     essa template valer\u00E1 para todas (selecionadas e a selecionar)\r\n                  -->\r\n                  <ng-container\r\n                    *ngIf=\"listOption && !listOptionSelected\"\r\n                    [ngTemplateOutlet]=\"listOption\"\r\n                    [ngTemplateOutletContext]=\"{$implicit:contentChilds.listOptionSelected(item, i)}\"\r\n                  >\r\n                  </ng-container>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n\r\n            <hr>\r\n          </div>\r\n\r\n\r\n          <!--\r\n          #################################################################\r\n          ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n          #################################################################\r\n          -->\r\n          <div class=\"cdk-content-section-list\">\r\n            <div class=\"cdk-content-section-list theme-list-header\">\r\n              <!-- #### HEADER CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"headerList\"\r\n                [ngTemplateOutlet]=\"headerList\"\r\n              >\r\n              </ng-container>\r\n              <!-- #### HEADER PADR\u00C3O DA LISTA DE ITENS -->\r\n              <span *ngIf=\"!headerList\" class=\"theme-list-header-title\">Selecionar</span>\r\n            </div>\r\n\r\n\r\n            <div class=\"cdk-content-section-list theme-list-body\">\r\n              <ul class=\"theme-ul-items-autocomplete2\">\r\n                <!-- #### ITENS DA LISTA -->\r\n                <li *ngIf=\"getListFiltered().length == 0\" class=\"theme-li-items-autocomplete2\">\r\n                  Nenhum registro encontrado\r\n                </li>\r\n                <li\r\n                  *ngFor=\"let item of getListFiltered(); let i = index\"\r\n                  class=\"theme-li-items-autocomplete2\"\r\n                  [class.selected]=\"verifySelectedItem(i)\"\r\n                  (click)=\"selectOption(item, i)\"\r\n                  [hidden]=\"verifications.ocultarItemSelecionado() && verifySelectedItem(i)\"\r\n                >\r\n                  <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n                  <div *ngIf=\"!listOption\">\r\n                    <input [type]=\"typeCheckInputOption\" *ngIf=\"(!!multiple || !!showCheckInputOption)\" [checked]=\"verifySelectedItem(i)\">\r\n                    {{getLabel(item)}}\r\n                  </div>\r\n                  <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n                  <ng-container\r\n                    *ngIf=\"listOption\"\r\n                    [ngTemplateOutlet]=\"listOption\"\r\n                    [ngTemplateOutletContext]=\"{$implicit:contentChilds.listOption(item, i)}\"\r\n                  >\r\n                  </ng-container>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AutocompleteListStickyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'autocomplete-list-sticky', template: "<div\r\n  [class.show]=\"show\"\r\n  [id]=\"id\"\r\n  class=\"dg-autocomplete2 sdk-absolute-content-insert-elements {{classes}}\"\r\n>\r\n  <div\r\n    #root\r\n    class=\"root-autocomplete2 theme-root-autocomplete2\"\r\n    [class.cdk-root-dg-autocomplete-position-y-bottom]=\"htmlManage.config.positionY == 'bottom'\"\r\n    [class.cdk-root-dg-autocomplete-position-y-top]=\"htmlManage.config.positionY == 'top'\"\r\n    (click)=\"closeClickOut($event)\"\r\n  >\r\n    <div class=\"cdk-content-autocomplete2 key-content-autocomplete2\">\r\n      <div\r\n        #listBox\r\n        class=\"cdk-list-box-autocomplete2 theme-list-box-autocomplete2 key-listbox-autocomplete2\"\r\n        [class.cdk-dg-autocomplete-position-y-bottom]=\"htmlManage.config.positionY == 'bottom'\"\r\n        [class.cdk-dg-autocomplete-position-y-top]=\"htmlManage.config.positionY == 'top'\"\r\n        [class.cdk-dg-autocomplete-position-x-start]=\"htmlManage.config.positionX == 'start'\"\r\n        [class.cdk-dg-autocomplete-position-x-end]=\"htmlManage.config.positionX == 'end'\"\r\n        [class.cdk-dg-cutocomplete-ajuste-width-auto]=\"htmlManage.config.widthDivList == 'auto'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-justify]=\"htmlManage.config.widthDivList == 'justify'\"\r\n        [class.cdk-dg-autocomplete-ajuste-width-min-justify]=\"htmlManage.config.widthDivList == 'min-justify'\"\r\n      >\r\n        <div class=\"cdk-list-content-autocomplete2\">\r\n          <!--\r\n        #################################################################\r\n        ##### INPUT DE FILTRO\r\n        #################################################################\r\n        -->\r\n          <div *ngIf=\"((position == 'inside' && showInputSearch != false) || !!showInputSearch)\" class=\"cdk-content-section-list\">\r\n            <input\r\n              #inputSearchFilterInsideList\r\n              class=\"form-control\"\r\n              placeholder=\"Pesquisar...\"\r\n              [(ngModel)]=\"search\"\r\n              (ngModelChange)=\"filter($event)\"\r\n            >\r\n          </div>\r\n\r\n\r\n          <!--\r\n          #################################################################\r\n          ##### LISTA DE ITENS SELECIONADOS\r\n          #################################################################\r\n          -->\r\n          <div class=\"cdk-content-section-list\" *ngIf=\"verifyShowSelectedList()\">\r\n            <div class=\"cdk-content-section-list theme-list-selected-header\">\r\n              <!-- CONTENT DE HEADER DA LISTA DE ITENS SELECIONADOS -->\r\n              <ng-container\r\n                *ngIf=\"headerListSelected\"\r\n                [ngTemplateOutlet]=\"headerListSelected\"\r\n              >\r\n              </ng-container>\r\n\r\n              <!-- #### HEADER PADR\u00C3O DA LISTA DE SELECIONADOS -->\r\n              <span *ngIf=\"!headerListSelected\" class=\"theme-list-selected-header-title\">Itens selecionados</span>\r\n            </div>\r\n\r\n\r\n            <div class=\"cdk-content-section-list theme-list-selected-body\" *ngIf=\"selectedList.length > 0\">\r\n              <ul class=\"theme-ul-items-selected-autocomplete2\">\r\n                <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n                <li *ngFor=\"let item of selectedList; let i = index\" (click)=\"unSelectOption(i)\">\r\n                  <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n                  <div *ngIf=\"!listOptionSelected && !listOption\">\r\n                    <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                    {{getLabel(item)}}\r\n                  </div>\r\n                  <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n                  <ng-container\r\n                    *ngIf=\"listOptionSelected\"\r\n                    [ngTemplateOutlet]=\"listOptionSelected\"\r\n                  >\r\n                  </ng-container>\r\n                  <!--\r\n                     CONTENT DA LISTA\r\n                     nesse caso quando houver um template para os itens a selecionar e n\u00E3o houver uma de itens selecionados\r\n                     essa template valer\u00E1 para todas (selecionadas e a selecionar)\r\n                  -->\r\n                  <ng-container\r\n                    *ngIf=\"listOption && !listOptionSelected\"\r\n                    [ngTemplateOutlet]=\"listOption\"\r\n                    [ngTemplateOutletContext]=\"{$implicit:contentChilds.listOptionSelected(item, i)}\"\r\n                  >\r\n                  </ng-container>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n\r\n            <hr>\r\n          </div>\r\n\r\n\r\n          <!--\r\n          #################################################################\r\n          ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n          #################################################################\r\n          -->\r\n          <div class=\"cdk-content-section-list\">\r\n            <div class=\"cdk-content-section-list theme-list-header\">\r\n              <!-- #### HEADER CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"headerList\"\r\n                [ngTemplateOutlet]=\"headerList\"\r\n              >\r\n              </ng-container>\r\n              <!-- #### HEADER PADR\u00C3O DA LISTA DE ITENS -->\r\n              <span *ngIf=\"!headerList\" class=\"theme-list-header-title\">Selecionar</span>\r\n            </div>\r\n\r\n\r\n            <div class=\"cdk-content-section-list theme-list-body\">\r\n              <ul class=\"theme-ul-items-autocomplete2\">\r\n                <!-- #### ITENS DA LISTA -->\r\n                <li *ngIf=\"getListFiltered().length == 0\" class=\"theme-li-items-autocomplete2\">\r\n                  Nenhum registro encontrado\r\n                </li>\r\n                <li\r\n                  *ngFor=\"let item of getListFiltered(); let i = index\"\r\n                  class=\"theme-li-items-autocomplete2\"\r\n                  [class.selected]=\"verifySelectedItem(i)\"\r\n                  (click)=\"selectOption(item, i)\"\r\n                  [hidden]=\"verifications.ocultarItemSelecionado() && verifySelectedItem(i)\"\r\n                >\r\n                  <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n                  <div *ngIf=\"!listOption\">\r\n                    <input [type]=\"typeCheckInputOption\" *ngIf=\"(!!multiple || !!showCheckInputOption)\" [checked]=\"verifySelectedItem(i)\">\r\n                    {{getLabel(item)}}\r\n                  </div>\r\n                  <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n                  <ng-container\r\n                    *ngIf=\"listOption\"\r\n                    [ngTemplateOutlet]=\"listOption\"\r\n                    [ngTemplateOutletContext]=\"{$implicit:contentChilds.listOption(item, i)}\"\r\n                  >\r\n                  </ng-container>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], key: [{
                type: Input
            }], data: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showSelectedList: [{
                type: Input
            }], showSelectedOption: [{
                type: Input
            }], showInputSearch: [{
                type: Input
            }], position: [{
                type: Input
            }], typeFilter: [{
                type: Input
            }], widthDivList: [{
                type: Input
            }], itenSelfUnselect: [{
                type: Input
            }], search: [{
                type: Input
            }], classes: [{
                type: Input
            }], showCheckInputOption: [{
                type: Input
            }], typeCheckInputOption: [{
                type: Input
            }], clearSearchOnClose: [{
                type: Input
            }], clearSearchOnOpen: [{
                type: Input
            }], setValue: [{
                type: Output,
                args: ['setValue']
            }], closeList: [{
                type: Output,
                args: ['closeList']
            }], searchFilterValue: [{
                type: Output,
                args: ['searchFilterValue']
            }], divRoot: [{
                type: ViewChild,
                args: ['root']
            }], divListBox: [{
                type: ViewChild,
                args: ['listBox']
            }], inputSearchFilterInsideList: [{
                type: ViewChild,
                args: ['inputSearchFilterInsideList']
            }], headerList: [{
                type: ContentChild,
                args: ['header_list', { static: false }]
            }], listOption: [{
                type: ContentChild,
                args: ['list_option', { static: false }]
            }], headerListSelected: [{
                type: ContentChild,
                args: ['header_list_selected', { static: false }]
            }], listOptionSelected: [{
                type: ContentChild,
                args: ['list_option_selected', { static: false }]
            }] } });

class DgAutocompleteComponent {
    constructor(ngControl) {
        this.ngControl = ngControl;
        /**======================================================
         *
         *  METODOS DE RELAÇÃO COM NG_VALUE_ACCESSOR
         *
         *  Os metodos abaixo servem para relação entre o componente e o form (caso exista)
         =======================================================*/
        // valor de dados sincronizado com os FORMs
        this.value = '';
        // metodo repositório do "onChange()" fornecido pelo NG_VALUE_ACCESSOR
        this.onChange = (val) => {
        };
        // metodo repositório do "onTouched()" fornecido pelo NG_VALUE_ACCESSOR
        this.onTouched = () => {
        };
        this.onValidationChange = () => { };
        // inputs que controlam eventos
        this.itenSelfUnselect = true;
        this.clearSearchOnClose = true;
        this.clearSearchOnOpen = true;
        this.freeHand = false;
        // inputs da base de dados
        this.label = '';
        this.key = '';
        this.data = [];
        this.typeCheckInputOption = 'checkbox';
        this.classes = '';
        this.close = new EventEmitter();
        this.searchFilterValue = new EventEmitter();
        this.searchFilter = new FormControl('');
        this.uniqIdHtml = '';
        // CONJUNTO DE FUNÇÕES DE ACESSO AO COMPONENTE DE LISTA
        this.listControl = {
            open: (referenceId) => {
                const listComponent = this.listControl.getInstance();
                if (!(listComponent === null || listComponent === void 0 ? void 0 : listComponent.show)) {
                    this.onTouched();
                    if (!!this.multiple && (listComponent.selectedList || []).length > 0)
                        this.searchFilter.reset('');
                }
                if (this.clearSearchOnOpen) {
                    listComponent.search = '';
                    this.searchFilter.patchValue('');
                }
                if (this.position)
                    listComponent.position = this.position;
                if (this.label)
                    listComponent.label = this.label;
                if (this.key)
                    listComponent.key = this.key;
                if (this.multiple)
                    listComponent.multiple = this.multiple;
                if (this.showSelectedList)
                    listComponent.showSelectedList = this.showSelectedList;
                if (this.typeFilter)
                    listComponent.typeFilter = this.typeFilter;
                if (this.widthDivList)
                    listComponent.widthDivList = this.widthDivList;
                if (this.itenSelfUnselect)
                    listComponent.itenSelfUnselect = this.itenSelfUnselect;
                if (this.showInputSearch != undefined)
                    listComponent.showInputSearch = this.showInputSearch;
                if (this.clearSearchOnClose != undefined)
                    listComponent.clearSearchOnClose = this.clearSearchOnClose;
                if (this.clearSearchOnOpen != undefined)
                    listComponent.clearSearchOnOpen = this.clearSearchOnOpen;
                if (this.showCheckInputOption != undefined)
                    listComponent.showCheckInputOption = this.showCheckInputOption;
                if (this.typeCheckInputOption != undefined)
                    listComponent.typeCheckInputOption = this.typeCheckInputOption;
                listComponent.showSelectedOption = this.showSelectedOption;
                listComponent.open(referenceId);
            },
            close: () => {
                if (!!this.customListComponent) {
                    this.customListComponent.close();
                }
                else {
                    this.listComponent.close();
                }
            },
            filter: (val) => {
                // if (this.freeHand && !this.multiple) {
                //   this.setValue(val);
                // }
                this.listControl.getInstance().filter(val);
            },
            getInstance: () => {
                return !!this.customListComponent ? this.customListComponent : this.listComponent;
            },
            reloaderFakeValue: (value = this.value) => {
                if (!this.listControl.getInstance())
                    return;
                const fakeValue = this.listControl.getInstance().receiveNewValues(value, this.key, this.label);
                this.searchFilter.patchValue(fakeValue, { emitEvent: false });
                return;
            },
            getSelected: () => {
                const result = this.listControl.getInstance().selectedList;
                if (this.multiple) {
                    return result;
                }
                if (!!result[0]) {
                    return result[0];
                }
                return {};
            }
        };
        /**
         *  RECEIVE
         *  Metodos de recebimento do objeto de lista
         */
        this.receiveListControl = {
            closeList: (value) => {
                // if (!this.freeHand && !this.multiple) {
                if (!!value) {
                    this.setFakeValue(value);
                }
                this.close.emit(this.value);
            },
            setValue: (ev) => {
                if (!Array.isArray(ev))
                    return;
                this.setValue(ev);
                if (this.multiple)
                    this.searchFilter.patchValue('');
            }
        };
        ngControl.valueAccessor = this;
        this.uniqIdHtml = uniqIdHtml(val => 'dg-autocomplete2-input-key-' + val);
        this.searchFilter.valueChanges.pipe(distinctUntilChanged()).subscribe(val => {
            if (!this.multiple && this.freeHand) {
                this.listControl.getInstance().selectedList = [];
            }
            this.listControl.filter(val);
        });
    }
    setDisabledState(isDisabled) {
        this.searchFilter[isDisabled ? 'disable' : 'enable']();
    }
    // metodo de registro do "onChange()"
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    // metodo de registro do "onTouched()"
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    /*
     * metodo de acesso exclusívo do form.
     * esse metodo entrará em ação quando um valor for fornecido pelo form pai
     * e não por ações do próprio autocomplete
     *
     * @param value
     */
    writeValue(value) {
        this.value = value;
        this.listControl.reloaderFakeValue(value);
    }
    /*
     * Metodo de acesso interno.
     * Esse metodo deve ser utilizado apenas em ciclos internos
     */
    setValue(ev) {
        this.value = ev;
        this.onChange(this.value);
    }
    setFakeValue(ev) {
        this.searchFilter.patchValue(ev, { emitEvent: false });
        // this.close.emit(this.listControl.getInstance().selectedList)
    }
    validate(c) {
        this.validationResult = { 'sync': true };
        return null;
    }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
    ngAfterContentChecked() {
        var _a;
        const currentInstance = this.listControl.getInstance();
        if (!((_a = this.listControl.getInstance()) === null || _a === void 0 ? void 0 : _a.show)) {
            this.listControl.reloaderFakeValue();
        }
        if (currentInstance) {
            currentInstance.data = this.data;
        }
    }
}
DgAutocompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteComponent, deps: [{ token: i1$1.NgControl }], target: i0.ɵɵFactoryTarget.Component });
DgAutocompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgAutocompleteComponent, selector: "dg-autocomplete", inputs: { label: "label", key: "key", data: "data", typeFilter: "typeFilter", position: "position", typeCheckInputOption: "typeCheckInputOption", widthDivList: "widthDivList", classes: "classes" }, outputs: { close: "close", searchFilterValue: "searchFilterValue" }, queries: [{ propertyName: "inputAutocomplete", first: true, predicate: ["inputAutocomplete"], descendants: true }], viewQueries: [{ propertyName: "listComponent", first: true, predicate: ["autocompleteListSticky"], descendants: true }], ngImport: i0, template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<input\r\n  *ngIf=\"!inputAutocomplete\"\r\n  type=\"text\"\r\n  class=\"{{classes}}\"\r\n  [id]=\"uniqIdHtml\"\r\n  [formControl]=\"searchFilter\"\r\n  [class.ng-touched]=\"ngControl.touched\"\r\n  [class.ng-invalid]=\"ngControl.invalid\"\r\n  [class.ng-valid]=\"!ngControl.invalid\"\r\n  (focus)=\"listControl.open(uniqIdHtml)\"\r\n  (click)=\"listControl.open(uniqIdHtml)\"\r\n>\r\n<!--LISTA DINAMICO CASO NENHUMA SEJA PASSADA-->\r\n<autocomplete-list-sticky\r\n  *ngIf=\"!customListComponent\"\r\n  #autocompleteListSticky\r\n  [data]=\"data\"\r\n  (setValue)=\"receiveListControl.setValue($event)\"\r\n  (closeList)=\"receiveListControl.closeList($event)\"\r\n  (searchFilterValue)=\"searchFilterValue.emit($event)\"\r\n>\r\n</autocomplete-list-sticky>\r\n", styles: [""], components: [{ type: AutocompleteListStickyComponent, selector: "autocomplete-list-sticky", inputs: ["label", "key", "data", "multiple", "showSelectedList", "showSelectedOption", "showInputSearch", "position", "typeFilter", "widthDivList", "itenSelfUnselect", "search", "classes", "showCheckInputOption", "typeCheckInputOption", "clearSearchOnClose", "clearSearchOnOpen"], outputs: ["setValue", "closeList", "searchFilterValue"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-autocomplete', template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<input\r\n  *ngIf=\"!inputAutocomplete\"\r\n  type=\"text\"\r\n  class=\"{{classes}}\"\r\n  [id]=\"uniqIdHtml\"\r\n  [formControl]=\"searchFilter\"\r\n  [class.ng-touched]=\"ngControl.touched\"\r\n  [class.ng-invalid]=\"ngControl.invalid\"\r\n  [class.ng-valid]=\"!ngControl.invalid\"\r\n  (focus)=\"listControl.open(uniqIdHtml)\"\r\n  (click)=\"listControl.open(uniqIdHtml)\"\r\n>\r\n<!--LISTA DINAMICO CASO NENHUMA SEJA PASSADA-->\r\n<autocomplete-list-sticky\r\n  *ngIf=\"!customListComponent\"\r\n  #autocompleteListSticky\r\n  [data]=\"data\"\r\n  (setValue)=\"receiveListControl.setValue($event)\"\r\n  (closeList)=\"receiveListControl.closeList($event)\"\r\n  (searchFilterValue)=\"searchFilterValue.emit($event)\"\r\n>\r\n</autocomplete-list-sticky>\r\n", styles: [""] }]
        }], ctorParameters: function () { return [{ type: i1$1.NgControl }]; }, propDecorators: { label: [{
                type: Input
            }], key: [{
                type: Input
            }], data: [{
                type: Input
            }], typeFilter: [{
                type: Input
            }], position: [{
                type: Input
            }], typeCheckInputOption: [{
                type: Input
            }], widthDivList: [{
                type: Input
            }], classes: [{
                type: Input
            }], close: [{
                type: Output,
                args: ['close']
            }], searchFilterValue: [{
                type: Output,
                args: ['searchFilterValue']
            }], inputAutocomplete: [{
                type: ContentChild,
                args: ['inputAutocomplete', { static: false }]
            }], listComponent: [{
                type: ViewChild,
                args: ['autocompleteListSticky']
            }] } });

class AbstractConnectCustomNgModelComponent {
    constructor(_ngControl) {
        this._ngControl = _ngControl;
        /**======================================================
         *
         *  METODOS DE RELAÇÃO COM NG_VALUE_ACCESSOR
         *
         *  Os metodos abaixo servem para relação entre o componente e o form (caso exista)
         =======================================================*/
        // valor de dados sincronizado com os FORMs
        this.value = '';
        this.touched = false;
        // metodo repositório do "onChange()" fornecido pelo NG_VALUE_ACCESSOR
        this.onChange = (val) => {
        };
        // metodo repositório do "onTouched()" fornecido pelo NG_VALUE_ACCESSOR
        this.onTouched = () => {
        };
        this.onValidationChange = () => {
        };
        // _ngControl.valueAccessor = this;
        if (!!_ngControl)
            _ngControl.valueAccessor = this;
    }
    setDisabledState(isDisabled) {
        // this.searchFilter[isDisabled ? 'disable' : 'enable']()
        console.log('setDisabledState', isDisabled);
    }
    // metodo de registro do "onChange()"
    registerOnChange(onChange) {
        this.onChange = onChange;
    }
    // metodo de registro do "onTouched()"
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    /*
     * metodo de acesso exclusívo do form.
     * esse metodo entrará em ação quando um valor for fornecido pelo form pai
     * e não por ações do próprio autocomplete
     *
     * @param value
     */
    writeValue(value) {
        this.value = value;
    }
    /*
     * Metodo de acesso interno.
     * Esse metodo deve ser utilizado apenas em ciclos internos
     */
    setValue(ev) {
        this.value = ev;
        this.onChange(this.value);
    }
    validate(c) {
        this.validationResult = { 'sync': true };
        return null;
    }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
}
AbstractConnectCustomNgModelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractConnectCustomNgModelComponent, deps: [{ token: i1$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AbstractConnectCustomNgModelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: AbstractConnectCustomNgModelComponent, selector: "ng-component", ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractConnectCustomNgModelComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    } });

class AbstractDgAutocomplete extends AbstractConnectCustomNgModelComponent {
    constructor(__ngControl) {
        super(__ngControl);
        this.__ngControl = __ngControl;
        // inputs que controlam eventos
        this.itenSelfUnselect = true;
        this.clearSearchOnClose = true;
        this.clearSearchOnOpen = true;
        this.freeHand = false;
        // inputs da base de dados
        this.label = '';
        this.key = '';
        this.data = [];
        //inputs de posicionamento e estilo
        // @Input() position: 'inside' | 'outside' | undefined;
        this.positionY = 'auto';
        this.positionX = 'start';
        this.listInsideInput = false;
        this.typeCheckInputOption = 'checkbox';
        // @Input() widthDivList: CdkListStickyAutocomplete3.widthDivList | undefined;
        this.classes = '';
        this.close = new EventEmitter();
        this.searchFilterValue = new EventEmitter();
        this.change = new EventEmitter();
        this.opened = false;
        this.searchFilter = new FormControl('');
        this.inputId = '';
        // lista de itens selecionados
        this.selectedList = [];
        /**
         * Controles de funções basicas do loader
         */
        this._controls = {
            events: {
                selectOption: (itemSelected, index) => {
                    var _a;
                    console.log('teste');
                    if (this.itenSelfUnselect) {
                        const indexItemSelected = this
                            .selectedList.findIndex(item => this._controls.item.getKey(item) == this._controls.item.getKey(itemSelected));
                        if (indexItemSelected != -1) {
                            this._controls.events.unSelectOption(indexItemSelected);
                            return;
                        }
                    }
                    if (!this.multiple)
                        this.selectedList = [];
                    this.selectedList.push(this.controls.getListFiltered()[index]);
                    // this.setFakeValue('');
                    (_a = document.getElementById(this.inputId)) === null || _a === void 0 ? void 0 : _a.focus();
                    this.setValue();
                    if (!this.multiple) {
                        setTimeout(() => this.controls.close(), 10);
                    }
                },
                unSelectOption: (index) => {
                    this.selectedList.splice(index, 1);
                    this.setValue();
                },
                clickMouseClose: (ev) => {
                    if (!this._controls.verify.isClickInsideElement(ev, this.inputId)
                        && !this._controls.verify.isClickInsideElement(ev, this.inputId + '-list')) {
                        this.controls.close();
                    }
                },
                escClose: (ev) => {
                    if (ev.key == 'Escape') {
                        this.controls.close();
                    }
                },
                positionListByInput: () => {
                    const element = window.document.getElementById(this.inputId);
                    const container = window.document.getElementById(this.inputId + '-root-popper');
                    if (!element || !container)
                        return;
                    const elementInputCoordinates = element.getBoundingClientRect();
                    let positionY = this.positionY != 'auto' ? this.positionY : this._controls.verify.verifyPositionY(elementInputCoordinates);
                    const contaierStyles = {
                        height: '',
                        transform: '',
                        width: '',
                    };
                    if (positionY == 'top') {
                        container.classList.remove('positionY-bottom');
                        container.classList.add('positionY-top');
                        if (this.listInsideInput) {
                            contaierStyles.height = `${elementInputCoordinates.bottom}px`;
                        }
                        else {
                            contaierStyles.height = `${elementInputCoordinates.top}px`;
                        }
                    }
                    else {
                        container.classList.remove('positionY-top');
                        container.classList.add('positionY-bottom');
                        if (this.listInsideInput) {
                            contaierStyles.transform = `translateY(${elementInputCoordinates.top}px)`;
                            contaierStyles.height = `${window.innerHeight - elementInputCoordinates.top}px`;
                        }
                        else {
                            contaierStyles.transform = `translateY(${elementInputCoordinates.bottom}px)`;
                            contaierStyles.height = `${window.innerHeight - elementInputCoordinates.bottom}px`;
                        }
                    }
                    if (this.positionX == 'start') {
                        container.classList.remove('positionX-end');
                        container.classList.add('positionX-start');
                        contaierStyles.transform += ` translateX(${elementInputCoordinates.x}px)`;
                        contaierStyles.width = `${window.innerWidth - elementInputCoordinates.x - 30}px`;
                    }
                    else {
                        container.classList.remove('positionX-start');
                        container.classList.add('positionX-end');
                        contaierStyles.width = `${elementInputCoordinates.right}px`;
                    }
                    container.style.height = contaierStyles.height;
                    container.style.transform = contaierStyles.transform;
                    container.style.maxWidth = contaierStyles.width;
                },
                updateSelectedListByValue: () => {
                    const value = this.value;
                    if (!!this.multiple) {
                        if (!Array.isArray(value)) {
                            return;
                        }
                        if (value.length <= 0) {
                            this.selectedList = [];
                        }
                        else {
                            const listvaluesIsNotExistInSelectedList = value.map(itemValue => {
                                if (this.selectedList.find(itemSelected => this._controls.item.getKey(itemSelected) == itemValue)) {
                                    return false;
                                }
                                return itemValue;
                            }).filter(itemValue => !!itemValue);
                            const newSelectedList = listvaluesIsNotExistInSelectedList.map(val => {
                                const item = this.data.find(item => this._controls.item.getKey(item) == val);
                                if (!!item)
                                    return item;
                                return false;
                            }).filter(val => !!val);
                            this.selectedList = [...this.selectedList, ...newSelectedList];
                        }
                    }
                    else {
                        if (!this.selectedList.find(item => this._controls.item.getKey(item) == value)) {
                            this.selectedList = this.data.filter(item => this._controls.item.getKey(item) == value);
                        }
                    }
                    if (!this.opened)
                        this.setFakeValue(this.selectedList.map(item => this._controls.item.getLabel(item)).join(', '));
                }
            },
            verify: {
                showSelectedList: () => {
                    if (typeof this.showSelectedList == 'boolean') {
                        return this.showSelectedList;
                    }
                    return this.multiple;
                },
                isClickInsideElement: (event, elementId) => {
                    const clickedElement = event.target;
                    const targetElement = document.getElementById(elementId);
                    return targetElement ? targetElement.contains(clickedElement) : false;
                },
                ocultarItemSelecionado: () => {
                    if (!this.multiple) {
                        if (this.showSelectedOption == undefined)
                            return false;
                        return !this.showSelectedOption;
                    }
                    if (this.showSelectedOption == undefined)
                        return true;
                    return !this.showSelectedOption;
                },
                selectedItem: (index) => {
                    const indexItemSelected = this.selectedList.findIndex(item => {
                        if (!this.key) {
                            return JSON.stringify(item) == JSON.stringify(this.data[index]);
                        }
                        return String(this._controls.item.getKey(item)).toUpperCase() === String(this._controls.item.getKey(this.controls.getListFiltered()[index])).toUpperCase();
                    });
                    return indexItemSelected != -1;
                },
                verifyPositionY: (elementInputCoordinates) => {
                    // verifica se o BOTTOM é menor que o mínimo '300px'
                    if ((window.innerHeight - elementInputCoordinates.top + elementInputCoordinates.height) < 300) {
                        // verifica se o TOP é menor do que o BOTTOM
                        if ((window.innerHeight - elementInputCoordinates.top + (elementInputCoordinates.height / 2)) > elementInputCoordinates.top + (elementInputCoordinates.height / 2)) {
                            return 'bottom';
                        }
                        else {
                            return 'top';
                        }
                    }
                    return "bottom";
                },
                /**
                 * Metodo que permite simplificar escrita de inputs booleanos, capturando entradas de string
                 * tanto para valores convertidos quanto sua escrita simplificada, exemplo abaixo
                 * [multiple]="true"
                 *    => multiple
                 *    => multiple="true"
                 *    => [multiple]="true"
                 * @param value
                 */
                verifyInputBoolean: (value) => {
                    if (typeof value == 'boolean')
                        return value;
                    if (typeof value == 'string') {
                        if (value == '')
                            return true;
                        return value == 'true';
                    }
                    return false;
                }
            },
            item: {
                getLabel: (item, label = this.label) => {
                    if (typeof item == 'string')
                        return item;
                    if (typeof label == 'string') {
                        if (label in (item || {})) {
                            return item[label];
                        }
                        else {
                            return '--';
                        }
                    }
                    if (Array.isArray(label)) {
                        const labelArray = Array.isArray(label) ? label : [];
                        let result = item;
                        labelArray.map((nivelArray) => {
                            if (nivelArray in result) {
                                result = result[nivelArray];
                            }
                        });
                        return result;
                    }
                    return '--';
                },
                getKey: (item, key = this.key) => {
                    if (typeof item == 'string')
                        return item;
                    if (!key)
                        return item;
                    if (typeof key == 'string') {
                        if (key in (item || {})) {
                            return item[key];
                        }
                        else {
                            return '';
                        }
                    }
                    if (Array.isArray(key)) {
                        const keysArray = Array.isArray(key) ? key : [];
                        let result = item;
                        keysArray.map((nivelArray) => {
                            if (nivelArray in result) {
                                result = result[nivelArray];
                            }
                        });
                        return result;
                    }
                    return '--';
                },
            },
            dataTemplate: {
                template_item: (option, index) => {
                    return {
                        row: option,
                        label: this._controls.item.getLabel(option),
                        key: this._controls.item.getKey(option),
                        selected: this._controls.verify.selectedItem(index)
                    };
                },
                template_item_selected: (option, index) => {
                    return {
                        row: option,
                        label: this._controls.item.getLabel(option),
                        key: this._controls.item.getKey(option),
                        selected: true
                    };
                },
            }
        };
        this.controls = {
            open: () => {
                var _a;
                const divContainer = document.getElementById(this.inputId + '-root-popper');
                if (!divContainer)
                    return;
                this.setFakeValue('');
                this.opened = true;
                this._controls.events.positionListByInput();
                divContainer.setAttribute('data-show', '');
                window.addEventListener('keyup', this._controls.events.escClose);
                window.addEventListener('click', this._controls.events.clickMouseClose);
                window.addEventListener('scroll', this._controls.events.positionListByInput);
                window.addEventListener('resize', this._controls.events.positionListByInput);
                if (this.listInsideInput) {
                    (_a = document.getElementById(this.inputId + '-inside-input')) === null || _a === void 0 ? void 0 : _a.focus();
                }
            },
            close: () => {
                var _a;
                const divContainer = document.getElementById(this.inputId + '-root-popper');
                if (!divContainer)
                    return;
                this.opened = false;
                this.setFakeValue(this.selectedList.map(item => this._controls.item.getLabel(item)).join(', '));
                if (this.value !== this.previousValue) {
                    this.change.emit(this.value);
                    this.previousValue = this.value;
                }
                this.close.emit(this.value);
                (_a = this._ngControl.control) === null || _a === void 0 ? void 0 : _a.markAllAsTouched();
                divContainer.removeAttribute('data-show');
                window.removeEventListener('click', this._controls.events.clickMouseClose);
                window.removeEventListener('keyup', this._controls.events.escClose);
                window.removeEventListener('scroll', this._controls.events.positionListByInput);
                window.removeEventListener('resize', this._controls.events.positionListByInput);
            },
            /**
             * metodo de retorno de itens filtrados.
             */
            getListFiltered: () => {
                // caso a busca seja externa, apenas retorna a lista
                if (this.typeFilter == 'outside')
                    return this.data;
                if (!this.searchFilter.value)
                    return this.data;
                const search = clearString(String(this.searchFilter.value) || '').toUpperCase();
                // filtros internos
                return this.data.filter(item => {
                    const itemList = clearString(String(this._controls.item.getLabel(item) || '')).toUpperCase();
                    return itemList.includes(search);
                });
            }
        };
        this.inputId = uniqIdHtml(val => 'dg-autocomplete3-key-' + val);
        this.searchFilter.valueChanges.subscribe(value => {
            if (this.typeFilter == 'outside') {
                this.searchFilterValue.emit(value);
            }
        });
    }
    setFakeValue(ev) {
        this.searchFilter.patchValue(ev, { emitEvent: false });
    }
    writeValue(value) {
        super.writeValue(value);
        this.previousValue = value;
        this._controls.events.updateSelectedListByValue();
    }
    setValue(value) {
        if (!value) {
            if (!!this.multiple) {
                value = this.selectedList.map(item => this._controls.item.getKey(item));
            }
            else {
                value = this._controls.item.getKey(this.selectedList[0]) || '';
            }
        }
        super.setValue(value);
    }
    setDisabledState(isDisabled) {
        this.searchFilter[isDisabled ? 'disable' : 'enable']();
    }
    ngOnInit() {
        if (!!this.multiple) {
            if (!Array.isArray(this.value)) {
                this.setValue([]);
            }
        }
    }
    ngOnChanges(changes) {
        var _a, _b;
        if (JSON.stringify((_a = changes['data']) === null || _a === void 0 ? void 0 : _a.previousValue) !==
            JSON.stringify((_b = changes['data']) === null || _b === void 0 ? void 0 : _b.currentValue)) {
            this._controls.events.updateSelectedListByValue();
        }
    }
}
AbstractDgAutocomplete.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractDgAutocomplete, deps: [{ token: i1$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
AbstractDgAutocomplete.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: AbstractDgAutocomplete, selector: "ng-component", inputs: { multiple: "multiple", showSelectedList: "showSelectedList", label: "label", key: "key", data: "data", typeFilter: "typeFilter", positionY: "positionY", positionX: "positionX", listInsideInput: "listInsideInput", typeCheckInputOption: "typeCheckInputOption", classes: "classes" }, outputs: { close: "close", searchFilterValue: "searchFilterValue", change: "change" }, queries: [{ propertyName: "template_item", first: true, predicate: ["list_option"], descendants: true }, { propertyName: "inputAutocomplete", first: true, predicate: ["inputAutocomplete"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AbstractDgAutocomplete, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    }, propDecorators: { multiple: [{
                type: Input
            }], showSelectedList: [{
                type: Input
            }], label: [{
                type: Input
            }], key: [{
                type: Input
            }], data: [{
                type: Input
            }], typeFilter: [{
                type: Input
            }], positionY: [{
                type: Input
            }], positionX: [{
                type: Input
            }], listInsideInput: [{
                type: Input
            }], typeCheckInputOption: [{
                type: Input
            }], classes: [{
                type: Input
            }], close: [{
                type: Output,
                args: ['close']
            }], searchFilterValue: [{
                type: Output,
                args: ['searchFilterValue']
            }], change: [{
                type: Output,
                args: ['change']
            }], template_item: [{
                type: ContentChild,
                args: ['list_option', { static: false }]
            }], inputAutocomplete: [{
                type: ContentChild,
                args: ['inputAutocomplete', { static: false }]
            }] } });

class DgAutocomplete3Component extends AbstractDgAutocomplete {
    constructor(controlDir) {
        super(controlDir);
        this.controlDir = controlDir;
    }
}
DgAutocomplete3Component.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Component, deps: [{ token: i1$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
DgAutocomplete3Component.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgAutocomplete3Component, selector: "dg-autocomplete3", usesInheritance: true, ngImport: i0, template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<input\r\n  *ngIf=\"!inputAutocomplete\"\r\n  type=\"text\"\r\n  class=\"autocomplete3 input {{classes}}\"\r\n  [style.z-index]=\"opened ? 3001 : null\"\r\n  [id]=\"inputId\"\r\n  [formControl]=\"searchFilter\"\r\n  [class.ng-touched]=\"_ngControl?.touched\"\r\n  [class.ng-invalid]=\"_ngControl?.invalid\"\r\n  [class.ng-valid]=\"!_ngControl?.invalid\"\r\n  (click)=\"controls.open()\"\r\n>\r\n<div class=\"autocomplete3 root-popper\" [id]=\"inputId+'-root-popper'\">\r\n  <div class=\"card-popper\">\r\n    <div class=\"card-popper-body\" [id]=\"inputId+'-list'\">\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS SELECIONADOS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list selected-list\" *ngIf=\"_controls.verify.showSelectedList()\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Itens selecionados</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\" *ngIf=\"selectedList.length > 0\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n            <li\r\n              *ngFor=\"let item of selectedList; let i = index\"\r\n              (click)=\"$event.stopPropagation(); _controls.events.unSelectOption(i)\"\r\n              class=\"list-option selected\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!--\r\n                 CONTENT DA LISTA\r\n              -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item_selected(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <hr>\r\n      </div>\r\n\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Selecionar</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS DA LISTA -->\r\n            <li *ngIf=\"controls.getListFiltered().length == 0\" class=\"list-option\">\r\n              Nenhum registro encontrado\r\n            </li>\r\n            <li\r\n              *ngFor=\"let item of controls.getListFiltered() let i = index\"\r\n              class=\"list-option\"\r\n              [class.selected]=\"_controls.verify.selectedItem(i)\"\r\n              (click)=\"_controls.events.selectOption(item, i)\"\r\n              [hidden]=\"_controls.verify.ocultarItemSelecionado() && _controls.verify.selectedItem(i)\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input\r\n                  [type]=\"typeCheckInputOption\"\r\n                  *ngIf=\"(!!multiple || !!showCheckInputOption)\"\r\n                  [checked]=\"_controls.verify.selectedItem(i)\"\r\n                >\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Component, decorators: [{
            type: Component,
            args: [{ selector: 'dg-autocomplete3', template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<input\r\n  *ngIf=\"!inputAutocomplete\"\r\n  type=\"text\"\r\n  class=\"autocomplete3 input {{classes}}\"\r\n  [style.z-index]=\"opened ? 3001 : null\"\r\n  [id]=\"inputId\"\r\n  [formControl]=\"searchFilter\"\r\n  [class.ng-touched]=\"_ngControl?.touched\"\r\n  [class.ng-invalid]=\"_ngControl?.invalid\"\r\n  [class.ng-valid]=\"!_ngControl?.invalid\"\r\n  (click)=\"controls.open()\"\r\n>\r\n<div class=\"autocomplete3 root-popper\" [id]=\"inputId+'-root-popper'\">\r\n  <div class=\"card-popper\">\r\n    <div class=\"card-popper-body\" [id]=\"inputId+'-list'\">\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS SELECIONADOS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list selected-list\" *ngIf=\"_controls.verify.showSelectedList()\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Itens selecionados</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\" *ngIf=\"selectedList.length > 0\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n            <li\r\n              *ngFor=\"let item of selectedList; let i = index\"\r\n              (click)=\"$event.stopPropagation(); _controls.events.unSelectOption(i)\"\r\n              class=\"list-option selected\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!--\r\n                 CONTENT DA LISTA\r\n              -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item_selected(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <hr>\r\n      </div>\r\n\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Selecionar</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS DA LISTA -->\r\n            <li *ngIf=\"controls.getListFiltered().length == 0\" class=\"list-option\">\r\n              Nenhum registro encontrado\r\n            </li>\r\n            <li\r\n              *ngFor=\"let item of controls.getListFiltered() let i = index\"\r\n              class=\"list-option\"\r\n              [class.selected]=\"_controls.verify.selectedItem(i)\"\r\n              (click)=\"_controls.events.selectOption(item, i)\"\r\n              [hidden]=\"_controls.verify.ocultarItemSelecionado() && _controls.verify.selectedItem(i)\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input\r\n                  [type]=\"typeCheckInputOption\"\r\n                  *ngIf=\"(!!multiple || !!showCheckInputOption)\"\r\n                  [checked]=\"_controls.verify.selectedItem(i)\"\r\n                >\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    } });

/**
 * DynamicGroupDirective
 * Diretiva de acesso à classe de controle dynamicGroupClass.
 * Essa diretiva vai buscar estabelecer uma conexão disparando um evento de
 * reconhecimento, e aguardará um segundo evento de resposta contenda os dados
 * de conexão com a instância correta.
 * Caso essa conexão falhe e a diretiva não encontre a instância para se conectar
 * ela aguardará que a dynamicGroupClass lance um evento de reconhecimento ao ser iniciada.
 * Isso garante que independente da ordem de montagem ambos possam buscar a conexão.
 */
class DynamicGroupDirective {
    constructor(cdRef, ngControl, autocomplete, autocomplete3) {
        this.cdRef = cdRef;
        this.ngControl = ngControl;
        this.autocomplete = autocomplete;
        this.autocomplete3 = autocomplete3;
        // nome do parametro no grupo
        this.paramName = '';
        // tipo de comunicação
        this.typeComunication = 'ngModelChange';
        // não connectar
        this.dynamicNonConnect = false;
        /**##############################################
         * ## OUTPUTS
         ##############################################*/
        // evento para comunicar mudança em valores de terceiros
        this.changeParams = new EventEmitter();
        // evento para comunicar início da classe de controle
        this.startParams = new EventEmitter();
        // evento para disparar limpeza dos campos
        this.clearParams = new EventEmitter();
        // Ultimo valor salvo no formControl.
        // Isso é feito para podermos evitar que filtros sejam executados fora de hora
        // apenas pela execução dos eventos.
        // Esse valor é comparado ao próximo valor, para determinar se deve ou não disparar o evento
        this.lastValue = undefined;
    }
    ngOnInit() {
        this.findClass();
    }
    /**##############################################
     * ## COMUNICAÇÃO DOM DYNAMICGROUP
     ##############################################*/
    /**
     * Metodo que busca a classe para realizar a conexão,
     * ele dispara um reconhecimento e espera que a DynamicGroup responda
     * com os dados de conexão com a instância.
     */
    findClass() {
        if (!!this.dynamicGroup || !this.group || this.dynamicNonConnect)
            return;
        DynamicGroupClass.findInstance(this.group);
    }
    /**
     * Metodo para receber o chamado da DynamicGroup com os dados de conexão da instância.
     * Esse metodo também ajusta os valores dos inputes para os informados na DynamicGroup (caso existam)
     * @param ev
     */
    receiveInstance(ev) {
        var _a, _b, _c, _d, _e;
        if (!!this.dynamicGroup || this.dynamicNonConnect || ev.detail.group != this.group)
            return;
        this.dynamicGroup = ev.detail;
        // ajustando valor do input
        if (!!((_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control)) {
            if (this.ngControl.control.value != this.dynamicGroup.values[this.paramName]) {
                let value = this.dynamicGroup.values[this.paramName];
                this.lastValue = value;
                setTimeout(() => { var _a; return (_a = this.ngControl.control) === null || _a === void 0 ? void 0 : _a.patchValue(value); }, 50);
            }
        }
        else if (this.ngControl instanceof FormControlDirective || !!((_b = this.ngControl) === null || _b === void 0 ? void 0 : _b.valueAccessor)) {
            if ((_c = this.ngControl) === null || _c === void 0 ? void 0 : _c.valueAccessor) {
                if (this.ngControl.value != this.dynamicGroup.values[this.paramName]) {
                    let value = this.dynamicGroup.values[this.paramName];
                    this.lastValue = value;
                    setTimeout(() => { var _a; return (_a = this.ngControl.valueAccessor) === null || _a === void 0 ? void 0 : _a.writeValue(value); }, 50);
                }
            }
        }
        (_d = this.dynamicGroup.observables) === null || _d === void 0 ? void 0 : _d.change.subscribe(resp => {
            this.changeParams.emit(resp);
        });
        let selectedList = this.dynamicGroup.controls.optionalData.get(this.paramName + '-selectedList');
        if (!!this.autocomplete3 && !!selectedList) {
            this.autocomplete3.selectedList = selectedList || [];
        }
        (_e = this.dynamicGroup.observables) === null || _e === void 0 ? void 0 : _e.clearFilter.subscribe(resp => {
            var _a, _b;
            let valueClear = '';
            this.lastValue = undefined;
            if (this.paramName in (resp.allRawValues || {})) {
                valueClear = resp.allRawValues[this.paramName];
            }
            if ((_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control) {
                if (!valueClear) {
                    if (Array.isArray((_b = this.ngControl) === null || _b === void 0 ? void 0 : _b.control.value)) {
                        valueClear = [];
                    }
                    else {
                        valueClear = '';
                    }
                }
                this.ngControl.control.patchValue(valueClear);
            }
            console.log('valueClear', valueClear);
            this.clearParams.emit(valueClear);
        });
    }
    /**
     * Verifica se o valor atual é igual ao último valor. caso não seja, ele irá atualizar
     * o ultimo valor para o valor passado.
     * @param newValue
     */
    verifyLastValue(newValue) {
        if (String(newValue) == String(this.lastValue))
            return false;
        this.lastValue = newValue;
        return true;
    }
    /**##############################################
     * ## OBSERVANDO O INPUT
     ##############################################*/
    ngModalChange(ev) {
        if (!this.dynamicGroup || this.typeComunication != 'ngModelChange' || this.dynamicNonConnect)
            return;
        if (!this.verifyLastValue(this.ngControl.value))
            return;
        this.dynamicGroup.controls.values.patchValue({ [this.paramName]: ev });
    }
    change(ev) {
        if (!this.dynamicGroup || this.typeComunication != 'change' || this.dynamicNonConnect)
            return;
        if (!this.verifyLastValue(this.ngControl.value))
            return;
        this.dynamicGroup.controls.values.patchValue({ [this.paramName]: this.ngControl.value });
    }
    focusout(ev) {
        if (!this.dynamicGroup || (!!this.autocomplete || !!this.autocomplete3) || this.typeComunication != 'focusout' || this.dynamicNonConnect)
            return;
        if (!this.verifyLastValue(this.ngControl.value))
            return;
        this.dynamicGroup.controls.values.patchValue({ [this.paramName]: this.ngControl.value });
    }
    /**
     * Esse metodo é um coringa criado para servir ao "dgAutocomplete", ele tem o mesmo efeito do "focusout" porem
     * sua criação foi necessária, pois o "focusout" não comportou direito os eventos do "dgAutocomplete"
     * @param ev
     */
    close(ev) {
        if (!this.dynamicGroup || (!this.autocomplete && !this.autocomplete3) || this.typeComunication != 'focusout' || this.dynamicNonConnect)
            return;
        if (!this.verifyLastValue(this.ngControl.value))
            return;
        if (!!this.autocomplete3) {
            this.dynamicGroup.controls.optionalData.set(this.paramName + '-selectedList', this.autocomplete3.selectedList);
            // this.dynamicGroup.controls.filters.update(this.paramName, { opitionalData: { selectedList: this.autocomplete3.selectedList } })
        }
        this.dynamicGroup.controls.values.patchValue({ [this.paramName]: this.ngControl.value });
    }
}
DynamicGroupDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicGroupDirective, deps: [{ token: i0.ChangeDetectorRef }, { token: i1$1.NgControl, optional: true, self: true }, { token: DgAutocompleteComponent, optional: true }, { token: DgAutocomplete3Component, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
DynamicGroupDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DynamicGroupDirective, selector: "[dg-dynamic-group]", inputs: { group: ["dg-dynamic-group", "group"], paramName: "paramName", typeComunication: "typeComunication", dynamicNonConnect: "dynamicNonConnect" }, outputs: { changeParams: "changeParams", startParams: "startParams", clearParams: "clearParams" }, host: { listeners: { "window:dp-directive-receive-instance": "receiveInstance($event)", "ngModelChange": "ngModalChange($event)", "change": "change($event)", "focusout": "focusout($event)", "close": "close($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicGroupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dg-dynamic-group]'
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ChangeDetectorRef }, { type: i1$1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }, { type: DgAutocompleteComponent, decorators: [{
                        type: Optional
                    }] }, { type: DgAutocomplete3Component, decorators: [{
                        type: Optional
                    }] }];
    }, propDecorators: { group: [{
                type: Input,
                args: ['dg-dynamic-group']
            }], paramName: [{
                type: Input
            }], typeComunication: [{
                type: Input
            }], dynamicNonConnect: [{
                type: Input
            }], changeParams: [{
                type: Output,
                args: ['changeParams']
            }], startParams: [{
                type: Output,
                args: ['startParams']
            }], clearParams: [{
                type: Output,
                args: ['clearParams']
            }], receiveInstance: [{
                type: HostListener,
                args: ['window:dp-directive-receive-instance', ['$event']]
            }], ngModalChange: [{
                type: HostListener,
                args: ['ngModelChange', ['$event']]
            }], change: [{
                type: HostListener,
                args: ['change', ['$event']]
            }], focusout: [{
                type: HostListener,
                args: ['focusout', ['$event']]
            }], close: [{
                type: HostListener,
                args: ['close', ['$event']]
            }] } });

class DynamicGroupControlsDirective {
    constructor() {
        this.group = '';
        this.action = '';
    }
    click() {
        if (!this.group)
            return;
        if (this.filter === '' || !!this.filter) {
            DynamicGroupClass.dispacherFilter(this.group);
            return;
        }
        if (this.clear === '' || !!this.clear) {
            DynamicGroupClass.dispacherClear(this.group);
            return;
        }
    }
}
DynamicGroupControlsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicGroupControlsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DynamicGroupControlsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DynamicGroupControlsDirective, selector: "[dynamic-group-control]", inputs: { group: ["dynamic-group-control", "group"], action: "action", filter: "filter", clear: "clear" }, host: { listeners: { "click": "click()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DynamicGroupControlsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dynamic-group-control]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { group: [{
                type: Input,
                args: ['dynamic-group-control']
            }], action: [{
                type: Input
            }], filter: [{
                type: Input
            }], clear: [{
                type: Input
            }], click: [{
                type: HostListener,
                args: ['click']
            }] } });

class CdkDynamicGroupModule {
}
CdkDynamicGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CdkDynamicGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupModule, declarations: [DynamicGroupDirective,
        DynamicGroupControlsDirective], exports: [DynamicGroupDirective,
        DynamicGroupControlsDirective] });
CdkDynamicGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DynamicGroupDirective,
                        DynamicGroupControlsDirective
                    ],
                    imports: [],
                    exports: [
                        DynamicGroupDirective,
                        DynamicGroupControlsDirective
                    ]
                }]
        }] });

class CdkDynamicGroupService {
    constructor() {
    }
    createGroup(group, config) {
        return CdkDynamicGroup.newClass(group, config);
    }
    findGroup(group) {
        const observ = new ReplaySubject(undefined);
        const keyPort = String(Date.now()) + uniqIdHtml();
        let connect = false;
        let timeout = null;
        let countFind = 0;
        window.addEventListener('dynamic-group-class-find-service', (e) => {
            const ev = e.detail;
            if (ev.keyPort != keyPort)
                return;
            connect = true;
            clearTimeout(timeout);
            observ.next(ev.instance);
        });
        const funcTimout = (time = 250) => {
            timeout = setTimeout(() => {
                if (connect)
                    return;
                if (countFind > 8) {
                    clearTimeout(timeout);
                    console.error('Tempo excedido: ', 'A busca pelo grupo "' + group + '" excedeu o tempo de 2 segundos (8 chamadas). ' +
                        'O grupo provávelmente ainda não existe, declare o observable depois que o grupo ' +
                        'for instanciado');
                    return;
                }
                DynamicGroupClass.serviceFindInstance(group, keyPort);
                countFind = countFind + 1;
                if (!connect)
                    funcTimout();
            }, time);
        };
        funcTimout(0);
        return observ.asObservable();
    }
}
CdkDynamicGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CdkDynamicGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CdkDynamicGroupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

// REMOVER

class DisableByPeriodDirective {
    constructor(elRef, render) {
        this.elRef = elRef;
        this.render = render;
        this.time = 1500;
    }
    click() {
        this.render.setAttribute(this.elRef.nativeElement, 'disabled', 'true');
        if (this.time != 'no') {
            setTimeout(() => {
                this.render.removeAttribute(this.elRef.nativeElement, 'disabled');
            }, this.time);
        }
    }
    getEventEnableButton(ev) {
        if (!(ev === null || ev === void 0 ? void 0 : ev.detail) || !this.eventKey)
            return;
        if (ev.detail != this.eventKey)
            return;
        this.render.removeAttribute(this.elRef.nativeElement, 'disabled');
    }
    getEventDisableButton(ev) {
        if (!(ev === null || ev === void 0 ? void 0 : ev.detail) || !this.eventKey)
            return;
        if (ev.detail != this.eventKey)
            return;
        this.render.setAttribute(this.elRef.nativeElement, 'disabled', 'true');
    }
}
DisableByPeriodDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
DisableByPeriodDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: DisableByPeriodDirective, selector: "*[dg-disable-by-period]", inputs: { time: "time", eventKey: "eventKey" }, host: { listeners: { "click": "click()", "window:dg-desable-by-period-enable": "getEventEnableButton($event)", "window:dg-desable-by-period": "getEventDisableButton($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '*[dg-disable-by-period]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { time: [{
                type: Input
            }], eventKey: [{
                type: Input
            }], click: [{
                type: HostListener,
                args: ['click']
            }], getEventEnableButton: [{
                type: HostListener,
                args: ['window:dg-desable-by-period-enable', ['$event']]
            }], getEventDisableButton: [{
                type: HostListener,
                args: ['window:dg-desable-by-period', ['$event']]
            }] } });

class DisableByPeriodModule {
}
DisableByPeriodModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DisableByPeriodModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodModule, declarations: [DisableByPeriodDirective], imports: [CommonModule] });
DisableByPeriodModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodModule, imports: [[
            CommonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DisableByPeriodModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DisableByPeriodDirective
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

var CkdDgDisableByPeriod;
(function (CkdDgDisableByPeriod) {
    CkdDgDisableByPeriod.enable = (eventKey) => {
        window.dispatchEvent(new CustomEvent('dg-desable-by-period-enable', { detail: eventKey }));
    };
    CkdDgDisableByPeriod.disable = (eventKey) => {
        window.dispatchEvent(new CustomEvent('dg-desable-by-period', { detail: eventKey }));
    };
})(CkdDgDisableByPeriod || (CkdDgDisableByPeriod = {}));

// DgDisableByPeriod

class DgTableModule {
}
DgTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableModule, declarations: [DgTableComponent,
        DefaultTdActionsDgTableComponent,
        TdInnerHtmlDirective,
        DefaultTableLoadersComponent], imports: [CommonModule,
        RouterModule,
        DragDropModule], exports: [DgTableComponent,
        DefaultTdActionsDgTableComponent] });
DgTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableModule, imports: [[
            CommonModule,
            RouterModule,
            DragDropModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgTableComponent,
                        DefaultTdActionsDgTableComponent,
                        TdInnerHtmlDirective,
                        DefaultTableLoadersComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterModule,
                        DragDropModule
                    ],
                    exports: [
                        DgTableComponent,
                        DefaultTdActionsDgTableComponent
                    ]
                }]
        }] });

class DgPaginatorModule {
}
DgPaginatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgPaginatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorModule, declarations: [DgPaginatorComponent], imports: [CommonModule,
        FormsModule], exports: [DgPaginatorComponent] });
DgPaginatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorModule, imports: [[
            CommonModule,
            FormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgPaginatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgPaginatorComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    exports: [
                        DgPaginatorComponent
                    ]
                }]
        }] });

// PAGINATOR

/**
 * directive aplicado ao input de template do autocomplete
 */
class InputSearchAutocompleteDirective {
    // @Input('custom-list') customList: AutocompleteListStickyComponent | undefined
    constructor(element) {
        this.element = element;
        let referenceId = this.element.nativeElement.getAttribute('id');
        if (!referenceId) {
            referenceId = uniqIdHtml((val) => val);
            this.element.nativeElement.setAttribute('id', referenceId);
        }
    }
    focus(ev) {
        this.dadComponent.listControl.open(this.element.nativeElement.getAttribute('id'));
    }
    click(ev) {
        this.dadComponent.listControl.open(this.element.nativeElement.getAttribute('id'));
    }
}
InputSearchAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InputSearchAutocompleteDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
InputSearchAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: InputSearchAutocompleteDirective, selector: "[search-autocomplete]", inputs: { dadComponent: ["search-autocomplete", "dadComponent"] }, host: { listeners: { "focus": "focus($event)", "click": "click($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InputSearchAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[search-autocomplete]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { dadComponent: [{
                type: Input,
                args: ['search-autocomplete']
            }], focus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }], click: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/**
 * directive aplicado a lista
 */
class ListSearchAutocomplete2Directive {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
        this.dadComponent.customListComponent = this.element;
    }
    ngAfterViewInit() {
        this.dadComponent.customListComponent = this.element;
    }
    setValue(ev) {
        this.dadComponent.setValue(ev);
    }
    closeList(ev) {
        // this.dadComponent.setFakeValue(ev)
    }
    searchFilterValue(ev) {
        this.dadComponent.searchFilterValue.emit(ev);
    }
}
ListSearchAutocomplete2Directive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ListSearchAutocomplete2Directive, deps: [{ token: AutocompleteListStickyComponent }], target: i0.ɵɵFactoryTarget.Directive });
ListSearchAutocomplete2Directive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: ListSearchAutocomplete2Directive, selector: "[list-search-autocomplete]", inputs: { dadComponent: ["list-search-autocomplete", "dadComponent"] }, host: { listeners: { "setValue": "setValue($event)", "closeList": "closeList($event)", "searchFilterValue": "searchFilterValue($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ListSearchAutocomplete2Directive, decorators: [{
            type: Directive,
            args: [{
                    selector: '[list-search-autocomplete]',
                }]
        }], ctorParameters: function () { return [{ type: AutocompleteListStickyComponent }]; }, propDecorators: { dadComponent: [{
                type: Input,
                args: ['list-search-autocomplete']
            }], setValue: [{
                type: HostListener,
                args: ['setValue', ['$event']]
            }], closeList: [{
                type: HostListener,
                args: ['closeList', ['$event']]
            }], searchFilterValue: [{
                type: HostListener,
                args: ['searchFilterValue', ['$event']]
            }] } });

class ConfigDgAutocomplete2 {
    static get(configName) {
        if (!configName)
            return this.configs;
        if (configName in this.configs) {
            return this.configs[configName];
        }
        return {};
    }
    static set(props) {
        this.configs = props;
    }
    static setOne(key, props) {
        if (key in this.configs) {
            this.configs[key] = Object.assign(Object.assign({}, this.configs[key]), props);
            return;
        }
        this.configs[key] = props;
    }
}
ConfigDgAutocomplete2.configs = {};

class PropertiesAutocomplete2Directive {
    constructor(host) {
        this.host = host;
    }
    ngAfterContentChecked() {
        if (!(this === null || this === void 0 ? void 0 : this.host))
            return;
        // insert boolean
        this.insertInputBooleanInHost('showSelectedOption');
        this.insertInputBooleanInHost('multiple');
        this.insertInputBooleanInHost('showSelectedList');
        this.insertInputBooleanInHost('showInputSearch');
        this.insertInputBooleanInHost('showCheckInputOption');
        this.insertInputBooleanInHost('itenSelfUnselect');
        this.insertInputBooleanInHost('clearSearchOnClose');
        this.insertInputBooleanInHost('clearSearchOnOpen');
        this.insertInputBooleanInHost('freeHand');
        // insert string
        this.insertInputStringInHost('typeFilter', undefined);
    }
    ngOnInit() {
    }
    /**
     * Metodo que permite simplificar escrita de inputs booleanos, capturando entradas de string
     * tanto para valores convertidos quanto sua escrita simplificada, exemplo abaixo
     * [multiple]="true"
     *    => multiple
     *    => multiple="true"
     *    => [multiple]="true"
     * @param value
     */
    verifyValue(value) {
        if (typeof value == 'boolean')
            return value;
        if (typeof value == 'string') {
            if (value == '')
                return true;
            return value == 'true';
        }
        return false;
    }
    /**
     * Metodo de insert de booleanos no host
     * @param attr
     */
    insertInputBooleanInHost(attr) {
        if (typeof this[attr] != "undefined") {
            this.host[attr] = this.verifyValue(this[attr]);
            return;
        }
        if (this.config) {
            if (attr in this.config) {
                this.host[attr] = this.verifyValue(this.config[attr]);
                return;
            }
        }
        if (this.configName) {
            const rootConfig = ConfigDgAutocomplete2.get(this.configName);
            if (attr in rootConfig) {
                this.host[attr] = this.verifyValue(rootConfig[attr]);
                return;
            }
        }
    }
    /**
     * Metodos de insert de strings no host
     * @param attr
     * @param defaultValue
     */
    insertInputStringInHost(attr, defaultValue) {
        if (!this.host)
            return;
        if (typeof this[attr] !== 'undefined') {
            this.host[attr] = this[attr];
            return;
        }
        if (this.config) {
            if (attr in this.config) {
                if (typeof this.config[attr] !== 'undefined') {
                    this.host[attr] = this.config[attr];
                    return;
                }
            }
        }
        if (this.configName) {
            const rootConfig = ConfigDgAutocomplete2.get(this.configName);
            if (attr in rootConfig) {
                if (typeof rootConfig[attr] !== 'undefined') {
                    this.host[attr] = rootConfig[attr];
                    return;
                }
            }
        }
        this.host[attr] = defaultValue;
    }
}
PropertiesAutocomplete2Directive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertiesAutocomplete2Directive, deps: [{ token: DgAutocompleteComponent }], target: i0.ɵɵFactoryTarget.Directive });
PropertiesAutocomplete2Directive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: PropertiesAutocomplete2Directive, selector: "dg-autocomplete", inputs: { showSelectedOption: "showSelectedOption", multiple: "multiple", showSelectedList: "showSelectedList", showInputSearch: "showInputSearch", showCheckInputOption: "showCheckInputOption", itenSelfUnselect: "itenSelfUnselect", clearSearchOnClose: "clearSearchOnClose", clearSearchOnOpen: "clearSearchOnOpen", freeHand: "freeHand", typeFilter: "typeFilter", config: "config", configName: "configName" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertiesAutocomplete2Directive, decorators: [{
            type: Directive,
            args: [{
                    selector: 'dg-autocomplete',
                }]
        }], ctorParameters: function () { return [{ type: DgAutocompleteComponent }]; }, propDecorators: { showSelectedOption: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showSelectedList: [{
                type: Input
            }], showInputSearch: [{
                type: Input
            }], showCheckInputOption: [{
                type: Input
            }], itenSelfUnselect: [{
                type: Input
            }], clearSearchOnClose: [{
                type: Input
            }], clearSearchOnOpen: [{
                type: Input
            }], freeHand: [{
                type: Input
            }], typeFilter: [{
                type: Input
            }], config: [{
                type: Input
            }], configName: [{
                type: Input
            }] } });

class DgAutocomplete2Module {
}
DgAutocomplete2Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete2Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgAutocomplete2Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete2Module, declarations: [DgAutocompleteComponent,
        InputSearchAutocompleteDirective,
        AutocompleteListStickyComponent,
        ListSearchAutocomplete2Directive,
        PropertiesAutocomplete2Directive], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule], exports: [DgAutocompleteComponent,
        InputSearchAutocompleteDirective,
        AutocompleteListStickyComponent,
        ListSearchAutocomplete2Directive,
        PropertiesAutocomplete2Directive] });
DgAutocomplete2Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete2Module, imports: [[
            CommonModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete2Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgAutocompleteComponent,
                        InputSearchAutocompleteDirective,
                        AutocompleteListStickyComponent,
                        ListSearchAutocomplete2Directive,
                        PropertiesAutocomplete2Directive
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule
                    ],
                    exports: [
                        DgAutocompleteComponent,
                        InputSearchAutocompleteDirective,
                        AutocompleteListStickyComponent,
                        ListSearchAutocomplete2Directive,
                        PropertiesAutocomplete2Directive
                    ]
                }]
        }] });

class DgAutocomplete3DropdownComponent extends AbstractDgAutocomplete {
    constructor(controlDir) {
        super(controlDir);
        this.controlDir = controlDir;
        this.listInsideInput = true;
    }
}
DgAutocomplete3DropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3DropdownComponent, deps: [{ token: i1$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Component });
DgAutocomplete3DropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: DgAutocomplete3DropdownComponent, selector: "dg-autocomplete3-dropdown", usesInheritance: true, ngImport: i0, template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<!--<input-->\r\n<!--  *ngIf=\"!inputAutocomplete\"-->\r\n<!--  type=\"text\"-->\r\n<!--  class=\"autocomplete3 input {{classes}}\"-->\r\n<!--  [style.z-index]=\"opened ? 3001 : null\"-->\r\n<!--  [id]=\"inputId\"-->\r\n<!--  [formControl]=\"searchFilter\"-->\r\n<!--  [class.ng-touched]=\"_ngControl?.touched\"-->\r\n<!--  [class.ng-invalid]=\"_ngControl?.invalid\"-->\r\n<!--  [class.ng-valid]=\"!_ngControl?.invalid\"-->\r\n<!--  (click)=\"controls.open()\"-->\r\n<!--&gt;-->\r\n\r\n<span (click)=\"controls.open()\" [id]=\"inputId\">Abrir - {{this.listInsideInput | json}}</span>\r\n\r\n<div class=\"autocomplete3 root-popper\" [id]=\"inputId+'-root-popper'\">\r\n  <div class=\"card-popper\">\r\n    <div class=\"card-popper-body\" [id]=\"inputId+'-list'\">\r\n      <!--\r\n        #################################################################\r\n        ##### INPUT DE FILTRO\r\n        #################################################################\r\n        -->\r\n      <div class=\"cdk-content-section-list\">\r\n        <input\r\n          [id]=\"inputId+'-inside-input'\"\r\n          class=\"form-control\"\r\n          placeholder=\"Pesquisar...\"\r\n          [formControl]=\"searchFilter\"\r\n        >\r\n      </div>\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS SELECIONADOS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list selected-list\" *ngIf=\"_controls.verify.showSelectedList()\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Itens selecionados</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\" *ngIf=\"selectedList.length > 0\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n            <li\r\n              *ngFor=\"let item of selectedList; let i = index\"\r\n              (click)=\"$event.stopPropagation(); _controls.events.unSelectOption(i)\"\r\n              class=\"list-option selected\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!--\r\n                 CONTENT DA LISTA\r\n              -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item_selected(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <hr>\r\n      </div>\r\n\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Selecionar</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS DA LISTA -->\r\n            <li *ngIf=\"controls.getListFiltered().length == 0\" class=\"list-option\">\r\n              Nenhum registro encontrado\r\n            </li>\r\n            <li\r\n              *ngFor=\"let item of controls.getListFiltered() let i = index\"\r\n              class=\"list-option\"\r\n              [class.selected]=\"_controls.verify.selectedItem(i)\"\r\n              (click)=\"_controls.events.selectOption(item, i)\"\r\n              [hidden]=\"_controls.verify.ocultarItemSelecionado() && _controls.verify.selectedItem(i)\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input\r\n                  [type]=\"typeCheckInputOption\"\r\n                  *ngIf=\"(!!multiple || !!showCheckInputOption)\"\r\n                  [checked]=\"_controls.verify.selectedItem(i)\"\r\n                >\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }, { type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i1$1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { type: i2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "json": i2.JsonPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3DropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dg-autocomplete3-dropdown', template: "<!--INPUT PASSADO PELO CLIENTE-->\r\n<ng-container *ngIf=\"inputAutocomplete\" [ngTemplateOutlet]=\"inputAutocomplete\"></ng-container>\r\n<!--INPUT DINAMICO CASO NENHUM SEJA PASSADO-->\r\n<!--<input-->\r\n<!--  *ngIf=\"!inputAutocomplete\"-->\r\n<!--  type=\"text\"-->\r\n<!--  class=\"autocomplete3 input {{classes}}\"-->\r\n<!--  [style.z-index]=\"opened ? 3001 : null\"-->\r\n<!--  [id]=\"inputId\"-->\r\n<!--  [formControl]=\"searchFilter\"-->\r\n<!--  [class.ng-touched]=\"_ngControl?.touched\"-->\r\n<!--  [class.ng-invalid]=\"_ngControl?.invalid\"-->\r\n<!--  [class.ng-valid]=\"!_ngControl?.invalid\"-->\r\n<!--  (click)=\"controls.open()\"-->\r\n<!--&gt;-->\r\n\r\n<span (click)=\"controls.open()\" [id]=\"inputId\">Abrir - {{this.listInsideInput | json}}</span>\r\n\r\n<div class=\"autocomplete3 root-popper\" [id]=\"inputId+'-root-popper'\">\r\n  <div class=\"card-popper\">\r\n    <div class=\"card-popper-body\" [id]=\"inputId+'-list'\">\r\n      <!--\r\n        #################################################################\r\n        ##### INPUT DE FILTRO\r\n        #################################################################\r\n        -->\r\n      <div class=\"cdk-content-section-list\">\r\n        <input\r\n          [id]=\"inputId+'-inside-input'\"\r\n          class=\"form-control\"\r\n          placeholder=\"Pesquisar...\"\r\n          [formControl]=\"searchFilter\"\r\n        >\r\n      </div>\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS SELECIONADOS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list selected-list\" *ngIf=\"_controls.verify.showSelectedList()\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Itens selecionados</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\" *ngIf=\"selectedList.length > 0\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS SELECIONADOS DA LISTA -->\r\n            <li\r\n              *ngFor=\"let item of selectedList; let i = index\"\r\n              (click)=\"$event.stopPropagation(); _controls.events.unSelectOption(i)\"\r\n              class=\"list-option selected\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input type=\"checkbox\" *ngIf=\"!!multiple\" checked>\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!--\r\n                 CONTENT DA LISTA\r\n              -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item_selected(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <hr>\r\n      </div>\r\n\r\n\r\n      <!--\r\n      #################################################################\r\n      ##### LISTA DE ITENS DISPON\u00CDVEIS\r\n      #################################################################\r\n      -->\r\n      <div class=\"root-list\">\r\n        <div class=\"header-list\">\r\n          <span class=\"title-list\">Selecionar</span>\r\n        </div>\r\n\r\n        <div class=\"content-list\">\r\n          <ul class=\"list\">\r\n            <!-- #### ITENS DA LISTA -->\r\n            <li *ngIf=\"controls.getListFiltered().length == 0\" class=\"list-option\">\r\n              Nenhum registro encontrado\r\n            </li>\r\n            <li\r\n              *ngFor=\"let item of controls.getListFiltered() let i = index\"\r\n              class=\"list-option\"\r\n              [class.selected]=\"_controls.verify.selectedItem(i)\"\r\n              (click)=\"_controls.events.selectOption(item, i)\"\r\n              [hidden]=\"_controls.verify.ocultarItemSelecionado() && _controls.verify.selectedItem(i)\"\r\n            >\r\n              <!-- #### ITEM PADR\u00C3O DA LISTA -->\r\n              <div *ngIf=\"!template_item\">\r\n                <input\r\n                  [type]=\"typeCheckInputOption\"\r\n                  *ngIf=\"(!!multiple || !!showCheckInputOption)\"\r\n                  [checked]=\"_controls.verify.selectedItem(i)\"\r\n                >\r\n                {{_controls.item.getLabel(item)}}\r\n              </div>\r\n              <!-- #### ITEM CUSTOMIZADO FORNECIDO PELO CLIENTE -->\r\n              <ng-container\r\n                *ngIf=\"template_item\"\r\n                [ngTemplateOutlet]=\"template_item\"\r\n                [ngTemplateOutletContext]=\"{$implicit:_controls.dataTemplate.template_item(item, i)}\"\r\n              >\r\n              </ng-container>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [""] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.NgControl, decorators: [{
                        type: Optional
                    }, {
                        type: Self
                    }] }];
    } });

class DgAutocomplete3Module {
}
DgAutocomplete3Module.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Module, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DgAutocomplete3Module.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Module, declarations: [DgAutocomplete3Component,
        DgAutocomplete3DropdownComponent
        // PropertiesAutocomplete3Directive,
    ], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule], exports: [DgAutocomplete3Component,
        DgAutocomplete3DropdownComponent
        // PropertiesAutocomplete3Directive,
    ] });
DgAutocomplete3Module.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Module, imports: [[
            CommonModule,
            ReactiveFormsModule,
            FormsModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DgAutocomplete3Module, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DgAutocomplete3Component,
                        DgAutocomplete3DropdownComponent
                        // PropertiesAutocomplete3Directive,
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule
                    ],
                    exports: [
                        DgAutocomplete3Component,
                        DgAutocomplete3DropdownComponent
                        // PropertiesAutocomplete3Directive,
                    ]
                }]
        }] });

class ConfigDgAutocomplete3 {
    static get(configName) {
        if (!configName)
            return this.configs;
        if (configName in this.configs) {
            return this.configs[configName];
        }
        return {};
    }
    static set(props) {
        this.configs = props;
    }
    static setOne(key, props) {
        if (key in this.configs) {
            this.configs[key] = Object.assign(Object.assign({}, this.configs[key]), props);
            return;
        }
        this.configs[key] = props;
    }
}
ConfigDgAutocomplete3.configs = {};

class PropertiesAutocomplete3Directive {
    constructor(host) {
        this.host = host;
    }
    ngAfterContentChecked() {
        if (!(this === null || this === void 0 ? void 0 : this.host))
            return;
        // insert boolean
        this.insertInputBooleanInHost('showSelectedOption');
        this.insertInputBooleanInHost('multiple');
        this.insertInputBooleanInHost('showSelectedList');
        this.insertInputBooleanInHost('showInputSearch');
        this.insertInputBooleanInHost('showCheckInputOption');
        this.insertInputBooleanInHost('itenSelfUnselect');
        this.insertInputBooleanInHost('clearSearchOnClose');
        this.insertInputBooleanInHost('clearSearchOnOpen');
        this.insertInputBooleanInHost('freeHand');
        // insert string
        this.insertInputStringInHost('typeFilter', undefined);
    }
    ngOnInit() {
    }
    /**
     * Metodo que permite simplificar escrita de inputs booleanos, capturando entradas de string
     * tanto para valores convertidos quanto sua escrita simplificada, exemplo abaixo
     * [multiple]="true"
     *    => multiple
     *    => multiple="true"
     *    => [multiple]="true"
     * @param value
     */
    verifyValue(value) {
        if (typeof value == 'boolean')
            return value;
        if (typeof value == 'string') {
            if (value == '')
                return true;
            return value == 'true';
        }
        return false;
    }
    /**
     * Metodo de insert de booleanos no host
     * @param attr
     */
    insertInputBooleanInHost(attr) {
        if (typeof this[attr] != "undefined") {
            this.host[attr] = this.verifyValue(this[attr]);
            return;
        }
        if (this.config) {
            if (attr in this.config) {
                this.host[attr] = this.verifyValue(this.config[attr]);
                return;
            }
        }
        if (this.configName) {
            const rootConfig = ConfigDgAutocomplete3.get(this.configName);
            if (attr in rootConfig) {
                this.host[attr] = this.verifyValue(rootConfig[attr]);
                return;
            }
        }
    }
    /**
     * Metodos de insert de strings no host
     * @param attr
     * @param defaultValue
     */
    insertInputStringInHost(attr, defaultValue) {
        if (!this.host)
            return;
        if (typeof this[attr] !== 'undefined') {
            this.host[attr] = this[attr];
            return;
        }
        if (this.config) {
            if (attr in this.config) {
                if (typeof this.config[attr] !== 'undefined') {
                    this.host[attr] = this.config[attr];
                    return;
                }
            }
        }
        if (this.configName) {
            const rootConfig = ConfigDgAutocomplete3.get(this.configName);
            if (attr in rootConfig) {
                if (typeof rootConfig[attr] !== 'undefined') {
                    this.host[attr] = rootConfig[attr];
                    return;
                }
            }
        }
        this.host[attr] = defaultValue;
    }
}
PropertiesAutocomplete3Directive.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertiesAutocomplete3Directive, deps: [{ token: DgAutocomplete3Component }], target: i0.ɵɵFactoryTarget.Directive });
PropertiesAutocomplete3Directive.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.2.7", type: PropertiesAutocomplete3Directive, selector: "dg-autocomplete3", inputs: { showSelectedOption: "showSelectedOption", multiple: "multiple", showSelectedList: "showSelectedList", showInputSearch: "showInputSearch", showCheckInputOption: "showCheckInputOption", itenSelfUnselect: "itenSelfUnselect", clearSearchOnClose: "clearSearchOnClose", clearSearchOnOpen: "clearSearchOnOpen", freeHand: "freeHand", typeFilter: "typeFilter", config: "config", configName: "configName" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertiesAutocomplete3Directive, decorators: [{
            type: Directive,
            args: [{
                    selector: 'dg-autocomplete3',
                }]
        }], ctorParameters: function () { return [{ type: DgAutocomplete3Component }]; }, propDecorators: { showSelectedOption: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showSelectedList: [{
                type: Input
            }], showInputSearch: [{
                type: Input
            }], showCheckInputOption: [{
                type: Input
            }], itenSelfUnselect: [{
                type: Input
            }], clearSearchOnClose: [{
                type: Input
            }], clearSearchOnOpen: [{
                type: Input
            }], freeHand: [{
                type: Input
            }], typeFilter: [{
                type: Input
            }], config: [{
                type: Input
            }], configName: [{
                type: Input
            }] } });

/*
 * Public API Surface of dg-ng-util
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractAddToken, AbstractDgAutocomplete, AbstractGenericService, AbstractSessionService, AbstractTokenService, AutocompleteListStickyComponent, CdkContentListAutocompleteDirective, CdkDgTable, CdkDynamicGroup, CdkDynamicGroupModule, CdkDynamicGroupService, CdkDynamicTable, CdkDynamicTableModule, CdkDynamicTableService, CkdDgDisableByPeriod, ConfigDgAutocomplete2, ConfigDgAutocomplete3, ConfigDgTable, ConfigDynamicTable, DefaultTdActionsDgTableComponent, DgAutocomplete2Module, DgAutocomplete3Component, DgAutocomplete3DropdownComponent, DgAutocomplete3Module, DgAutocompleteComponent, DgAutocompleteDirective, DgAutocompleteModule, DgDynamicTableDirective, DgModalComponent, DgModalModule, DgPaginatorComponent, DgPaginatorModule, DgSidebarMenuComponent, DgSidebarMenuLogoComponent, DgSidebarMenuModule, DgSidebarMenuNavigationItemComponent, DgTableActionsTemplateDirective, DgTableColumnTemplateDirective, DgTableComponent, DgTableHeaderTemplateDirective, DgTableMaterialDataDirective, DgTableMaterialPaginatorDirective, DgTableModule, DgTablePaginatorDirective, DisableByPeriodDirective, DisableByPeriodModule, DynamicColumn, DynamicGroupClass, DynamicGroupControlsDirective, DynamicGroupDirective, DynamicQueryParams, DynamicTableEntity, InputAutocompleteComponent, InputSearchAutocompleteDirective, ListSearchAutocomplete2Directive, PropertiesAutocomplete2Directive, PropertiesAutocomplete3Directive, QueryParamsGroup, clearString, dynamicTableColumnKey, getFilteredProperties, uniqIdHtml };
